(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lx-aankondiging"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('lx-aankondiging-afteller')) return;

    class LxAankondigingAfteller extends HTMLElement {
      connectedCallback() {
        this.einde = parseInt(this.dataset.einde, 10) * 1000;
        if (!this.einde) return;
        this.velden = {
          d: this.querySelector('[data-deel="d"]'),
          u: this.querySelector('[data-deel="u"]'),
          m: this.querySelector('[data-deel="m"]'),
          s: this.querySelector('[data-deel="s"]'),
        };
        this.sectie = this.closest('.lx-aankondiging');
        this.opZicht = () => {
          if (document.hidden) return;
          clearTimeout(this.klok);
          if (this.tik()) this.plan();
        };
        document.addEventListener('visibilitychange', this.opZicht);
        if (this.tik()) this.plan();
      }

      disconnectedCallback() {
        clearTimeout(this.klok);
        if (this.opZicht) document.removeEventListener('visibilitychange', this.opZicht);
      }

      plan() {
        const wacht = 1000 - (Date.now() % 1000) + 10;
        this.klok = setTimeout(() => {
          if (this.tik()) this.plan();
        }, wacht);
      }

      zet(veld, waarde) {
        const el = this.velden[veld];
        if (!el) return;
        const tekst = String(waarde).padStart(2, '0');
        if (el.textContent === tekst) return;
        // Eén vak per cijfer (zie de CSS); bij een ander aantal cijfers de vakken opnieuw maken.
        if (el.children.length !== tekst.length) {
          el.replaceChildren(
            ...Array.from(tekst, () => {
              const vak = document.createElement('span');
              vak.className = 'lx-aankondiging__cijfer';
              return vak;
            })
          );
        }
        Array.from(tekst).forEach((teken, i) => {
          if (el.children[i].textContent !== teken) el.children[i].textContent = teken;
        });
      }

      tik() {
        const rest = Math.max(0, Math.floor((this.einde - Date.now()) / 1000));
        this.zet('d', Math.floor(rest / 86400));
        this.zet('u', Math.floor((rest % 86400) / 3600));
        this.zet('m', Math.floor((rest % 3600) / 60));
        this.zet('s', rest % 60);
        if (rest > 0) return true;
        this.afgelopen();
        return false;
      }

      afgelopen() {
        // In de editor blijft de balk staan, zodat hij te bewerken is; op de winkel verdwijnt hij.
        if (this.hasAttribute('data-editor')) return;
        if (this.sectie) this.sectie.hidden = true;
        document.dispatchEvent(new CustomEvent('lx:aankondiging:afgelopen'));
      }
    }

    customElements.define('lx-aankondiging-afteller', LxAankondigingAfteller);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lx-accessoires-rij"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('lx-accessoires-rij')) return;

    const rustig = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /*
      Eén element per sectie: de stippen volgen de rij, en «In winkelwagen» voegt toe zonder de pagina te
      verlaten (zoals lx-categorie-modellen en lx-koop).
    */
    class LxAccessoiresRij extends HTMLElement {
      connectedCallback() {
        if (this._klaar) return;
        this.rij = this.querySelector('[data-lx-rij]');
        if (!this.rij) return;
        this._klaar = true;
        // Zoals lx-categorie-modellen: zonder action telt Shopify's pixelbeheer de toevoeging maar één keer.
        this.querySelectorAll('form[data-lx-koop]').forEach((form) => form.removeAttribute('action'));
        this.kaarten = Array.from(this.rij.querySelectorAll('[data-lx-kaart]'));
        this.stippen = Array.from(this.querySelectorAll('[data-lx-stip]'));
        this.actief = -1;
        this.gepland = false;

        this.opScroll = () => {
          if (this.gepland) return;
          this.gepland = true;
          requestAnimationFrame(() => {
            this.gepland = false;
            this.werkStippenBij();
          });
        };
        this.opKlik = (event) => {
          const stip = event.target instanceof Element ? event.target.closest('[data-lx-stip]') : null;
          if (stip && this.contains(stip)) this.gaNaar(Number(stip.dataset.lxStip));
        };
        this.opFocus = (event) => {
          const doel = event.target instanceof Element ? event.target : null;
          if (!doel || !doel.matches(':focus-visible')) return;
          const kaart = doel.closest('[data-lx-kaart]');
          const index = kaart ? this.kaarten.indexOf(kaart) : -1;
          if (index > -1) this.gaNaar(index, true);
        };
        this.opVersturen = (event) => this.versturen(event);
        this.opTerug = (event) => {
          if (!event.persisted) return;
          this.querySelectorAll('form[data-lx-koop]').forEach((form) => this.zetBezig(form, false));
        };

        this.rij.addEventListener('scroll', this.opScroll, { passive: true });
        this.addEventListener('click', this.opKlik);
        this.addEventListener('focusin', this.opFocus);
        this.addEventListener('submit', this.opVersturen);
        window.addEventListener('pageshow', this.opTerug);
        this.werkStippenBij();
      }

      disconnectedCallback() {
        if (!this._klaar) return;
        this._klaar = false;
        this.rij.removeEventListener('scroll', this.opScroll);
        this.removeEventListener('click', this.opKlik);
        this.removeEventListener('focusin', this.opFocus);
        this.removeEventListener('submit', this.opVersturen);
        window.removeEventListener('pageshow', this.opTerug);
      }

      beginVan(kaart) {
        return kaart.offsetLeft - this.kaarten[0].offsetLeft;
      }

      gaNaar(index, direct) {
        const kaart = this.kaarten[index];
        if (!kaart) return;
        this.rij.scrollTo({ left: this.beginVan(kaart), behavior: direct || rustig() ? 'auto' : 'smooth' });
      }

      werkStippenBij() {
        if (!this.kaarten.length || !this.stippen.length) return;
        const links = this.rij.scrollLeft;
        const max = this.rij.scrollWidth - this.rij.clientWidth;
        let index = 0;
        if (max > 0 && links >= max - 2) {
          index = this.kaarten.length - 1;
        } else {
          let kleinste = Infinity;
          this.kaarten.forEach((kaart, i) => {
            const afstand = Math.abs(this.beginVan(kaart) - links);
            if (afstand < kleinste) {
              kleinste = afstand;
              index = i;
            }
          });
        }
        if (index === this.actief) return;
        this.actief = index;
        this.stippen.forEach((stip, i) => {
          if (i === index) stip.setAttribute('aria-current', 'true');
          else stip.removeAttribute('aria-current');
        });
      }

      zetBezig(form, bezig) {
        form.toggleAttribute('data-bezig', bezig);
        const knop = form.querySelector('[data-lx-knop]');
        if (!knop) return;
        knop.disabled = bezig || form.hasAttribute('data-uitverkocht');
        if (bezig) knop.setAttribute('aria-busy', 'true');
        else knop.removeAttribute('aria-busy');
      }

      toonFout(form, tekst) {
        const regel = form.querySelector('[data-lx-fout]');
        if (!regel) return;
        regel.textContent = tekst || this.dataset.fout || '';
        regel.hidden = false;
      }

      async versturen(event) {
        const form = event.target;
        if (!(form instanceof HTMLFormElement) || !form.hasAttribute('data-lx-koop') || !this.contains(form)) return;
        event.preventDefault();
        if (form.hasAttribute('data-bezig') || form.hasAttribute('data-uitverkocht')) return;
        const veld = form.querySelector('input[name="id"]');
        const id = veld ? Number(veld.value) : 0;
        if (!id) return;

        const regel = form.querySelector('[data-lx-fout]');
        if (regel) regel.hidden = true;
        this.zetBezig(form, true);
        const wagen = this.dataset.wagen || '/cart';
        const lade = document.querySelector('lx-wagen[data-modus="lade"]');
        const sectie = lade && typeof lade.toonMet === 'function' ? lade.dataset.sectie : '';
        const lichaam = { items: [{ id: id, quantity: 1 }] };
        if (sectie) lichaam.sections = sectie;
        try {
          const antwoord = await fetch((this.dataset.toevoegen || '/cart/add') + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(lichaam),
          });
          const json = await antwoord.json().catch(() => ({}));
          if (!antwoord.ok || json.status) {
            const melding = typeof json.description === 'string' ? json.description : '';
            const shopifyFout = new Error(melding);
            shopifyFout.vanShopify = true;
            throw shopifyFout;
          }
          if (sectie && json.sections && json.sections[sectie]) {
            this.zetBezig(form, false);
            lade.toonMet(json.sections[sectie], form.querySelector('button[type="submit"]'));
            window.dispatchEvent(new CustomEvent('lx:cart:updated'));
            return;
          }
          let cart = null;
          try {
            const r = await fetch(wagen + '.js', { headers: { Accept: 'application/json' } });
            cart = await r.json();
          } catch (e) {
            cart = null;
          }
          window.dispatchEvent(new CustomEvent('lx:cart:updated', { detail: cart }));
          window.location.assign(wagen);
        } catch (fout) {
          this.zetBezig(form, false);
          this.toonFout(form, fout && fout.vanShopify ? fout.message : '');
        }
      }
    }

    customElements.define('lx-accessoires-rij', LxAccessoiresRij);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lx-beschrijving"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('lx-beschrijving-accordeon')) return;

    class LxBeschrijvingAccordeon extends HTMLElement {
      constructor() {
        super();
        this.bijBlokSelectie = this.bijBlokSelectie.bind(this);
      }

      connectedCallback() {
        this.addEventListener('click', this);
        document.addEventListener('shopify:block:select', this.bijBlokSelectie);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this);
        document.removeEventListener('shopify:block:select', this.bijBlokSelectie);
      }

      handleEvent(event) {
        const knop = event.target instanceof Element ? event.target.closest('[data-lx-beschrijving-knop]') : null;
        if (!knop || !this.contains(knop)) return;
        const item = knop.closest('[data-lx-beschrijving-item]');
        if (item) this.zet(item, knop.getAttribute('aria-expanded') !== 'true');
      }

      /* In de theme editor: een gekozen blok klapt open, zodat je ziet wat je bewerkt. */
      bijBlokSelectie(event) {
        const item = event.target instanceof Element ? event.target.closest('[data-lx-beschrijving-item]') : null;
        if (item && this.contains(item)) this.zet(item, true);
      }

      zet(item, open) {
        const knop = item.querySelector('[data-lx-beschrijving-knop]');
        if (knop) knop.setAttribute('aria-expanded', open ? 'true' : 'false');
        item.toggleAttribute('data-open', open);
      }
    }

    customElements.define('lx-beschrijving-accordeon', LxBeschrijvingAccordeon);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lx-categorie-modellen"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('lx-categorie-modellen')) return;

    const rustig = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /*
      Eén element per sectie: de stippen volgen de rij, een bolletje wisselt de kleur van zijn kaart,
      en «In winkelwagen» voegt toe zonder de pagina te verlaten tot de wagen gevuld is (zoals lx-koop).
      Alles wordt pas bij gebruik opgezocht, dus het werkt ook na een herlaadbeurt in de editor.
    */
    class LxCategorieModellen extends HTMLElement {
      connectedCallback() {
        if (this._klaar) return;
        this.rij = this.querySelector('[data-lx-rij]');
        if (!this.rij) return;
        this._klaar = true;
        // De action blijft in de HTML als terugval zonder JavaScript. Met JavaScript gaat hij eraf: anders telt
        // Shopify's pixelbeheer de submit als een extra product_added_to_cart (zonder product.url, waarop de
        // Clarity-pixel vastloopt), naast de toevoeging via /cart/add.js. Gemeten 01-10-2026.
        this.querySelectorAll('form[data-lx-koop]').forEach((form) => form.removeAttribute('action'));
        this.kaarten = Array.from(this.rij.querySelectorAll('[data-lx-kaart]'));
        this.stippen = Array.from(this.querySelectorAll('[data-lx-stip]'));
        this.actief = -1;
        this.gepland = false;

        this.opScroll = () => {
          if (this.gepland) return;
          this.gepland = true;
          requestAnimationFrame(() => {
            this.gepland = false;
            this.werkStippenBij();
          });
        };
        this.opKlik = (event) => {
          const doel = event.target instanceof Element ? event.target : null;
          if (!doel) return;
          const stip = doel.closest('[data-lx-stip]');
          if (stip && this.contains(stip)) {
            this.gaNaar(Number(stip.dataset.lxStip));
            return;
          }
          const kleur = doel.closest('[data-lx-kleur-knop]');
          if (kleur && this.contains(kleur)) this.kiesKleur(kleur);
        };
        /* Wie naar de bolletjes gaat, wil misschien zwart zien: dat beeld alvast laden. */
        this.opVoorladen = (event) => {
          const groep = event.target instanceof Element ? event.target.closest('[data-lx-kleuren]') : null;
          const kaart = groep ? groep.closest('[data-lx-kaart]') : null;
          if (!kaart) return;
          kaart.querySelectorAll('img[loading="lazy"]').forEach((img) => {
            img.loading = 'eager';
          });
        };
        this.opVersturen = (event) => this.versturen(event);
        this.opTerug = (event) => {
          if (!event.persisted) return;
          this.querySelectorAll('form[data-lx-koop]').forEach((form) => this.zetBezig(form, false));
        };
        this.opBlokKeuze = (event) => {
          const kaart = event.target instanceof Element ? event.target.closest('[data-lx-kaart]') : null;
          const index = kaart ? this.kaarten.indexOf(kaart) : -1;
          if (index > -1) this.gaNaar(index, true);
        };
        /* Met Tab naar een bolletje, knop of link in een kaart die half buiten beeld staat: die kaart naar voren.
           Zonder dit snapt de rij na het meescrollen van de browser terug en blijft de focus buiten beeld. */
        this.opFocus = (event) => {
          const doel = event.target instanceof Element ? event.target : null;
          if (!doel || !doel.matches(':focus-visible')) return;
          const kaart = doel.closest('[data-lx-kaart]');
          const index = kaart ? this.kaarten.indexOf(kaart) : -1;
          if (index > -1) this.gaNaar(index, true);
        };
        /* De zwarte beelden laden zodra de rij in beeld komt, zodat een tik op zwart nooit een leeg vak geeft.
           Pas na het load-event (PageSpeed 13-10-2026, B5): de rij staat boven de vouw, en anders halen de verborgen
           kleurbeelden (~250 KB) het eerste modelbeeld in. Wie eerder naar de bolletjes gaat, laadt ze via opVoorladen. */
        this.startVoorlader = () => {
          if (!this._klaar || !('IntersectionObserver' in window)) return;
          this.voorlader = new IntersectionObserver(
            (items) => {
              if (!items.some((item) => item.isIntersecting)) return;
              this.querySelectorAll('[data-lx-kleur] img[loading="lazy"]').forEach((img) => {
                img.loading = 'eager';
              });
              this.voorlader.disconnect();
            },
            { rootMargin: '200px 0px' }
          );
          this.voorlader.observe(this.rij);
        };
        if (document.readyState === 'complete') this.startVoorlader();
        else window.addEventListener('load', this.startVoorlader, { once: true });

        this.rij.addEventListener('scroll', this.opScroll, { passive: true });
        this.addEventListener('click', this.opKlik);
        this.addEventListener('pointerover', this.opVoorladen);
        this.addEventListener('focusin', this.opVoorladen);
        this.addEventListener('focusin', this.opFocus);
        this.addEventListener('submit', this.opVersturen);
        window.addEventListener('pageshow', this.opTerug);
        document.addEventListener('shopify:block:select', this.opBlokKeuze);
        this.werkStippenBij();
      }

      disconnectedCallback() {
        if (!this._klaar) return;
        this._klaar = false;
        this.rij.removeEventListener('scroll', this.opScroll);
        this.removeEventListener('click', this.opKlik);
        this.removeEventListener('pointerover', this.opVoorladen);
        this.removeEventListener('focusin', this.opVoorladen);
        this.removeEventListener('focusin', this.opFocus);
        if (this.voorlader) this.voorlader.disconnect();
        window.removeEventListener('load', this.startVoorlader);
        this.removeEventListener('submit', this.opVersturen);
        window.removeEventListener('pageshow', this.opTerug);
        document.removeEventListener('shopify:block:select', this.opBlokKeuze);
      }

      beginVan(kaart) {
        return kaart.offsetLeft - this.kaarten[0].offsetLeft;
      }

      gaNaar(index, direct) {
        const kaart = this.kaarten[index];
        if (!kaart) return;
        this.rij.scrollTo({
          left: this.beginVan(kaart),
          behavior: direct || rustig() ? 'auto' : 'smooth',
        });
      }

      werkStippenBij() {
        if (!this.kaarten.length || !this.stippen.length) return;
        const links = this.rij.scrollLeft;
        const max = this.rij.scrollWidth - this.rij.clientWidth;
        let index = 0;
        if (max > 0 && links >= max - 2) {
          index = this.kaarten.length - 1;
        } else {
          let kleinste = Infinity;
          this.kaarten.forEach((kaart, i) => {
            const afstand = Math.abs(this.beginVan(kaart) - links);
            if (afstand < kleinste) {
              kleinste = afstand;
              index = i;
            }
          });
        }
        if (index === this.actief) return;
        this.actief = index;
        this.stippen.forEach((stip, i) => {
          if (i === index) stip.setAttribute('aria-current', 'true');
          else stip.removeAttribute('aria-current');
        });
      }

      /* Wit of zwart: alleen `hidden` en aria-pressed wisselen; beeld, prijs, formulier en link staan al klaar. */
      kiesKleur(knop) {
        const kaart = knop.closest('[data-lx-kaart]');
        if (!kaart) return;
        const kleur = knop.dataset.lxKleurKnop;
        kaart.querySelectorAll('[data-lx-kleur-knop]').forEach((k) => {
          k.setAttribute('aria-pressed', k === knop ? 'true' : 'false');
        });
        kaart.querySelectorAll('[data-lx-kleur]').forEach((deel) => {
          deel.hidden = deel.dataset.lxKleur !== kleur;
        });
        /* Eén beeld voor beide kleuren: alleen de link van dat beeld volgt de kleur. */
        const urlSleutel = 'data-lx-url-' + kleur;
        kaart.querySelectorAll('[' + urlSleutel + ']').forEach((link) => {
          link.setAttribute('href', link.getAttribute(urlSleutel));
        });
      }

      zetBezig(form, bezig) {
        form.toggleAttribute('data-bezig', bezig);
        const knop = form.querySelector('[data-lx-knop]');
        if (!knop) return;
        knop.disabled = bezig || form.hasAttribute('data-uitverkocht');
        if (bezig) knop.setAttribute('aria-busy', 'true');
        else knop.removeAttribute('aria-busy');
      }

      toonFout(form, tekst) {
        const regel = form.querySelector('[data-lx-fout]');
        if (!regel) return;
        regel.textContent = tekst || this.dataset.fout || '';
        regel.hidden = false;
      }

      async versturen(event) {
        const form = event.target;
        if (!(form instanceof HTMLFormElement) || !form.hasAttribute('data-lx-koop') || !this.contains(form)) return;
        event.preventDefault();
        if (form.hasAttribute('data-bezig') || form.hasAttribute('data-uitverkocht')) return;
        const veld = form.querySelector('input[name="id"]');
        const id = veld ? Number(veld.value) : 0;
        if (!id) return;

        const regel = form.querySelector('[data-lx-fout]');
        if (regel) regel.hidden = true;
        this.zetBezig(form, true);
        const wagen = this.dataset.wagen || '/cart';
        // Zoals lx-koop: de winkelwagenlade (lx-wagen) komt met het antwoord mee terug en gaat open.
        const lade = document.querySelector('lx-wagen[data-modus="lade"]');
        const sectie = lade && typeof lade.toonMet === 'function' ? lade.dataset.sectie : '';
        const lichaam = { items: [{ id: id, quantity: 1 }] };
        if (sectie) lichaam.sections = sectie;
        try {
          const antwoord = await fetch((this.dataset.toevoegen || '/cart/add') + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(lichaam),
          });
          const json = await antwoord.json().catch(() => ({}));
          if (!antwoord.ok || json.status) {
            // Alleen de (vertaalde) uitleg van Shopify tonen; anders de instelbare fouttekst.
            const melding = typeof json.description === 'string' ? json.description : '';
            const shopifyFout = new Error(melding);
            shopifyFout.vanShopify = true;
            throw shopifyFout;
          }
          if (sectie && json.sections && json.sections[sectie]) {
            this.zetBezig(form, false);
            lade.toonMet(json.sections[sectie], form.querySelector('button[type="submit"]'));
            window.dispatchEvent(new CustomEvent('lx:cart:updated'));
            return;
          }
          let cart = null;
          try {
            const r = await fetch(wagen + '.js', { headers: { Accept: 'application/json' } });
            cart = await r.json();
          } catch (e) {
            cart = null;
          }
          window.dispatchEvent(new CustomEvent('lx:cart:updated', { detail: cart }));
          window.location.assign(wagen);
        } catch (fout) {
          // Een netwerkfout geeft een Engelse browsertekst ("Failed to fetch"); die tonen we niet.
          this.zetBezig(form, false);
          this.toonFout(form, fout && fout.vanShopify ? fout.message : '');
        }
      }
    }

    customElements.define('lx-categorie-modellen', LxCategorieModellen);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lx-contact-formulier"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('lx-contact-routering')) return;
    const SLEUTEL = 'lx-contact-verstuurd';
    class LxContactRoutering extends HTMLElement {
      connectedCallback() {
        if (this._klaar) return;
        this._klaar = true;
        const bedankt = this.querySelector('[data-lx-bedankt]');
        if (bedankt) {
          this.toonBedankt(bedankt);
          return;
        }
        this.form = this.querySelector('form');
        if (!this.form) return;
        this.groepen = Array.from(this.querySelectorAll('[data-lx-voor]'));
        this.opWijziging = (event) => {
          const doel = event.target;
          if (!(doel instanceof HTMLInputElement)) return;
          if (doel.dataset.lxOnderwerp) this.kies(doel.dataset.lxOnderwerp);
          if (doel.dataset.lxWinkel) this.winkel(doel.dataset.lxWinkel);
        };
        this.opVerstuur = () => {
          try {
            const o = this.form.querySelector('[data-lx-onderwerp]:checked');
            const e = this.form.querySelector('[data-lx-email]');
            sessionStorage.setItem(SLEUTEL, JSON.stringify({ onderwerp: o ? o.dataset.lxOnderwerp : '', email: e ? e.value : '' }));
          } catch (fout) {}
        };
        this.form.addEventListener('change', this.opWijziging);
        this.form.addEventListener('submit', this.opVerstuur);
        const vooraf = new URLSearchParams(window.location.search).get('onderwerp');
        const radio = vooraf ? this.form.querySelector('[data-lx-onderwerp="' + CSS.escape(vooraf) + '"]') : this.form.querySelector('[data-lx-onderwerp]:checked');
        if (radio) {
          radio.checked = true;
          this.kies(radio.dataset.lxOnderwerp);
        } else {
          this.kies('');
        }
        const w = this.form.querySelector('[data-lx-winkel]:checked');
        if (w) this.winkel(w.dataset.lxWinkel);
      }
      disconnectedCallback() {
        if (!this.form) return;
        this.form.removeEventListener('change', this.opWijziging);
        this.form.removeEventListener('submit', this.opVerstuur);
        this._klaar = false;
      }
      kies(onderwerp) {
        this.onderwerp = onderwerp;
        this.groepen.forEach((g) => {
          const aan = !!onderwerp && g.dataset.lxVoor.split(' ').includes(onderwerp);
          g.hidden = !aan;
          g.querySelectorAll('input, textarea, select').forEach((veld) => {
            veld.disabled = !aan;
          });
        });
        /* verplicht volgt de zichtbaarheid; het model is alleen bij een defect verplicht */
        this.form.querySelectorAll('[data-lx-verplicht]').forEach((veld) => {
          veld.required = !veld.disabled;
        });
        this.form.querySelectorAll('[data-lx-model-keuze]').forEach((r) => {
          r.required = onderwerp === 'defect' && !r.disabled;
        });
        this.zet('[data-lx-model-label]', onderwerp === 'twijfel' ? 'twijfel' : 'defect', 'text');
        this.zet('[data-lx-vraag-label]', onderwerp === 'defect' ? 'defect' : 'anders', 'text');
        this.zet('[data-lx-vraag]', onderwerp === 'twijfel' || onderwerp === 'defect' ? onderwerp : 'anders', 'placeholder');
        this.zet('[data-lx-email]', onderwerp === 'zakelijk' ? 'zakelijk' : 'anders', 'placeholder');
        const w = this.form.querySelector('[data-lx-winkel]:checked');
        if (w) this.winkel(w.dataset.lxWinkel);
      }
      winkel(w) {
        this.zet('[data-lx-bestel-label]', w, 'text');
        this.zet('[data-lx-bestel-hint]', w, 'text');
        const nr = this.form.querySelector('[name="contact[Bestelnummer]"]');
        if (!nr) return;
        nr.required = !nr.disabled && w !== 'anders';
        if (w === 'lumenix') nr.setAttribute('inputmode', 'numeric');
        else nr.removeAttribute('inputmode');
      }
      zet(selector, sleutel, wat) {
        const el = this.form.querySelector(selector);
        if (!el) return;
        const waarde = el.dataset[sleutel];
        if (waarde == null || waarde === '') return;
        if (wat === 'placeholder') el.placeholder = waarde;
        else el.textContent = waarde;
      }
      toonBedankt(bedankt) {
        let info = {};
        try {
          info = JSON.parse(sessionStorage.getItem(SLEUTEL) || '{}');
          sessionStorage.removeItem(SLEUTEL);
        } catch (fout) {}
        const kop = bedankt.querySelector('[data-lx-bedankt-kop]');
        const tekst = bedankt.querySelector('[data-lx-bedankt-tekst]');
        const extra = bedankt.querySelector('[data-lx-bedankt-extra]');
        const email = (info.email || '').trim();
        if (info.onderwerp === 'zakelijk') {
          if (kop && kop.dataset.zakelijk) kop.textContent = kop.dataset.zakelijk;
          if (tekst && tekst.dataset.zakelijk) tekst.textContent = tekst.dataset.zakelijk;
          if (extra) extra.hidden = true;
        }
        if (tekst && email) tekst.textContent = tekst.textContent.replace('je e-mailadres', email);
        bedankt.focus({ preventScroll: true });
      }
    }
    customElements.define('lx-contact-routering', LxContactRoutering);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lx-cross-sell"] && !Shopify.designMode) return;
  try {
    
  /*
    Toetsenbord: krijgt «Bekijk» van een kaart die maar deels in beeld staat de focus, dan schuift de rij
    naar het snappunt van die kaart. Chrome scrolt een deels zichtbare link zelf niet in beeld, en een
    kleine sprong zou de verplichte snap toch terugzetten. Zo staat de gefocuste knop met rand altijd heel in beeld.
  */
  (() => {
    if (window.lxCrossSellFocus) return;
    window.lxCrossSellFocus = true;

    document.addEventListener('focusin', (event) => {
      const knop = event.target instanceof Element ? event.target.closest('.lx-cross-sell__knop') : null;
      if (!knop) return;
      const rij = knop.closest('.lx-cross-sell__rij');
      const kaart = knop.closest('.lx-cross-sell__kaart');
      if (!rij || !kaart) return;
      const r = rij.getBoundingClientRect();
      const k = kaart.getBoundingClientRect();
      if (k.left >= r.left - 1 && k.right <= r.right + 1) return;
      const rustig = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      rij.scrollTo({ left: rij.scrollLeft + (k.left - r.left), behavior: rustig ? 'auto' : 'smooth' });
    });
  })();
  /*
    Deal-keuze (lx-koop): wat in de gekozen deal zit, gaat uit de rij. De kaarten worden echt uit de rij
    gehaald (en in de oorspronkelijke volgorde teruggezet), zodat de carrousel uit lx-base altijd met een
    zichtbare eerste kaart rekent. Zijn alle kaarten weg, dan verdwijnt de sectie.
  */
  (() => {
    if (window.lxCrossSellDeal) return;
    window.lxCrossSellDeal = true;

    const lijst = (waarde) => (Array.isArray(waarde) ? waarde : String(waarde || '').split(','))
      .map((h) => String(h).trim())
      .filter(Boolean);

    const werkBij = (producten) => {
      const weg = new Set(lijst(producten));
      document.querySelectorAll('[data-lx-cross-sell-rij]').forEach((rij) => {
        if (!rij._lxKaarten) rij._lxKaarten = Array.from(rij.children);
        const zichtbaar = rij._lxKaarten.filter((k) => !weg.has(k.dataset.handle));
        rij._lxKaarten.forEach((k) => {
          if (!zichtbaar.includes(k) && k.parentNode === rij) k.remove();
        });
        zichtbaar.forEach((k) => rij.appendChild(k));
        rij.scrollLeft = 0;
        const sectie = rij.closest('.lx-cross-sell');
        if (sectie) sectie.hidden = zichtbaar.length === 0;
      });
      /* lx-carrousel.js toont de pijlen opnieuw bij resize */
      window.dispatchEvent(new Event('resize'));
    };

    document.addEventListener('lx:deal-gekozen', (event) => {
      werkBij(event.detail && event.detail.producten);
    });
    const start = () => {
      const huidig = document.documentElement.dataset.lxDealProducten;
      if (huidig) werkBij(huidig);
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lx-ervaringen"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('lx-ervaring-video')) return;

    /* «Minder beweging» in het systeem: niet vanzelf afspelen, alleen na een tik. */
    const minderBeweging = window.matchMedia('(prefers-reduced-motion: reduce)');

    /*
      Eén waarnemer voor alle kaarten met video, in elke instantie van de sectie en na elke herlaadbeurt in de
      editor. In beeld = minstens de helft van het fotovak zichtbaar, ook binnen de schuifrij. Buiten beeld
      pauzeert de video, zodat er nooit meer speelt dan je ziet.
    */
    const DREMPEL = 0.5;
    const waarnemer =
      'IntersectionObserver' in window
        ? new IntersectionObserver(
            (items) => {
              items.forEach((item) => {
                if (typeof item.target.zetInBeeld === 'function') {
                  item.target.zetInBeeld(item.isIntersecting && item.intersectionRatio >= DREMPEL);
                }
              });
            },
            { threshold: [0, DREMPEL] }
          )
        : null;

    class LxErvaringVideo extends HTMLElement {
      connectedCallback() {
        if (this._klaar) return;
        this.video = this.querySelector('video');
        this.knop = this.querySelector('.lx-ervaringen__speel');
        if (!this.video || !this.knop) return;
        this._klaar = true;

        /* Zonder geluid, in een lus, in de pagina, zonder bediening. Afspelen start alleen dit script. */
        this.video.muted = true;
        this.video.defaultMuted = true;
        this.video.loop = true;
        this.video.playsInline = true;
        this.video.autoplay = false;
        this.video.controls = false;

        this.inBeeld = !waarnemer;
        this.doorTik = false;
        this.wilSpelen = !minderBeweging.matches;

        this._opTik = this.wissel.bind(this);
        this._opBeweging = this.opBeweging.bind(this);
        this.knop.addEventListener('click', this._opTik);
        if (typeof minderBeweging.addEventListener === 'function') {
          minderBeweging.addEventListener('change', this._opBeweging);
        }

        this.knop.hidden = false;
        this.pasToe();
        if (waarnemer) waarnemer.observe(this);
      }

      disconnectedCallback() {
        if (!this._klaar) return;
        this._klaar = false;
        if (waarnemer) waarnemer.unobserve(this);
        this.knop.removeEventListener('click', this._opTik);
        if (typeof minderBeweging.removeEventListener === 'function') {
          minderBeweging.removeEventListener('change', this._opBeweging);
        }
        this.video.pause();
      }

      zetInBeeld(inBeeld) {
        this.inBeeld = inBeeld;
        this.pasToe();
      }

      /* Tik: afspelen als hij stilstaat, pauzeren als hij speelt. Een pauze door een tik blijft staan. */
      wissel() {
        this.doorTik = true;
        this.wilSpelen = !this.wilSpelen;
        if (this.wilSpelen) this.inBeeld = true;
        this.pasToe();
      }

      opBeweging() {
        if (minderBeweging.matches) {
          this.wilSpelen = false;
        } else if (!this.doorTik) {
          this.wilSpelen = true;
        }
        this.pasToe();
      }

      pasToe() {
        if (!this._klaar) return;
        if (this.wilSpelen && this.inBeeld) {
          if (this.video.paused) {
            const bezig = this.video.play();
            if (bezig && typeof bezig.catch === 'function') {
              bezig.catch((fout) => {
                /* Geweigerd door de browser (bijv. energiebesparing op iOS): poster met afspeelknop. */
                if (fout && fout.name === 'NotAllowedError') {
                  this.wilSpelen = false;
                  this.toonStaat();
                }
              });
            }
          }
        } else if (!this.video.paused) {
          this.video.pause();
        }
        this.toonStaat();
      }

      toonStaat() {
        this.classList.toggle('is-gepauzeerd', !this.wilSpelen);
        const label = this.wilSpelen ? this.knop.dataset.labelPauze : this.knop.dataset.labelSpeel;
        if (label) this.knop.setAttribute('aria-label', label);
      }
    }

    customElements.define('lx-ervaring-video', LxErvaringVideo);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lx-faq"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('lx-faq-accordeon')) return;

    class LxFaqAccordeon extends HTMLElement {
      constructor() {
        super();
        this.bijBlokSelectie = this.bijBlokSelectie.bind(this);
      }

      connectedCallback() {
        this.addEventListener('click', this);
        document.addEventListener('shopify:block:select', this.bijBlokSelectie);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this);
        document.removeEventListener('shopify:block:select', this.bijBlokSelectie);
      }

      handleEvent(event) {
        const knop = event.target instanceof Element ? event.target.closest('[data-lx-faq-knop]') : null;
        if (!knop || !this.contains(knop)) return;
        const item = knop.closest('[data-lx-faq-item]');
        if (item) this.zet(item, knop.getAttribute('aria-expanded') !== 'true');
      }

      /* In de theme editor: een gekozen vraag klapt open, zodat je ziet wat je bewerkt. */
      bijBlokSelectie(event) {
        const item = event.target instanceof Element ? event.target.closest('[data-lx-faq-item]') : null;
        if (item && this.contains(item)) this.zet(item, true);
      }

      zet(item, open) {
        const knop = item.querySelector('[data-lx-faq-knop]');
        if (knop) knop.setAttribute('aria-expanded', open ? 'true' : 'false');
        item.toggleAttribute('data-open', open);
      }
    }

    customElements.define('lx-faq-accordeon', LxFaqAccordeon);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lx-footer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('lx-footer-cookies')) return;

    /* «Cookievoorkeuren» opent de voorkeuren van de Shopify-cookiebanner. Bestaat die niet,
       dan gaat de knop naar het privacybeleid. */
    class LxFooterCookies extends HTMLElement {
      connectedCallback() {
        if (this.opKlik) return;
        this.knop = this.querySelector('button');
        if (!this.knop) return;
        this.opKlik = (event) => {
          event.preventDefault();
          const shopify = window.Shopify;
          const privacy = shopify && shopify.customerPrivacy;
          if (privacy && typeof privacy.showPreferences === 'function') {
            privacy.showPreferences();
            return;
          }
          const banner = window.privacyBanner;
          if (banner && typeof banner.showPreferences === 'function') {
            banner.showPreferences();
            return;
          }
          const terugval = this.dataset.terugval;
          if (terugval) window.location.href = terugval;
        };
        this.knop.addEventListener('click', this.opKlik);
      }

      disconnectedCallback() {
        if (this.knop && this.opKlik) this.knop.removeEventListener('click', this.opKlik);
        this.opKlik = null;
        this.knop = null;
      }
    }

    customElements.define('lx-footer-cookies', LxFooterCookies);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lx-header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('lx-header-kop')) return;

    const zonderBeweging = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const inEditor = () => Boolean(window.Shopify && window.Shopify.designMode);

    class LxHeaderKop extends HTMLElement {
      connectedCallback() {
        this.lade = this.querySelector('[data-lx-lade]');
        this.openKnop = this.querySelector('[data-lx-open]');
        this.sluitKnop = this.querySelector('[data-lx-sluit]');
        this.wagen = this.querySelector('[data-lx-wagen]');
        this.teller = this.querySelector('[data-lx-teller]');
        this.wagenUrl = this.dataset.wagenUrl || '/cart.js';

        this.open = this.open.bind(this);
        this.sluit = this.sluit.bind(this);
        this.opLadeKlik = this.opLadeKlik.bind(this);
        this.opAnnuleer = this.opAnnuleer.bind(this);
        this.opGesloten = this.opGesloten.bind(this);
        this.opWagen = this.opWagen.bind(this);
        this.opThemaWagen = this.opThemaWagen.bind(this);
        this.opPageshow = this.opPageshow.bind(this);
        this.opBlokKies = this.opBlokKies.bind(this);
        this.opBlokLos = this.opBlokLos.bind(this);
        this.opLand = this.opLand.bind(this);
        this.meet = this.meet.bind(this);

        if (this.openKnop) this.openKnop.addEventListener('click', this.open);
        if (this.lade) {
          this.lade.addEventListener('click', this.opLadeKlik);
          this.lade.addEventListener('cancel', this.opAnnuleer);
          this.lade.addEventListener('close', this.opGesloten);
        }
        this.landKeuzes = Array.from(this.querySelectorAll('[data-lx-land]'));
        this.landKeuzes.forEach((keuze) => keuze.addEventListener('change', this.opLand));

        window.addEventListener('lx:cart:updated', this.opWagen);
        document.addEventListener('cart:update', this.opThemaWagen);
        window.addEventListener('pageshow', this.opPageshow);
        document.addEventListener('shopify:block:select', this.opBlokKies);
        document.addEventListener('shopify:block:deselect', this.opBlokLos);
        document.addEventListener('lx:aankondiging:afgelopen', this.meet);

        this.controleerActie();
        this.startMeten();

        // Vanaf 1024 is er geen hamburger: staat de lade open als het venster breder wordt, dan gaat hij dicht.
        this.desktop = window.matchMedia('(min-width: 1024px)');
        this.opDesktop = (event) => {
          if (event.matches && !inEditor() && this.lade && this.lade.open) this.sluit(true);
        };
        if (typeof this.desktop.addEventListener === 'function') this.desktop.addEventListener('change', this.opDesktop);
      }

      disconnectedCallback() {
        if (this.openKnop) this.openKnop.removeEventListener('click', this.open);
        if (this.lade) {
          this.lade.removeEventListener('click', this.opLadeKlik);
          this.lade.removeEventListener('cancel', this.opAnnuleer);
          this.lade.removeEventListener('close', this.opGesloten);
        }
        (this.landKeuzes || []).forEach((keuze) => keuze.removeEventListener('change', this.opLand));
        window.removeEventListener('lx:cart:updated', this.opWagen);
        document.removeEventListener('cart:update', this.opThemaWagen);
        window.removeEventListener('pageshow', this.opPageshow);
        document.removeEventListener('shopify:block:select', this.opBlokKies);
        document.removeEventListener('shopify:block:deselect', this.opBlokLos);
        document.removeEventListener('lx:aankondiging:afgelopen', this.meet);
        if (this.desktop && typeof this.desktop.removeEventListener === 'function') {
          this.desktop.removeEventListener('change', this.opDesktop);
        }
        if (this.waarnemer) this.waarnemer.disconnect();
        clearTimeout(this.sluitKlok);
        if (this.haalt) this.haalt.abort();
        this.ontgrendel();
      }

      /* Menu-lade */

      open(direct) {
        const lade = this.lade;
        if (!lade) return;
        if (lade.open) {
          // Sluiten was bezig: terugdraaien.
          clearTimeout(this.sluitKlok);
          if (this.opEinde) lade.removeEventListener('transitionend', this.opEinde);
          lade.classList.add('is-open');
          if (this.openKnop) this.openKnop.setAttribute('aria-expanded', 'true');
          return;
        }
        this.terugFocus = document.activeElement;
        this.controleerActie();
        if (typeof lade.showModal === 'function') {
          lade.showModal();
        } else {
          lade.setAttribute('open', '');
        }
        this.vergrendel();
        if (this.openKnop) this.openKnop.setAttribute('aria-expanded', 'true');
        if (direct !== true && !zonderBeweging()) lade.getBoundingClientRect();
        lade.classList.add('is-open');
        if (this.sluitKnop) this.sluitKnop.focus({ preventScroll: true });
      }

      sluit(direct) {
        const lade = this.lade;
        if (!lade || !lade.open) return;
        lade.classList.remove('is-open');
        if (this.openKnop) this.openKnop.setAttribute('aria-expanded', 'false');
        const klaar = () => {
          clearTimeout(this.sluitKlok);
          if (this.opEinde) lade.removeEventListener('transitionend', this.opEinde);
          this.opEinde = null;
          if (!lade.open) return;
          if (typeof lade.close === 'function') {
            lade.close();
          } else {
            lade.removeAttribute('open');
            this.opGesloten();
          }
        };
        if (direct === true || zonderBeweging()) {
          klaar();
          return;
        }
        this.opEinde = (event) => {
          if (event.target === lade && event.propertyName === 'transform') klaar();
        };
        lade.addEventListener('transitionend', this.opEinde);
        this.sluitKlok = setTimeout(klaar, 400);
      }

      opLadeKlik(event) {
        // Klik op de achtergrond (::backdrop) komt binnen op de dialog zelf.
        if (event.target === this.lade) {
          this.sluit();
          return;
        }
        if (event.target.closest('[data-lx-sluit]')) {
          this.sluit();
          return;
        }
        const link = event.target.closest('a[href]');
        if (link && link.hash && link.pathname === window.location.pathname) this.sluit(true);
      }

      opAnnuleer(event) {
        event.preventDefault();
        this.sluit();
      }

      opGesloten() {
        if (this.lade) this.lade.classList.remove('is-open');
        if (this.openKnop) this.openKnop.setAttribute('aria-expanded', 'false');
        this.ontgrendel();
        const doel = this.terugFocus && this.terugFocus.isConnected ? this.terugFocus : this.openKnop;
        this.terugFocus = null;
        if (doel && typeof doel.focus === 'function') doel.focus({ preventScroll: true });
      }

      vergrendel() {
        if (this.vergrendeld) return;
        const html = document.documentElement;
        this.vorigeOverflow = html.style.overflow;
        html.style.overflow = 'hidden';
        this.vergrendeld = true;
      }

      ontgrendel() {
        if (!this.vergrendeld) return;
        document.documentElement.style.overflow = this.vorigeOverflow || '';
        this.vergrendeld = false;
      }

      controleerActie() {
        if (inEditor()) return;
        this.querySelectorAll('[data-lx-einde]').forEach((kaart) => {
          const einde = parseInt(kaart.getAttribute('data-lx-einde'), 10) * 1000;
          if (einde && Date.now() >= einde) kaart.hidden = true;
        });
      }

      opBlokKies(event) {
        if (this.lade && this.lade.contains(event.target)) this.open(true);
      }

      opBlokLos(event) {
        if (this.lade && this.lade.contains(event.target)) this.sluit(true);
      }

      opLand(event) {
        const form = event.target.form;
        if (!form) return;
        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit();
        } else {
          form.submit();
        }
      }

      /* Winkelwagen-teller */

      zetTeller(waarde) {
        const aantal = Math.max(0, parseInt(waarde, 10) || 0);
        if (this.teller) {
          this.teller.textContent = String(aantal);
          this.teller.hidden = aantal === 0;
        }
        if (this.wagen) {
          const basis = this.dataset.labelWagen || 'Winkelwagen';
          const eenheid = aantal === 1 ? this.dataset.labelArtikel || 'artikel' : this.dataset.labelArtikelen || 'artikelen';
          this.wagen.setAttribute('aria-label', aantal === 0 ? basis : `${basis}, ${aantal} ${eenheid}`);
        }
      }

      haalWagen() {
        if (this.haalt) this.haalt.abort();
        const controle = new AbortController();
        this.haalt = controle;
        fetch(this.wagenUrl, {
          headers: { Accept: 'application/json' },
          credentials: 'same-origin',
          signal: controle.signal,
        })
          .then((antwoord) => (antwoord.ok ? antwoord.json() : null))
          .then((wagen) => {
            if (wagen && typeof wagen.item_count === 'number') this.zetTeller(wagen.item_count);
          })
          .catch(() => {});
      }

      opWagen(event) {
        const wagen = event && event.detail;
        if (wagen && typeof wagen.item_count === 'number') {
          this.zetTeller(wagen.item_count);
        } else {
          this.haalWagen();
        }
      }

      opThemaWagen(event) {
        const detail = (event && event.detail) || {};
        let aantal = null;
        if (detail.resource && typeof detail.resource.item_count === 'number') aantal = detail.resource.item_count;
        else if (detail.data && typeof detail.data.itemCount === 'number') aantal = detail.data.itemCount;
        if (aantal === null) {
          this.haalWagen();
        } else {
          this.zetTeller(aantal);
        }
      }

      opPageshow(event) {
        if (event.persisted && this.lade && this.lade.open) this.sluit(true);
        this.haalWagen();
      }

      /* Hoogtes voor Horizon-onderdelen die op --header-height en --header-group-height rekenen */

      startMeten() {
        this.meet();
        if (!('ResizeObserver' in window)) return;
        this.waarnemer = new ResizeObserver(() => this.meet());
        const kop = this.closest('.shopify-section') || this;
        this.waarnemer.observe(kop);
        const groep = document.getElementById('header-group');
        if (groep) {
          Array.from(groep.children).forEach((kind) => {
            if (kind !== kop) this.waarnemer.observe(kind);
          });
        }
      }

      meet() {
        const kop = this.closest('.shopify-section') || this;
        document.body.style.setProperty('--header-height', `${kop.offsetHeight}px`);
        const groep = document.getElementById('header-group');
        if (!groep) return;
        let som = 0;
        Array.from(groep.children).forEach((kind) => {
          if (kind !== kop && kind instanceof HTMLElement) som += kind.offsetHeight;
        });
        document.body.style.setProperty('--header-group-height', `${som}px`);
      }
    }

    customElements.define('lx-header-kop', LxHeaderKop);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lx-home-clips"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('lx-home-clips-rij')) return;
    const rustig = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const zuinig = () => !!(navigator.connection && navigator.connection.saveData);

    /* Maten uit Figma 536:2035: actieve clip 250 breed, buren 200. De buur rechts staat op ruimte/12 (x 332),
       de buur links op 20 (x -150); zo blijft het bij elke stap. */
    const ACTIEF = 250;
    const BUUR = 200;
    const GAP_RECHTS = 12;
    const GAP_LINKS = 20;
    const DREMPEL = 40;

    class LxHomeClipsRij extends HTMLElement {
      connectedCallback() {
        if (this._klaar) return;
        this.lijst = this.querySelector('[data-lx-clips]');
        if (!this.lijst) return;
        this._klaar = true;
        this.clips = Array.from(this.lijst.querySelectorAll('[data-lx-clip]'));
        /* Desktop: alle clips, ook die met «Alleen op desktop». */
        this.alle = Array.from(this.lijst.querySelectorAll('[data-lx-clip], [data-lx-clip-desktop]'));
        /* Volgnummer van elke echte clip; een kopie neemt het mee, zo weet hij wie zijn origineel is. */
        this.alle.forEach((clip, i) => {
          clip.dataset.lxNr = String(i);
        });
        this.pijlen = this.querySelector('[data-lx-ronde-pijlen]');
        this.ronde = null;
        this.mq = window.matchMedia('(min-width: 1024px)');
        this.desktop = false;
        this.opMaat = () => this.wissel();
        this.tellerEl = this.querySelector('[data-lx-teller-tekst]');
        this.tellerSjabloon = this.dataset.lxTeller || '[nr] van [totaal]';
        this.preview = Math.max(1, Number(this.dataset.lxPreview) || 6);
        this.actief = 0;
        this.inBeeld = false;

        this.opKlik = this.opKlik.bind(this);
        this.opToets = this.opToets.bind(this);
        this.opNeer = this.opNeer.bind(this);
        this.opBeweeg = this.opBeweeg.bind(this);
        this.opLos = this.opLos.bind(this);
        this.opBlokKeuze = this.opBlokKeuze.bind(this);
        this.opTijd = this.opTijd.bind(this);
        /* Desktop: voorvertoning met de muis erboven of met toetsenbordfocus (punt 12a). */
        this.opBoven = (event) => {
          if (this.desktop && event.pointerType === 'mouse') this.voorproef(event.currentTarget, true);
        };
        this.opWeg = (event) => {
          if (this.desktop && event.pointerType === 'mouse') this.voorproef(event.currentTarget, false);
        };
        this.opFocusIn = (event) => {
          if (!this.desktop) return;
          const doel = event.target;
          let toetsenbord = true;
          try {
            toetsenbord = doel.matches(':focus-visible');
          } catch (e) {}
          if (toetsenbord) this.voorproef(event.currentTarget, true);
        };
        this.opFocusUit = (event) => {
          if (!this.desktop) return;
          const clip = event.currentTarget;
          if (event.relatedTarget instanceof Node && clip.contains(event.relatedTarget)) return;
          if (clip.matches(':hover')) return;
          this.voorproef(clip, false);
        };
        /* Met de muis vegen: geen beeld of link meeslepen. */
        this.opSleepBeeld = (event) => event.preventDefault();

        /* Desktop rondlopend: na elke scroll terug naar de echte set en kopieën in beeld ruilen voor hun origineel.
           scrollend waar de browser dat kent, anders 150 ms na de laatste scroll. */
        this.metScrollend = 'onscrollend' in window;
        this.opRondeKlaar = () => this.naScroll();
        this.opRondeScroll = () => {
          clearTimeout(this._scrollKlok);
          this._scrollKlok = setTimeout(this.opRondeKlaar, 150);
        };
        this.opRondeHand = () => {
          if (!this.ronde) return;
          this.ronde.aangeraakt = true;
          this.ronde.doel = null;
        };
        this.opRondeMaat = () => {
          clearTimeout(this._maatKlok);
          this._maatKlok = setTimeout(() => {
            if (this.ronde && this.desktop) this.herijk();
          }, 150);
        };
        /* Bij de eerste weergave kan de opmaak nog niet af zijn; na het load-event nog één keer neerzetten, zolang
           niemand de rij heeft aangeraakt. */
        this.opRondeLoad = () => {
          if (this.ronde && this.desktop && !this.ronde.aangeraakt) this.herijk(0);
        };

        this.addEventListener('click', this.opKlik, true);
        this.addEventListener('keydown', this.opToets);
        this.lijst.addEventListener('pointerdown', this.opNeer);
        this.lijst.addEventListener('pointermove', this.opBeweeg);
        this.lijst.addEventListener('pointerup', this.opLos);
        this.lijst.addEventListener('pointercancel', this.opLos);
        this.lijst.addEventListener('dragstart', this.opSleepBeeld);
        this.lijst.addEventListener(this.metScrollend ? 'scrollend' : 'scroll', this.metScrollend ? this.opRondeKlaar : this.opRondeScroll, { passive: true });
        ['wheel', 'pointerdown', 'touchstart', 'keydown'].forEach((type) => this.lijst.addEventListener(type, this.opRondeHand, { passive: true }));
        window.addEventListener('resize', this.opRondeMaat);
        if (document.readyState !== 'complete') window.addEventListener('load', this.opRondeLoad);
        document.addEventListener('shopify:block:select', this.opBlokKeuze);
        if (this.mq.addEventListener) this.mq.addEventListener('change', this.opMaat);
        else if (this.mq.addListener) this.mq.addListener(this.opMaat);
        this.alle.forEach((clip) => {
          const video = clip.querySelector('video');
          if (!video) return;
          video.muted = true;
          video.playsInline = true;
          video.setAttribute('playsinline', '');
          video.addEventListener('timeupdate', this.opTijd);
          clip.addEventListener('pointerenter', this.opBoven);
          clip.addEventListener('pointerleave', this.opWeg);
          clip.addEventListener('focusin', this.opFocusIn);
          clip.addEventListener('focusout', this.opFocusUit);
        });

        /* Posters pas als de rij in de buurt komt (PageSpeed 13-10-2026): zie de opmerking bij de video in Liquid.
           De rij staat op mobiel net onder de vouw, dus de waarnemer begint pas na het load-event of bij de eerste
           scroll (wat eerst komt); anders vuurt hij meteen en laden de posters toch tegelijk met het herobeeld. */
        /* Ook de kopieën (desktop): zelfde URL als het origineel, dus uit de cache en geen extra verzoek. Een kopie die
           later ontstaat, neemt het poster-attribuut van zijn origineel mee. */
        this.laadPosters = () => {
          this.lijst.querySelectorAll('video[data-poster]').forEach((video) => {
            if (!video.getAttribute('poster')) video.setAttribute('poster', video.dataset.poster);
          });
        };
        this.startPosters = () => {
          window.removeEventListener('load', this.startPosters);
          window.removeEventListener('scroll', this.startPosters);
          if (this.voorlader || !this._klaar) return;
          if (!('IntersectionObserver' in window)) {
            this.laadPosters();
            return;
          }
          this.voorlader = new IntersectionObserver(
            (items) => {
              if (!items.some((item) => item.isIntersecting)) return;
              this.laadPosters();
              this.voorlader.disconnect();
            },
            { rootMargin: '600px 0px' }
          );
          this.voorlader.observe(this);
        };
        if (document.readyState === 'complete') {
          this.startPosters();
        } else {
          window.addEventListener('load', this.startPosters);
          window.addEventListener('scroll', this.startPosters, { passive: true });
        }

        if ('IntersectionObserver' in window) {
          this.kijker = new IntersectionObserver(
            (items) => {
              this.inBeeld = items.some((item) => item.isIntersecting);
              this.werkVideoBij();
            },
            { threshold: 0.5 }
          );
          this.kijker.observe(this.lijst);
        }
        this.wissel(true);
      }

      /* Mobiel: de rondlopende rij met één clip in het midden. Desktop: carrousel waarin elke clip bedienbaar is. */
      wissel(eerste) {
        const desktop = this.mq.matches;
        if (!eerste && desktop === this.desktop) return;
        this.desktop = desktop;
        this.alle.forEach((clip) => {
          const video = clip.querySelector('video');
          const knop = clip.querySelector('[data-lx-speel]');
          if (video) {
            if (!video.paused) video.pause();
            video.muted = true;
          }
          if (knop) knop.setAttribute('aria-pressed', 'false');
          if (!clip.dataset.lxLabelMobiel) clip.dataset.lxLabelMobiel = clip.getAttribute('aria-label') || '';
          if (desktop) {
            clip.removeAttribute('aria-hidden');
            if (clip.dataset.lxLabelDesktop) clip.setAttribute('aria-label', clip.dataset.lxLabelDesktop);
            clip.querySelectorAll('a, button').forEach((el) => el.removeAttribute('tabindex'));
          } else if (clip.dataset.lxLabelMobiel) {
            clip.setAttribute('aria-label', clip.dataset.lxLabelMobiel);
          }
        });
        if (desktop) {
          /* Begin met de clip die mobiel in het midden stond (bij laden clip 1) als eerste hele kaart. */
          const nr = this.alle.indexOf(this.clips[this.actief]);
          this.herijk(nr > -1 ? nr : 0);
        } else {
          this.rondeUit();
          this.zet(this.actief, true);
        }
      }

      /* ---- Desktop rondlopend (Dion 13-10-2026), zie de kop van dit bestand. ----
         Plekken: de kinderen van de rij, links naar rechts. Plek p toont clip p mod n; de echte set begint op
         sets x n. Alle kaarten zijn even breed, dus de stap (kaart + gap) is overal gelijk. «Midden» is de plek
         waarvan het midden in het vastklikpunt staat: het midden van de rij, of bij een tussenruimte in het midden
         een halve stap links daarvan. */

      zicht() {
        const r = this.lijst.getBoundingClientRect();
        return { l: Math.max(r.left, 0), r: Math.min(r.right, document.documentElement.clientWidth) };
      }

      middenVan(el) {
        const r = this.lijst.getBoundingClientRect();
        const e = el.getBoundingClientRect();
        return e.left - r.left - this.lijst.clientLeft + this.lijst.scrollLeft + e.width / 2;
      }

      snapRand() {
        return this.ronde && this.ronde.tussen ? this.ronde.stap : 0;
      }

      scrollVoor(plek) {
        const plekken = this.lijst.children;
        const el = plekken[Math.max(0, Math.min(plekken.length - 1, plek))];
        return this.middenVan(el) - (this.lijst.clientWidth - this.snapRand()) / 2;
      }

      middenPlek() {
        const x = this.lijst.scrollLeft + (this.lijst.clientWidth - this.snapRand()) / 2;
        return Math.round((x - this.middenVan(this.lijst.children[0])) / this.ronde.stap);
      }

      springNaar(links) {
        try {
          this.lijst.scrollTo({ left: links, behavior: 'instant' });
        } catch (e) {
          this.lijst.scrollLeft = links;
        }
      }

      /* Kaart of tussenruimte in het midden: wat aan elke rand het dichtst bij een halve kaart uitsteekt.
         links = het aantal hele kaarten links van de middenplek, om de eerste hele kaart terug te vinden. */
      kiesModus(breed, kaart, stap) {
        const gap = stap - kaart;
        const half = kaart / 2;
        const mK = Math.max(0, Math.floor((breed - kaart) / (2 * stap)));
        const restK = Math.max(0, (breed - kaart) / 2 - mK * stap - gap);
        const mT = Math.max(0, Math.floor((breed / 2 - gap / 2 - kaart) / stap) + 1);
        const restT = Math.max(0, breed / 2 - gap / 2 - mT * stap);
        const tussen = mT > 0 && Math.abs(restT - half) < Math.abs(restK - half);
        return { tussen, links: tussen ? mT - 1 : mK };
      }

      kloon(clip) {
        const k = clip.cloneNode(true);
        ['data-lx-clip', 'data-lx-clip-desktop', 'data-lx-plek', 'data-shopify-editor-block', 'role', 'aria-roledescription', 'aria-label', 'id'].forEach((a) =>
          k.removeAttribute(a)
        );
        k.classList.remove('is-actief');
        k.setAttribute('data-lx-kloon', '');
        k.setAttribute('aria-hidden', 'true');
        k.setAttribute('inert', '');
        k.querySelectorAll('[id]').forEach((el) => el.removeAttribute('id'));
        k.querySelectorAll('a, button').forEach((el) => el.setAttribute('tabindex', '-1'));
        k.querySelectorAll('video').forEach((v) => {
          v.removeAttribute('autoplay');
          v.setAttribute('preload', 'none');
          v.muted = true;
        });
        return k;
      }

      /* Verplaatsen zonder dat een spelende video stopt of de focus wegvalt: moveBefore waar de browser dat kent,
         anders insertBefore (in dezelfde taak terug in het document = de video speelt door) en de focus terugzetten. */
      verplaats(el, voor) {
        const focus = document.activeElement;
        const hadFocus = focus && focus !== document.body && el.contains(focus);
        if (this.lijst.moveBefore && el.isConnected) {
          try {
            this.lijst.moveBefore(el, voor);
            return;
          } catch (e) {}
        }
        this.lijst.insertBefore(el, voor);
        if (hadFocus && document.activeElement !== focus) {
          try {
            focus.focus({ preventScroll: true });
          } catch (e) {}
        }
      }

      ruil(a, b) {
        const plek = document.createTextNode('');
        this.lijst.insertBefore(plek, a);
        this.verplaats(a, b);
        this.verplaats(b, plek);
        plek.remove();
      }

      verwijderKlonen() {
        this.lijst.querySelectorAll(':scope > [data-lx-kloon]').forEach((k) => k.remove());
        /* De echte clips terug in hun volgorde (een ruil kan ze verschoven hebben). */
        const nu = Array.from(this.lijst.children);
        if (this.alle.some((clip, i) => nu[i] !== clip)) this.alle.forEach((clip) => this.verplaats(clip, null));
      }

      bouwKlonen(sets) {
        this.verwijderKlonen();
        const voor = document.createDocumentFragment();
        const na = document.createDocumentFragment();
        for (let s = 0; s < sets; s += 1) {
          this.alle.forEach((clip) => {
            voor.appendChild(this.kloon(clip));
            na.appendChild(this.kloon(clip));
          });
        }
        this.lijst.insertBefore(voor, this.lijst.firstChild);
        this.lijst.appendChild(na);
        this.ronde.sets = sets;
      }

      /* Neerzetten of opnieuw uitmeten (laden, naar desktop, venstermaat). eersteNr = de clip die de eerste hele kaart
         wordt; zonder: de huidige eerste hele kaart blijft staan. */
      herijk(eersteNr) {
        const n = this.alle.length;
        if (!this.desktop || n < 2) return;
        let nr = eersteNr;
        if (nr == null && this.ronde && this.ronde.sets) {
          const el = this.lijst.children[this.middenPlek() - this.ronde.links];
          nr = el ? Number(el.dataset.lxNr) || 0 : 0;
        }
        if (nr == null) nr = 0;
        if (!this.ronde) this.ronde = { n, sets: 0, stap: 0, tussen: false, links: 0, doel: null, aangeraakt: false };
        const z = this.zicht();
        const breed = Math.max(1, z.r - z.l);
        /* Twee naast elkaar liggende plekken (na een ruil liggen clip 1 en 2 niet per se naast elkaar). */
        const eerste = this.lijst.children[0].getBoundingClientRect();
        const tweede = this.lijst.children[1].getBoundingClientRect();
        const kaart = eerste.width;
        const gap = parseFloat(getComputedStyle(this.lijst).columnGap) || 0;
        const stap = Math.abs(tweede.left - eerste.left) || kaart + gap;
        if (!kaart || !stap) return;
        /* Genoeg kopieën voor anderhalf scherm plus twee stappen aan elke kant, zodat ook een flinke veeg met het
           trackpad niet tegen het einde loopt voordat de rij terugspringt. */
        const sets = Math.max(1, Math.ceil((1.5 * breed + 2 * stap) / (n * stap)));
        if (sets > this.ronde.sets) this.bouwKlonen(sets);
        const modus = this.kiesModus(breed, kaart, stap);
        this.ronde.stap = stap;
        this.ronde.tussen = modus.tussen;
        this.ronde.links = modus.links;
        this.ronde.doel = null;
        this.lijst.style.setProperty('--lx-clips-snap-rechts', modus.tussen ? stap + 'px' : '0px');
        this.springNaar(this.scrollVoor(this.ronde.sets * n + nr + modus.links));
        this.normaliseer();
        this.ruilKlonen();
        if (this.pijlen) this.pijlen.hidden = false;
      }

      rondeUit() {
        if (this.pijlen) this.pijlen.hidden = true;
        if (!this.ronde) return;
        this.ronde = null;
        this.verwijderKlonen();
        this.lijst.style.removeProperty('--lx-clips-snap-rechts');
        this.lijst.scrollLeft = 0;
      }

      /* Staat de middenplek buiten de echte set, dan een hele ronde terug: zelfde beeld, andere plek. */
      normaliseer() {
        const r = this.ronde;
        const plek = this.middenPlek();
        const begin = r.sets * r.n;
        const rondes = Math.floor((plek - begin) / r.n);
        if (rondes) this.springNaar(this.lijst.scrollLeft - rondes * r.n * r.stap);
        return plek - rondes * r.n;
      }

      /* Een kopie die voor minstens de helft in beeld staat, ruilt van plek met zijn origineel als dat minder dan
         half in beeld is. Beide zien er hetzelfde uit, dus je ziet niets verspringen. */
      ruilKlonen() {
        const z = this.zicht();
        const deel = (el) => {
          const b = el.getBoundingClientRect();
          return b.width ? Math.max(0, Math.min(b.right, z.r) - Math.max(b.left, z.l)) / b.width : 0;
        };
        Array.from(this.lijst.children).forEach((el) => {
          if (!el.hasAttribute('data-lx-kloon') || deel(el) < 0.5) return;
          const origineel = this.alle[Number(el.dataset.lxNr)];
          if (!origineel || deel(origineel) >= 0.5) return;
          this.ruil(el, origineel);
        });
      }

      naScroll() {
        const r = this.ronde;
        if (!r || !this.desktop) return;
        clearTimeout(this._naKlok);
        if (r.doel != null) {
          /* Een pijlstap is nog onderweg. Chrome geeft na een sprong plus een vloeiende scroll soms maar één scrollend,
             al tijdens de scroll; daarom zelf opnieuw kijken tot het doel bereikt is. */
          const nu = this.lijst.scrollLeft;
          /* Staat hij stil maar net naast het doel (vastklikpunt op een halve pixel), dan is hij ook aangekomen. */
          const onderweg = Math.abs(nu - r.doelLinks) > 2 && nu !== r.vorigeLinks;
          r.vorigeLinks = nu;
          if (onderweg && performance.now() - r.doelTijd < 1200) {
            this._naKlok = setTimeout(this.opRondeKlaar, 150);
            return;
          }
          r.doel = null;
        }
        this.normaliseer();
        this.ruilKlonen();
      }

      /* Pijl: één kaart verder, ook als je snel achter elkaar klikt (vanaf het vorige doel). Zou het doel buiten de
         echte set vallen, dan eerst ongemerkt een ronde terugspringen en vandaar verder scrollen. */
      ga(richting) {
        const r = this.ronde;
        if (!r) return;
        r.aangeraakt = true;
        const n = r.n;
        const begin = r.sets * n;
        const vers = r.doel != null && performance.now() - r.doelTijd < 1200;
        let doel = (vers ? r.doel : this.middenPlek()) + richting;
        if (doel < begin || doel > begin + n - 1) {
          const sprong = doel < begin ? n : -n;
          this.springNaar(this.lijst.scrollLeft + sprong * r.stap);
          doel += sprong;
        }
        r.doel = doel;
        r.doelTijd = performance.now();
        r.vorigeLinks = null;
        r.doelLinks = this.scrollVoor(doel);
        this.lijst.scrollTo({ left: r.doelLinks, behavior: rustig() ? 'auto' : 'smooth' });
        clearTimeout(this._naKlok);
        this._naKlok = setTimeout(this.opRondeKlaar, 250);
      }

      /* Desktop, voorvertoning (punt 12a): aan = zonder geluid afspelen als hij stil staat; uit = stil en terug naar
         het begin, behalve als hij na een klik met geluid speelt (die loopt door). Muted betekent hier altijd: het
         is een voorvertoning, want een klik zet het geluid aan. */
      voorproef(clip, aan) {
        const video = clip.querySelector('video');
        if (!video) return;
        if (aan) {
          if (rustig() || zuinig()) return;
          if (!video.paused) return;
          video.muted = true;
          const bezig = video.play();
          if (bezig && typeof bezig.catch === 'function') bezig.catch(() => {});
          return;
        }
        if (!video.muted) return;
        if (!video.paused) video.pause();
        if (video.currentTime > 0) video.currentTime = 0;
      }

      /* Desktop: klik op de video speelt hem af vanaf het begin (met geluid als hij dat heeft), ook als hij al als
         voorvertoning zonder geluid liep; nog een klik zet hem stil. */
      speelDesktop(clip) {
        const video = clip.querySelector('video');
        const knop = clip.querySelector('[data-lx-speel]');
        if (!video) return;
        if (video.paused || video.muted) {
          this.alle.forEach((ander) => {
            if (ander === clip) return;
            const v = ander.querySelector('video');
            const k = ander.querySelector('[data-lx-speel]');
            if (v && !v.paused) v.pause();
            if (k) k.setAttribute('aria-pressed', 'false');
          });
          video.muted = false;
          video.currentTime = 0;
          const bezig = video.play();
          if (bezig && typeof bezig.catch === 'function') bezig.catch(() => {});
          if (knop) knop.setAttribute('aria-pressed', 'true');
        } else {
          video.pause();
          video.muted = true;
          if (knop) knop.setAttribute('aria-pressed', 'false');
        }
      }

      disconnectedCallback() {
        if (!this._klaar) return;
        this._klaar = false;
        this.removeEventListener('click', this.opKlik, true);
        this.removeEventListener('keydown', this.opToets);
        this.lijst.removeEventListener('pointerdown', this.opNeer);
        this.lijst.removeEventListener('pointermove', this.opBeweeg);
        this.lijst.removeEventListener('pointerup', this.opLos);
        this.lijst.removeEventListener('pointercancel', this.opLos);
        this.lijst.removeEventListener('dragstart', this.opSleepBeeld);
        this.lijst.removeEventListener('scrollend', this.opRondeKlaar);
        this.lijst.removeEventListener('scroll', this.opRondeScroll);
        ['wheel', 'pointerdown', 'touchstart', 'keydown'].forEach((type) => this.lijst.removeEventListener(type, this.opRondeHand));
        window.removeEventListener('resize', this.opRondeMaat);
        window.removeEventListener('load', this.opRondeLoad);
        clearTimeout(this._scrollKlok);
        clearTimeout(this._maatKlok);
        clearTimeout(this._naKlok);
        document.removeEventListener('shopify:block:select', this.opBlokKeuze);
        if (this.mq.removeEventListener) this.mq.removeEventListener('change', this.opMaat);
        else if (this.mq.removeListener) this.mq.removeListener(this.opMaat);
        if (this.kijker) this.kijker.disconnect();
        if (this.voorlader) this.voorlader.disconnect();
        this.voorlader = null;
        window.removeEventListener('load', this.startPosters);
        window.removeEventListener('scroll', this.startPosters);
        this.alle.forEach((clip) => {
          const video = clip.querySelector('video');
          if (video) {
            video.removeEventListener('timeupdate', this.opTijd);
            video.pause();
            clip.removeEventListener('pointerenter', this.opBoven);
            clip.removeEventListener('pointerleave', this.opWeg);
            clip.removeEventListener('focusin', this.opFocusIn);
            clip.removeEventListener('focusout', this.opFocusUit);
          }
        });
      }

      /* Plek van clip i ten opzichte van de actieve: 0 is het midden, negatief links, positief rechts (rondlopend). */
      plekVan(i, actief) {
        const n = this.clips.length;
        let plek = (((i - actief) % n) + n) % n;
        if (plek > Math.floor(n / 2)) plek -= n;
        return plek;
      }

      xVan(plek) {
        if (plek === 0) return 0;
        const gap = plek < 0 ? GAP_LINKS : GAP_RECHTS;
        const afstand = ACTIEF / 2 + gap + BUUR / 2 + (Math.abs(plek) - 1) * (BUUR + gap);
        return plek < 0 ? -afstand : afstand;
      }

      zet(index, eerste) {
        const n = this.clips.length;
        if (!n || this.desktop) return;
        this.actief = ((index % n) + n) % n;
        this.clips.forEach((clip, i) => {
          const oud = Number(clip.dataset.lxPlek || 0);
          const plek = this.plekVan(i, this.actief);
          /* Een clip die van de ene naar de andere kant springt, gaat buiten beeld en zonder overgang. */
          const sprong = !eerste && Math.abs(plek - oud) > 1;
          if (sprong) clip.classList.add('is-sprong');
          clip.dataset.lxPlek = String(plek);
          clip.style.setProperty('--lx-x', this.xVan(plek) + 'px');
          const isActief = plek === 0;
          clip.classList.toggle('is-actief', isActief);
          if (isActief) clip.removeAttribute('aria-hidden');
          else clip.setAttribute('aria-hidden', 'true');
          clip.querySelectorAll('a, button').forEach((el) => {
            if (isActief) el.removeAttribute('tabindex');
            else el.setAttribute('tabindex', '-1');
          });
          if (sprong) {
            void clip.offsetWidth;
            requestAnimationFrame(() => clip.classList.remove('is-sprong'));
          }
        });
        if (this.tellerEl) {
          const tekst = this.tellerSjabloon.replace('[nr]', String(this.actief + 1)).replace('[totaal]', String(n));
          if (this.tellerEl.textContent !== tekst) this.tellerEl.textContent = tekst;
        }
        this.werkVideoBij();
      }

      stap(richting) {
        this.zet(this.actief + richting);
      }

      /* Preview zonder geluid in de actieve clip, alleen in beeld; de rest staat stil en zonder geluid. */
      werkVideoBij() {
        if (this.desktop) {
          /* Desktop speelt na een klik of als voorvertoning (muis of focus); uit beeld gaat alles stil. */
          if (!this.inBeeld) {
            this.alle.forEach((clip) => {
              const video = clip.querySelector('video');
              const knop = clip.querySelector('[data-lx-speel]');
              if (video && !video.paused) video.pause();
              if (knop) knop.setAttribute('aria-pressed', 'false');
            });
          }
          return;
        }
        this.clips.forEach((clip, i) => {
          const video = clip.querySelector('video');
          if (!video) return;
          const knop = clip.querySelector('[data-lx-speel]');
          const actief = i === this.actief;
          if (!actief || !this.inBeeld) {
            if (!video.paused) video.pause();
            if (!actief && !video.muted) {
              video.muted = true;
              if (knop) knop.setAttribute('aria-pressed', 'false');
            }
            return;
          }
          if (video.muted && (rustig() || zuinig())) return;
          const bezig = video.play();
          if (bezig && typeof bezig.catch === 'function') bezig.catch(() => {});
        });
      }

      opTijd(event) {
        const video = event.target;
        if (video.muted && video.currentTime >= this.preview) video.currentTime = 0;
      }

      geluid(clip) {
        const video = clip.querySelector('video');
        const knop = clip.querySelector('[data-lx-speel]');
        if (!video) return;
        if (video.muted) {
          video.muted = false;
          video.currentTime = 0;
          const bezig = video.play();
          if (bezig && typeof bezig.catch === 'function') bezig.catch(() => {});
          if (knop) knop.setAttribute('aria-pressed', 'true');
        } else {
          video.muted = true;
          if (knop) knop.setAttribute('aria-pressed', 'false');
          if (rustig() || zuinig()) video.pause();
        }
      }

      opKlik(event) {
        const doel = event.target instanceof Element ? event.target : null;
        if (!doel) return;
        if (this.desktop) {
          const pijl = doel.closest('[data-lx-ronde]');
          if (pijl && this.contains(pijl)) {
            this.ga(Number(pijl.dataset.lxRonde) < 0 ? -1 : 1);
            return;
          }
          const speel = doel.closest('[data-lx-speel]');
          const clipD = speel ? speel.closest('[data-lx-clip], [data-lx-clip-desktop]') : null;
          if (clipD && this.contains(clipD)) this.speelDesktop(clipD);
          return;
        }
        /* Een klik die het einde van een veeg is, telt niet als tik. */
        if (this._veegTijd && performance.now() - this._veegTijd < 400) {
          this._veegTijd = 0;
          event.preventDefault();
          event.stopPropagation();
          return;
        }
        const stapKnop = doel.closest('[data-lx-stap]');
        if (stapKnop && this.contains(stapKnop)) {
          this.stap(Number(stapKnop.dataset.lxStap));
          return;
        }
        const clip = doel.closest('[data-lx-clip]');
        if (!clip || !this.contains(clip)) return;
        const index = this.clips.indexOf(clip);
        if (index !== this.actief) {
          /* Tik op een buur: die komt naar het midden (de link in zijn tag volgt pas als hij actief is). */
          event.preventDefault();
          event.stopPropagation();
          this.zet(index);
          return;
        }
        if (doel.closest('[data-lx-speel]')) this.geluid(clip);
      }

      opToets(event) {
        if (this.desktop) return;
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        const doel = event.target instanceof Element ? event.target : null;
        if (doel && doel.closest('input, textarea, select')) return;
        event.preventDefault();
        this.stap(event.key === 'ArrowLeft' ? -1 : 1);
      }

      opNeer(event) {
        if (this.desktop) return;
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        if (this.clips.length < 2) return;
        /* Een nieuwe aanraking is altijd een nieuwe tik, ook vlak na een veeg. */
        this._veegTijd = 0;
        this.start = { x: event.clientX, y: event.clientY, id: event.pointerId };
        this.slepend = false;
        this.dx = 0;
      }

      opBeweeg(event) {
        if (!this.start || event.pointerId !== this.start.id) return;
        const dx = event.clientX - this.start.x;
        const dy = event.clientY - this.start.y;
        if (!this.slepend) {
          if (Math.abs(dx) < 8 || Math.abs(dx) < Math.abs(dy)) return;
          this.slepend = true;
          this.lijst.classList.add('is-slepend');
          try {
            this.lijst.setPointerCapture(event.pointerId);
          } catch (e) {}
        }
        this.dx = dx;
        this.lijst.style.setProperty('--lx-sleep', dx + 'px');
      }

      opLos(event) {
        if (!this.start || event.pointerId !== this.start.id) return;
        const geveegd = this.slepend;
        const dx = this.dx;
        this.start = null;
        this.slepend = false;
        if (!geveegd) return;
        this._veegTijd = performance.now();
        this.lijst.classList.remove('is-slepend');
        this.lijst.style.removeProperty('--lx-sleep');
        if (Math.abs(dx) >= DREMPEL) this.stap(dx < 0 ? 1 : -1);
      }

      opBlokKeuze(event) {
        if (this.desktop) {
          const clipD = event.target instanceof Element ? event.target.closest('[data-lx-clip], [data-lx-clip-desktop]') : null;
          if (clipD && this.contains(clipD)) clipD.scrollIntoView({ block: 'nearest', inline: 'center' });
          return;
        }
        const clip = event.target instanceof Element ? event.target.closest('[data-lx-clip]') : null;
        const index = clip ? this.clips.indexOf(clip) : -1;
        if (index > -1) this.zet(index);
      }
    }
    customElements.define('lx-home-clips-rij', LxHomeClipsRij);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lx-home-echt"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('lx-home-echt-rij')) return;
    const rustig = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /*
      H08: schuifrij met pijlen en voortgangslijn (opbouw zoals lx-home-modellen), en het video-onderblad:
      een dialog met showModal; sluiten met de greep (desktop: het kruisje), de scrim, Escape of omlaag vegen. De video speelt pas na een
      tik op de afspeelknop en stopt als het blad dichtgaat.
    */
    class LxHomeEchtRij extends HTMLElement {
      connectedCallback() {
        if (this._klaar) return;
        this.rij = this.querySelector('[data-lx-rij]');
        if (!this.rij) return;
        this._klaar = true;
        this.sectie = this.closest('section') || document;
        this.kaarten = Array.from(this.rij.querySelectorAll('[data-lx-kaart]'));
        this.vorige = this.querySelector('[data-lx-vorige]');
        this.volgende = this.querySelector('[data-lx-volgende]');
        this.voortgang = this.querySelector('.lx-home-echt__voortgang');
        this.bladen = Array.from(this.sectie.querySelectorAll('[data-lx-blad]'));
        this.actief = -1;
        this.gepland = false;

        this.opScroll = () => {
          if (this.gepland) return;
          this.gepland = true;
          requestAnimationFrame(() => {
            this.gepland = false;
            this.werkBij();
          });
        };
        this.opKlik = (event) => {
          const doel = event.target instanceof Element ? event.target : null;
          if (!doel) return;
          const pijl = doel.closest('[data-lx-vorige], [data-lx-volgende]');
          if (pijl && this.contains(pijl)) {
            if (pijl.getAttribute('aria-disabled') !== 'true') {
              this.gaNaar(this.actief + (pijl.hasAttribute('data-lx-vorige') ? -1 : 1));
            }
            return;
          }
          /* Een tik op de kaart met video (beeld of tekst) opent het onderblad. */
          const kaart = doel.closest('[data-lx-opent]');
          if (kaart && this.contains(kaart)) this.openBlad(kaart.dataset.lxOpent, kaart.querySelector('[data-lx-blad-open]'));
        };
        this.opFocus = (event) => {
          const doel = event.target instanceof Element ? event.target : null;
          if (!doel || !doel.matches(':focus-visible')) return;
          const kaart = doel.closest('[data-lx-kaart]');
          const index = kaart ? this.kaarten.indexOf(kaart) : -1;
          if (index > -1) this.gaNaar(index, true);
        };
        this.opBlokKeuze = (event) => {
          const kaart = event.target instanceof Element ? event.target.closest('[data-lx-kaart]') : null;
          const index = kaart ? this.kaarten.indexOf(kaart) : -1;
          if (index > -1) this.gaNaar(index, true);
        };

        this.rij.addEventListener('scroll', this.opScroll, { passive: true });
        this.addEventListener('click', this.opKlik);
        this.addEventListener('focusin', this.opFocus);
        document.addEventListener('shopify:block:select', this.opBlokKeuze);
        this.bladen.forEach((blad) => this.koppelBlad(blad));
        this.werkBij();
      }

      disconnectedCallback() {
        if (!this._klaar) return;
        this._klaar = false;
        this.rij.removeEventListener('scroll', this.opScroll);
        this.removeEventListener('click', this.opKlik);
        this.removeEventListener('focusin', this.opFocus);
        document.removeEventListener('shopify:block:select', this.opBlokKeuze);
        this.bladen.forEach((blad) => {
          if (blad.open) blad.close();
        });
        this.ontgrendel();
      }

      beginVan(kaart) {
        return kaart.offsetLeft - this.kaarten[0].offsetLeft;
      }

      gaNaar(index, direct) {
        const kaart = this.kaarten[Math.max(0, Math.min(index, this.kaarten.length - 1))];
        if (!kaart) return;
        this.rij.scrollTo({ left: this.beginVan(kaart), behavior: direct || rustig() ? 'auto' : 'smooth' });
      }

      werkBij() {
        if (!this.kaarten.length) return;
        const links = this.rij.scrollLeft;
        const max = this.rij.scrollWidth - this.rij.clientWidth;
        let index = 0;
        if (max > 0 && links >= max - 2) {
          index = this.kaarten.length - 1;
        } else {
          let kleinste = Infinity;
          this.kaarten.forEach((kaart, i) => {
            const afstand = Math.abs(this.beginVan(kaart) - links);
            if (afstand < kleinste) {
              kleinste = afstand;
              index = i;
            }
          });
        }
        if (index === this.actief) return;
        this.actief = index;
        if (this.vorige) this.vorige.setAttribute('aria-disabled', index === 0 ? 'true' : 'false');
        if (this.volgende) this.volgende.setAttribute('aria-disabled', index === this.kaarten.length - 1 ? 'true' : 'false');
        if (this.voortgang) this.voortgang.style.setProperty('--lx-stap', String(index));
      }

      /* Onderblad */

      koppelBlad(blad) {
        if (blad.dataset.lxGekoppeld) return;
        blad.dataset.lxGekoppeld = 'true';
        blad.addEventListener('click', (event) => {
          const doel = event.target instanceof Element ? event.target : null;
          if (!doel) return;
          // Een tik op de scrim (::backdrop) komt binnen op de dialog zelf; de inhoud vult de dialog helemaal.
          if (doel === blad || doel.closest('[data-lx-blad-sluit]')) {
            this.sluitBlad(blad);
            return;
          }
          if (doel.closest('[data-lx-speel]')) this.speel(blad);
        });
        blad.addEventListener('cancel', (event) => {
          event.preventDefault();
          this.sluitBlad(blad);
        });
        blad.addEventListener('close', () => {
          blad.classList.remove('is-open');
          this.stopVideo(blad);
          this.ontgrendel();
          if (this.opener) this.opener.focus({ preventScroll: true });
          this.opener = null;
        });
        /* Omlaag vegen vanaf de bovenkant van het blad sluit het. */
        let beginY = null;
        blad.addEventListener('touchstart', (event) => {
          beginY = blad.scrollTop <= 0 && event.touches.length === 1 ? event.touches[0].clientY : null;
        }, { passive: true });
        blad.addEventListener('touchmove', (event) => {
          if (beginY === null) return;
          const dy = event.touches[0].clientY - beginY;
          if (dy > 0) blad.style.transform = `translateY(${dy}px)`;
        }, { passive: true });
        blad.addEventListener('touchend', (event) => {
          if (beginY === null) return;
          const dy = event.changedTouches[0].clientY - beginY;
          beginY = null;
          blad.style.transform = '';
          if (dy > 80) this.sluitBlad(blad);
        });
      }

      openBlad(id, opener) {
        const blad = this.bladen.find((b) => b.id === id);
        if (!blad || blad.open || typeof blad.showModal !== 'function') return;
        if (document.querySelector('dialog[open]')) return;
        this.opener = opener || null;
        /* Poster pas laden bij openen: anders laadt hij mee met de hero (Lighthouse 05-10). */
        const vid = blad.querySelector('video[data-poster]');
        if (vid && !vid.poster) vid.poster = vid.dataset.poster;
        blad.showModal();
        this.vergrendel();
        if (!rustig()) blad.getBoundingClientRect();
        blad.classList.add('is-open');
        /* Eerste zichtbare sluitknop: de greep op mobiel, het kruisje op desktop. */
        const sluit = Array.from(blad.querySelectorAll('[data-lx-blad-sluit]')).find((el) => el.getClientRects().length > 0);
        const knop = blad.querySelector('[data-lx-speel]') || sluit;
        if (knop) knop.focus({ preventScroll: true });
      }

      sluitBlad(blad) {
        if (!blad.open) return;
        blad.classList.remove('is-open');
        this.stopVideo(blad);
        if (rustig()) {
          blad.close();
          return;
        }
        let klaar = false;
        const dicht = () => {
          if (klaar) return;
          klaar = true;
          if (blad.open) blad.close();
        };
        blad.addEventListener('transitionend', (event) => {
          if (event.target === blad) dicht();
        }, { once: true });
        setTimeout(dicht, 400);
      }

      speel(blad) {
        const video = blad.querySelector('[data-lx-video]');
        const vak = blad.querySelector('[data-lx-video-vak]');
        if (!video) return;
        video.controls = true;
        if (vak) vak.classList.add('is-speelt');
        const poging = video.play();
        if (poging && typeof poging.catch === 'function') poging.catch(() => {});
        video.focus({ preventScroll: true });
      }

      stopVideo(blad) {
        const video = blad.querySelector('[data-lx-video]');
        if (video && !video.paused) video.pause();
      }

      vergrendel() {
        if (this.vergrendeld) return;
        const html = document.documentElement;
        this.vorigeOverflow = html.style.overflow;
        html.style.overflow = 'hidden';
        this.vergrendeld = true;
      }

      ontgrendel() {
        if (!this.vergrendeld) return;
        document.documentElement.style.overflow = this.vorigeOverflow || '';
        this.vergrendeld = false;
      }
    }
    customElements.define('lx-home-echt-rij', LxHomeEchtRij);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lx-home-modellen"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('lx-home-modellen-rij')) return;
    const rustig = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* Stippen en pijlen volgen de schuifrij en zijn knoppen; opbouw zoals lx-zakelijk-modellen. */
    class LxHomeModellenRij extends HTMLElement {
      connectedCallback() {
        if (this._klaar) return;
        this.rij = this.querySelector('[data-lx-rij]');
        if (!this.rij) return;
        this._klaar = true;
        this.kaarten = Array.from(this.rij.querySelectorAll('[data-lx-kaart]'));
        this.stippen = Array.from(this.querySelectorAll('[data-lx-stip]'));
        this.vorige = this.querySelector('[data-lx-vorige]');
        this.volgende = this.querySelector('[data-lx-volgende]');
        this.actief = -1;
        this.gepland = false;
        this.opScroll = () => {
          if (this.gepland) return;
          this.gepland = true;
          requestAnimationFrame(() => {
            this.gepland = false;
            this.werkBij();
          });
        };
        this.opKlik = (event) => {
          const doel = event.target instanceof Element ? event.target : null;
          if (!doel) return;
          const stip = doel.closest('[data-lx-stip]');
          if (stip && this.contains(stip)) {
            this.gaNaar(Number(stip.dataset.lxStip));
            return;
          }
          const kleur = doel.closest('[data-lx-kleur-knop]');
          if (kleur && this.contains(kleur)) {
            this.kiesKleur(kleur);
            return;
          }
          const pijl = doel.closest('[data-lx-vorige], [data-lx-volgende]');
          if (!pijl || !this.contains(pijl) || pijl.getAttribute('aria-disabled') === 'true') return;
          this.gaNaar(this.actief + (pijl.hasAttribute('data-lx-vorige') ? -1 : 1));
        };
        /* Met Tab naar een kaart die half buiten beeld staat: die kaart naar voren. */
        this.opFocus = (event) => {
          const doel = event.target instanceof Element ? event.target : null;
          if (!doel || !doel.matches(':focus-visible')) return;
          const kaart = doel.closest('[data-lx-kaart]');
          const index = kaart ? this.kaarten.indexOf(kaart) : -1;
          if (index > -1) this.gaNaar(index, true);
        };
        this.opBlokKeuze = (event) => {
          const kaart = event.target instanceof Element ? event.target.closest('[data-lx-kaart]') : null;
          const index = kaart ? this.kaarten.indexOf(kaart) : -1;
          if (index > -1) this.gaNaar(index, true);
        };
        /* Wie naar de bolletjes gaat, wil misschien zwart zien: dat beeld alvast laden (zoals lx-categorie-modellen). */
        this.opVoorladen = (event) => {
          const groep = event.target instanceof Element ? event.target.closest('[data-lx-kleuren]') : null;
          const kaart = groep ? groep.closest('[data-lx-kaart]') : null;
          if (!kaart) return;
          kaart.querySelectorAll('img[loading="lazy"]').forEach((img) => {
            img.loading = 'eager';
          });
        };
        /* De zwarte beelden laden zodra de rij bijna in beeld is, zodat een tik op zwart nooit een leeg vak geeft.
           Pas na het load-event, zodat ze de rest van de pagina niet ophouden. */
        this.startVoorlader = () => {
          if (!this._klaar || !('IntersectionObserver' in window)) return;
          if (!this.querySelector('[data-lx-kleur] img[loading="lazy"]')) return;
          this.voorlader = new IntersectionObserver(
            (items) => {
              if (!items.some((item) => item.isIntersecting)) return;
              this.querySelectorAll('[data-lx-kleur] img[loading="lazy"]').forEach((img) => {
                img.loading = 'eager';
              });
              this.voorlader.disconnect();
            },
            { rootMargin: '200px 0px' }
          );
          this.voorlader.observe(this.rij);
        };
        if (document.readyState === 'complete') this.startVoorlader();
        else window.addEventListener('load', this.startVoorlader, { once: true });

        this.rij.addEventListener('scroll', this.opScroll, { passive: true });
        this.addEventListener('click', this.opKlik);
        this.addEventListener('focusin', this.opFocus);
        this.addEventListener('pointerover', this.opVoorladen);
        this.addEventListener('focusin', this.opVoorladen);
        document.addEventListener('shopify:block:select', this.opBlokKeuze);
        this.werkBij();
      }

      disconnectedCallback() {
        if (!this._klaar) return;
        this._klaar = false;
        this.rij.removeEventListener('scroll', this.opScroll);
        this.removeEventListener('click', this.opKlik);
        this.removeEventListener('focusin', this.opFocus);
        this.removeEventListener('pointerover', this.opVoorladen);
        this.removeEventListener('focusin', this.opVoorladen);
        if (this.voorlader) this.voorlader.disconnect();
        window.removeEventListener('load', this.startVoorlader);
        document.removeEventListener('shopify:block:select', this.opBlokKeuze);
      }

      /* Wit of zwart: alleen `hidden` en aria-pressed wisselen; beeld, prijs, leverregel en link staan al klaar. */
      kiesKleur(knop) {
        const kaart = knop.closest('[data-lx-kaart]');
        if (!kaart) return;
        const kleur = knop.dataset.lxKleurKnop;
        kaart.querySelectorAll('[data-lx-kleur-knop]').forEach((k) => {
          k.setAttribute('aria-pressed', k === knop ? 'true' : 'false');
        });
        kaart.querySelectorAll('[data-lx-kleur]').forEach((deel) => {
          deel.hidden = deel.dataset.lxKleur !== kleur;
        });
      }

      beginVan(kaart) {
        return kaart.offsetLeft - this.kaarten[0].offsetLeft;
      }

      gaNaar(index, direct) {
        const kaart = this.kaarten[Math.max(0, Math.min(index, this.kaarten.length - 1))];
        if (!kaart) return;
        this.rij.scrollTo({ left: this.beginVan(kaart), behavior: direct || rustig() ? 'auto' : 'smooth' });
      }

      werkBij() {
        if (!this.kaarten.length) return;
        const links = this.rij.scrollLeft;
        const max = this.rij.scrollWidth - this.rij.clientWidth;
        let index = 0;
        if (max > 0 && links >= max - 2) {
          index = this.kaarten.length - 1;
        } else {
          let kleinste = Infinity;
          this.kaarten.forEach((kaart, i) => {
            const afstand = Math.abs(this.beginVan(kaart) - links);
            if (afstand < kleinste) {
              kleinste = afstand;
              index = i;
            }
          });
        }
        if (this.vorige) this.vorige.setAttribute('aria-disabled', links <= 2 ? 'true' : 'false');
        if (this.volgende) this.volgende.setAttribute('aria-disabled', max <= 0 || links >= max - 2 ? 'true' : 'false');
        if (index === this.actief) return;
        this.actief = index;
        this.stippen.forEach((stip, i) => {
          if (i === index) stip.setAttribute('aria-current', 'true');
          else stip.removeAttribute('aria-current');
        });
      }
    }
    customElements.define('lx-home-modellen-rij', LxHomeModellenRij);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lx-home-reviews"] && !Shopify.designMode) return;
  try {
    
  /* Startpositie van de doorlopende rijen: de eerste kaart van rij 1 staat bij het laden op de rand van de inhoud
     (zoals Figma), rij 2 een halve kaart verder (data-start). Snelheid overal gelijk en rustig: 25 px per seconde,
     zoals lx-trustpilot. Lopen, pauzeren en verslepen zit in lx-carrousel.js (.lx-loop); deze sectie geeft alleen de startpositie door (data-fase). */
  (function () {
    function zet(sectie) {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var kolom = sectie.querySelector('[data-lx-home-reviews-kolom]');
      if (!kolom) return;
      var stijl = getComputedStyle(kolom);
      var rand = kolom.getBoundingClientRect().left + parseFloat(stijl.paddingLeft || 0);
      sectie.querySelectorAll('[data-lx-home-reviews-loop]').forEach(function (loop) {
        if (!loop.offsetParent) return;
        var baan = loop.querySelector('.lx-loop__baan');
        if (!baan) return;
        var kaarten = baan.children;
        var helft = kaarten.length / 2;
        if (!helft || !kaarten[helft]) return;
        var d = kaarten[helft].offsetLeft - kaarten[0].offsetLeft;
        if (d <= 0) return;
        var m = rand - loop.getBoundingClientRect().left + (parseFloat(loop.dataset.start) || 0);
        var f = loop.dataset.richting === 'rechts' ? (((m % d) + d) % d) / d : ((((d - m) % d) + d) % d) / d;
        loop.dataset.fase = f.toFixed(4);
        loop.dispatchEvent(new CustomEvent('lx-loop:fase'));
      });
    }
    function alles() {
      document.querySelectorAll('.lx-home-reviews').forEach(function (sectie) {
        if (sectie.dataset.lxHomeReviewsKlaar) return;
        sectie.dataset.lxHomeReviewsKlaar = '1';
        zet(sectie);
        var breedte = window.innerWidth;
        window.addEventListener('resize', function () {
          if (window.innerWidth === breedte) return;
          breedte = window.innerWidth;
          zet(sectie);
        });
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', alles);
    else alles();
    document.addEventListener('shopify:section:load', alles);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lx-home-vragen"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('lx-home-vragen-accordeon')) return;

    class LxHomeVragenAccordeon extends HTMLElement {
      constructor() {
        super();
        this.bijBlokSelectie = this.bijBlokSelectie.bind(this);
      }

      connectedCallback() {
        this.addEventListener('click', this);
        document.addEventListener('shopify:block:select', this.bijBlokSelectie);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this);
        document.removeEventListener('shopify:block:select', this.bijBlokSelectie);
      }

      handleEvent(event) {
        const knop = event.target instanceof Element ? event.target.closest('[data-lx-home-vraag-knop]') : null;
        if (!knop || !this.contains(knop)) return;
        const item = knop.closest('[data-lx-home-vraag]');
        if (item) this.zet(item, knop.getAttribute('aria-expanded') !== 'true');
      }

      /* In de theme editor: een gekozen vraag klapt open, zodat je ziet wat je bewerkt. */
      bijBlokSelectie(event) {
        const item = event.target instanceof Element ? event.target.closest('[data-lx-home-vraag]') : null;
        if (item && this.contains(item)) this.zet(item, true);
      }

      zet(item, open) {
        const knop = item.querySelector('[data-lx-home-vraag-knop]');
        if (knop) knop.setAttribute('aria-expanded', open ? 'true' : 'false');
        item.toggleAttribute('data-open', open);
      }
    }

    customElements.define('lx-home-vragen-accordeon', LxHomeVragenAccordeon);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lx-keuzehulp"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('lx-keuzehulp')) return;

    const rustig = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const VOLGORDE = ['one', 'neo', 'air'];

    /* €130 of €1.396; centen alleen als ze er zijn (zoals money_without_trailing_zeros). */
    const geld = (centen) => {
      const euro = Math.floor(Math.abs(centen) / 100);
      const rest = Math.abs(centen) % 100;
      const heel = String(euro).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      return '€' + heel + (rest ? ',' + String(rest).padStart(2, '0') : '');
    };
    const vul = (tekst, waarden) =>
      String(tekst || '').replace(/\[(\w+)\]/g, (heel, sleutel) => (sleutel in waarden ? waarden[sleutel] : heel));
    const meld = (naam, gegevens) => {
      try {
        if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
          Shopify.analytics.publish(naam, gegevens);
        }
      } catch (e) {
        /* meten mag de keuzehulp nooit stoppen */
      }
    };

    class LxKeuzehulp extends HTMLElement {
      connectedCallback() {
        if (this._klaar) return;
        const bron = this.querySelector('[data-lx-gegevens]');
        if (!bron) return;
        try {
          this.gegevens = JSON.parse(bron.textContent);
        } catch (e) {
          return;
        }
        this._klaar = true;
        this.schermen = Array.from(this.querySelectorAll('[data-lx-scherm]'));
        this.vraagSchermen = this.schermen.filter((s) => s.dataset.lxScherm === 'vraag');
        this.antwoorden = new Array(this.vraagSchermen.length).fill(-1);
        /* Het script van lx-categorie-modellen laadt Shopify alleen waar die sectie zelf staat. Ontbreekt het, dan doet
           de keuzehulp de kleurwissel en de winkelwagen van de kaart zelf (zelfde gedrag). Zonder JavaScript blijft
           het <form> de terugval. */
        this.kaartZelf = !customElements.get('lx-categorie-modellen');
        const formulieren = this.kaartZelf ? 'form[data-lx-erbij-koop], form[data-lx-koop]' : 'form[data-lx-erbij-koop]';
        this.querySelectorAll(formulieren).forEach((form) => form.removeAttribute('action'));

        this.opKlik = (event) => {
          const doel = event.target instanceof Element ? event.target : null;
          if (!doel) return;
          if (doel.closest('[data-lx-start]')) return this.toonVraag(0);
          const kleur = doel.closest('[data-lx-kleur-knop]');
          if (kleur && this.kaartZelf && this.contains(kleur)) return this.kiesKleur(kleur);
          const optie = doel.closest('[data-lx-antwoord]');
          if (optie && this.contains(optie)) return this.kies(optie);
          if (doel.closest('[data-lx-terug]')) return this.terug();
          if (doel.closest('[data-lx-aanpassen]')) return this.toonVraag(0);
          if (doel.closest('[data-lx-opnieuw]')) {
            this.antwoorden.fill(-1);
            this.vraagSchermen.forEach((s) =>
              s.querySelectorAll('[data-lx-antwoord]').forEach((o) => o.setAttribute('aria-pressed', 'false'))
            );
            return this.toonVraag(0);
          }
        };
        this.opVersturen = (event) => this.erbijToevoegen(event);
        this.opTerugNaarPagina = (event) => {
          if (!event.persisted) return;
          this.querySelectorAll('form[data-bezig]').forEach((form) => {
            form.removeAttribute('data-bezig');
            const knop = form.querySelector('[data-lx-knop]');
            if (knop) {
              knop.disabled = form.hasAttribute('data-uitverkocht');
              knop.removeAttribute('aria-busy');
            }
          });
        };
        window.addEventListener('pageshow', this.opTerugNaarPagina);
        this.addEventListener('click', this.opKlik);
        this.addEventListener('submit', this.opVersturen);
      }

      disconnectedCallback() {
        if (!this._klaar) return;
        this._klaar = false;
        this.removeEventListener('click', this.opKlik);
        this.removeEventListener('submit', this.opVersturen);
        window.removeEventListener('pageshow', this.opTerugNaarPagina);
      }

      toon(scherm) {
        this.schermen.forEach((s) => {
          s.hidden = s !== scherm;
        });
        const sectie = this.closest('section') || this;
        const boven = sectie.getBoundingClientRect().top;
        if (boven < 0 || boven > window.innerHeight * 0.5) {
          sectie.scrollIntoView({ block: 'start', behavior: rustig() ? 'auto' : 'smooth' });
        }
        const focus = scherm.querySelector('[data-lx-focus]:not([hidden]), .lx-keuzehulp__uitkomst-kop:not([hidden])');
        if (focus) focus.focus({ preventScroll: true });
      }

      toonVraag(index) {
        this.huidig = index;
        this.toon(this.vraagSchermen[index]);
        meld('lx_keuzehulp_stap', { stap: index + 1 });
      }

      terug() {
        if (!this.huidig) return this.toon(this.schermen.find((s) => s.dataset.lxScherm === 'intro'));
        this.toonVraag(this.huidig - 1);
      }

      kies(optie) {
        if (this.bezig) return;
        const scherm = optie.closest('[data-lx-vraag]');
        const v = Number(scherm.dataset.lxVraag);
        scherm.querySelectorAll('[data-lx-antwoord]').forEach((o) => o.setAttribute('aria-pressed', o === optie ? 'true' : 'false'));
        this.antwoorden[v] = Number(optie.dataset.lxAntwoord);
        /* Even de gekozen stand laten zien (669:918), dan door. */
        this.bezig = true;
        window.setTimeout(() => {
          this.bezig = false;
          if (v + 1 < this.vraagSchermen.length) this.toonVraag(v + 1);
          else this.toonUitkomst();
        }, rustig() ? 0 : 260);
      }

      gekozen() {
        return this.antwoorden.map((a, v) => (a > -1 ? this.gegevens.vragen[v].antwoorden[a] : null));
      }

      /* «0/1/1» of «x/1/3» → [0,1,1] of [null,1,3] (null = valt af) */
      punten(antwoord) {
        const delen = String((antwoord && antwoord.punten) || '').split('/');
        return VOLGORDE.map((m, i) => {
          const d = (delen[i] || '0').trim().toLowerCase();
          if (d === 'x') return null;
          const n = Number(d);
          return Number.isFinite(n) ? n : 0;
        });
      }

      bereken() {
        const keuzes = this.gekozen();
        const vragen = this.gegevens.vragen;
        // VISION: bij elke vraag met een VISION-antwoord is dat antwoord gekozen.
        const sleutelVragen = vragen.filter((v) => v.antwoorden.some((a) => a.vision));
        const vision =
          sleutelVragen.length > 0 &&
          vragen.every((v, i) => !v.antwoorden.some((a) => a.vision) || (keuzes[i] && keuzes[i].vision));

        const totaal = [0, 0, 0];
        const af = [false, false, false];
        keuzes.forEach((a) => {
          if (!a) return;
          this.punten(a).forEach((p, i) => {
            if (p === null) af[i] = true;
            else totaal[i] += p;
          });
        });
        const kandidaten = [0, 1, 2].filter((i) => !af[i]);
        const lijst = kandidaten.length ? kandidaten : [0, 1, 2];
        let winnaar = lijst[0];
        lijst.forEach((i) => {
          if (totaal[i] > totaal[winnaar]) winnaar = i;
        });
        const rest = lijst.filter((i) => i !== winnaar).sort((x, y) => totaal[y] - totaal[x] || x - y);

        if (vision) return { model: 'vision', alt: 'air', keuzes, totaal, af };
        return { model: VOLGORDE[winnaar], alt: rest.length ? VOLGORDE[rest[0]] : null, keuzes, totaal, af, winnaar };
      }

      budgetZin(uitkomst) {
        const modellen = this.gegevens.modellen;
        const t = this.gegevens.teksten;
        const budgetAntwoord = uitkomst.keuzes.find((a) => a && Number(a.budget) > 0);
        const winnaar = modellen[uitkomst.model];
        if (!budgetAntwoord || !winnaar) return null;
        const grens = Number(budgetAntwoord.budget) * 100;
        if (winnaar.prijs <= grens) return null;
        // Het duurste model binnen het budget (ook als het afviel).
        let goedkoper = -1;
        VOLGORDE.forEach((m, i) => {
          if (modellen[m] && modellen[m].prijs <= grens) goedkoper = i;
        });
        if (goedkoper < 0) return null;
        const w = VOLGORDE.indexOf(uitkomst.model);
        let beste = null;
        let besteVerschil = 0;
        uitkomst.keuzes.forEach((a) => {
          if (!a || !a.reden || Number(a.budget) > 0) return;
          const p = this.punten(a);
          if (p[goedkoper] === null) {
            if (besteVerschil !== Infinity) {
              beste = a;
              besteVerschil = Infinity;
            }
            return;
          }
          const verschil = (w > -1 && p[w] !== null ? p[w] : 0) - p[goedkoper];
          if (verschil > besteVerschil) {
            beste = a;
            besteVerschil = verschil;
          }
        });
        const naamGoedkoper = modellen[VOLGORDE[goedkoper]].naam;
        const verschil = geld(winnaar.prijs - modellen[VOLGORDE[goedkoper]].prijs);
        const waarden = { model: winnaar.naam, goedkoper: naamGoedkoper, verschil: verschil };
        const reden = beste ? vul(beste.reden, waarden) : vul(t.budgetStandaard, waarden);
        const slot = w === goedkoper + 1 ? vul(t.budgetDicht, waarden) : vul(t.budgetVer, waarden);
        return { kop: budgetAntwoord.budgetKop, tekst: (reden + ' ' + slot).trim() };
      }

      toonUitkomst() {
        const uitkomst = this.bereken();
        const modellen = this.gegevens.modellen;
        const t = this.gegevens.teksten;
        const scherm = this.schermen.find((s) => s.dataset.lxScherm === 'uitkomst');

        scherm.querySelectorAll('[data-lx-model-deel]').forEach((deel) => {
          deel.hidden = deel.dataset.lxModelDeel !== uitkomst.model;
        });

        const chips = scherm.querySelector('[data-lx-chips]');
        chips.textContent = '';
        uitkomst.keuzes.forEach((a) => {
          if (!a || !a.kort) return;
          const li = document.createElement('li');
          li.className = 'lx-keuzehulp__chip lx-tekst-klein';
          li.textContent = a.kort;
          chips.appendChild(li);
        });

        const budget = scherm.querySelector('[data-lx-budget]');
        const zin = this.budgetZin(uitkomst);
        budget.hidden = !zin;
        if (zin) {
          budget.querySelector('[data-lx-budget-kop]').textContent = zin.kop || '';
          budget.querySelector('[data-lx-budget-tekst]').textContent = zin.tekst;
        }

        const ook = scherm.querySelector('[data-lx-ook]');
        const alt = uitkomst.alt && modellen[uitkomst.alt];
        const win = modellen[uitkomst.model];
        ook.hidden = !(alt && win);
        if (alt && win) {
          const omhoog = alt.prijs > win.prijs;
          const waarden = {
            model: alt.naam,
            prijs: geld(alt.prijs),
            verschil: geld(alt.prijs - win.prijs),
          };
          ook.querySelector('[data-lx-ook-kop]').textContent = vul(t.ookKop, waarden);
          ook.querySelector('[data-lx-ook-tekst]').textContent = omhoog ? alt.omhoog : alt.omlaag;
          ook.querySelector('[data-lx-ook-prijs]').textContent = vul(omhoog ? t.ookMeer : t.ookMinder, waarden);
          ook.querySelector('[data-lx-ook-link]').href = alt.url || '#';
          ook.querySelector('[data-lx-ook-link-tekst]').textContent = vul(t.ookLink, waarden);
        }

        // Past erbij: licht in de kamer → scherm; slaapkamer → tafelstatief; onderweg → statief; anders scherm.
        const soorten = uitkomst.keuzes.map((a) => (a && a.erbij) || 'geen');
        let soort = 'standaard';
        if (soorten.includes('licht')) soort = 'licht';
        else if (soorten.includes('slaapkamer')) soort = 'slaapkamer';
        else if (soorten.includes('onderweg')) soort = 'onderweg';
        let gevonden = false;
        scherm.querySelectorAll('[data-lx-erbij]').forEach((kaart) => {
          const doel = soort === 'standaard' ? 'licht' : soort;
          const tonen = !gevonden && kaart.dataset.lxErbij === doel;
          kaart.hidden = !tonen;
          if (tonen) {
            gevonden = true;
            const regel = kaart.querySelector('[data-lx-erbij-tekst]');
            if (regel) {
              if (!regel.dataset.eigen) regel.dataset.eigen = regel.textContent;
              regel.textContent = soort === 'standaard' && regel.dataset.standaard ? regel.dataset.standaard : regel.dataset.eigen;
            }
          }
        });

        this.huidig = this.vraagSchermen.length;
        this.toon(scherm);
        meld('lx_keuzehulp_uitkomst', {
          model: uitkomst.model,
          alternatief: uitkomst.alt,
          antwoorden: uitkomst.keuzes.map((a) => (a ? a.kort : null)),
        });
      }

      /* Zoals lx-categorie-modellen: alleen `hidden` en aria-pressed wisselen; beeld, prijs, formulier en link staan klaar. */
      kiesKleur(knop) {
        const kaart = knop.closest('[data-lx-kaart]');
        if (!kaart) return;
        const kleur = knop.dataset.lxKleurKnop;
        kaart.querySelectorAll('[data-lx-kleur-knop]').forEach((k) => k.setAttribute('aria-pressed', k === knop ? 'true' : 'false'));
        kaart.querySelectorAll('[data-lx-kleur]').forEach((deel) => {
          deel.hidden = deel.dataset.lxKleur !== kleur;
        });
      }

      async erbijToevoegen(event) {
        const form = event.target;
        if (!(form instanceof HTMLFormElement)) return;
        const isKaart = form.hasAttribute('data-lx-koop');
        if (!form.hasAttribute('data-lx-erbij-koop') && !(isKaart && this.kaartZelf)) return;
        event.preventDefault();
        if (form.hasAttribute('data-uitverkocht')) return;
        if (form.hasAttribute('data-bezig')) return;
        const veld = form.querySelector('input[name="id"]');
        const id = veld ? Number(veld.value) : 0;
        if (!id) return;
        const kaart = form.closest('[data-lx-erbij]');
        const fout = form.querySelector('[data-lx-fout]') || (kaart ? kaart.querySelector('[data-lx-fout]') : null);
        if (fout) fout.hidden = true;
        const knop = form.querySelector('[data-lx-knop]');
        form.setAttribute('data-bezig', '');
        if (knop) {
          knop.disabled = true;
          knop.setAttribute('aria-busy', 'true');
        }
        const klaar = () => {
          form.removeAttribute('data-bezig');
          if (knop) {
            knop.disabled = form.hasAttribute('data-uitverkocht');
            knop.removeAttribute('aria-busy');
          }
        };
        const wagen = this.dataset.wagen || '/cart';
        // Zoals lx-koop en de modelkaarten: de winkelwagenlade (lx-wagen) komt met het antwoord mee en gaat open.
        const lade = document.querySelector('lx-wagen[data-modus="lade"]');
        const sectie = lade && typeof lade.toonMet === 'function' ? lade.dataset.sectie : '';
        const lichaam = { items: [{ id: id, quantity: 1 }] };
        if (sectie) lichaam.sections = sectie;
        try {
          const antwoord = await fetch((this.dataset.toevoegen || '/cart/add') + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(lichaam),
          });
          const json = await antwoord.json().catch(() => ({}));
          if (!antwoord.ok || json.status) {
            const e = new Error(typeof json.description === 'string' ? json.description : '');
            e.vanShopify = true;
            throw e;
          }
          if (sectie && json.sections && json.sections[sectie]) {
            klaar();
            lade.toonMet(json.sections[sectie], knop);
            window.dispatchEvent(new CustomEvent('lx:cart:updated'));
            return;
          }
          window.dispatchEvent(new CustomEvent('lx:cart:updated'));
          window.location.assign(wagen);
        } catch (e) {
          klaar();
          if (fout) {
            fout.textContent = (e && e.vanShopify && e.message) || this.dataset.fout || '';
            fout.hidden = false;
          }
        }
      }
    }

    customElements.define('lx-keuzehulp', LxKeuzehulp);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lx-koop"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lx-koop-formulier')) {
    class LxKoopFormulier extends HTMLElement {
      // Luisteren op het element zelf: submit bubbelt op. Zo werkt het ook als het element
      // gedefinieerd wordt voordat zijn formulier geparst is; alles wordt pas bij gebruik opgezocht.
      connectedCallback() {
        this.bezig = false;
        this.levering = '';
        if (this.hasAttribute('data-levertijd-wacht') && this.dataset.levertijdEan) this.haalLevertijd();
        this.addEventListener('submit', this.opVersturen);
        this.addEventListener('change', this.opWissel);
        window.addEventListener('pageshow', this.opTerug);
        // De action blijft in de HTML als terugval zonder JavaScript. Met JavaScript gaat hij eraf: anders telt
        // Shopify's pixelbeheer de submit als een extra product_added_to_cart (zonder product.url, waarop de
        // Clarity-pixel vastloopt), naast de toevoeging via /cart/add.js. Gemeten 01-10-2026 op de categoriepagina.
        // Het formulier kan nog niet geparst zijn; dan na DOMContentLoaded.
        const actionWeg = () => {
          const form = this.formulier;
          if (form) form.removeAttribute('action');
        };
        actionWeg();
        if (!this.formulier) document.addEventListener('DOMContentLoaded', actionWeg, { once: true });
        // Bij laden één keer de standaarddeal melden (lx:deal-gekozen), als de radio's er zijn.
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.meldDeal(), { once: true });
        } else {
          setTimeout(() => this.meldDeal(), 0);
        }
      }

      disconnectedCallback() {
        this.removeEventListener('submit', this.opVersturen);
        this.removeEventListener('change', this.opWissel);
        window.removeEventListener('pageshow', this.opTerug);
      }

      get formulier() {
        return this.querySelector('form');
      }

      get knop() {
        return this.querySelector('[data-lx-koop-knop]');
      }

      get foutregel() {
        return this.querySelector('[data-lx-koop-fout]');
      }

      get uitverkocht() {
        return this.hasAttribute('data-uitverkocht') || this.hasAttribute('data-levertijd-wacht');
      }

      // Levertijd bij voorraad 0 (Dion 13-10-2026, ADR 0237 in het dashboard): het dashboard geeft per EAN het aantal
      // dagen (eerstvolgende aankomst + 7) of null als er niets besteld is. Geen antwoord binnen 5 seconden telt als
      // null: liever «Uitverkocht» dan een belofte die we niet kennen.
      async haalLevertijd() {
        const ean = this.dataset.levertijdEan;
        let dagen = null;
        try {
          const stop = new AbortController();
          const wekker = setTimeout(() => stop.abort(), 5000);
          const antwoord = await fetch(`${this.dataset.levertijdUrl}?ean=${encodeURIComponent(ean)}`, {
            signal: stop.signal,
            credentials: 'omit',
            headers: { Accept: 'application/json' },
          });
          clearTimeout(wekker);
          if (antwoord.ok) {
            const json = await antwoord.json();
            const waarde = json && json.levertijd ? json.levertijd[ean] : null;
            if (typeof waarde === 'number' && waarde >= 0) dagen = waarde;
          }
        } catch (e) {
          dagen = null;
        }
        this.zetLevertijd(dagen);
      }

      zetLevertijd(dagen) {
        this.removeAttribute('data-levertijd-wacht');
        const sectie = this.closest('.lx-koop');
        const regel = this.querySelector('[data-lx-levertijd]');
        const zeker = sectie ? sectie.querySelector('[data-lx-zeker-levering]') : null;
        if (dagen === null) {
          this.levering = '';
          this.setAttribute('data-uitverkocht', '');
          if (this.knop) {
            this.knop.disabled = true;
            this.knop.textContent = this.dataset.levertijdUit || '';
          }
          if (regel) regel.hidden = true;
          if (zeker) zeker.textContent = this.dataset.levertijdUitZeker || '';
          const balk = sectie ? sectie.querySelector('lx-koop-balk') : null;
          if (balk) balk.hidden = true;
          return;
        }
        // Tot drie weken in dagen, daarboven in hele weken (naar boven afgerond).
        // Eenheden uit de taalbestanden (lx.dagen, lx.weken), zodat /en «7 days» toont.
        const tijd = dagen <= 21
          ? `${dagen} ${this.dataset.woordDagen || 'dagen'}`
          : `${Math.ceil(dagen / 7)} ${this.dataset.woordWeken || 'weken'}`;
        this.levering = `binnen ${tijd}`;
        if (regel) {
          regel.textContent = (this.dataset.levertijdTekst || '').replace('[tijd]', tijd);
          regel.hidden = false;
        }
        if (zeker) zeker.textContent = (this.dataset.levertijdZeker || '').replace('[tijd]', tijd);
        this.zetBezig(false);
      }

      // De sticky koopbalk volgt het formulier via deze events (ze bubbelen): lx:deal, lx:koop:bezig, lx:koop:fout.
      meld(naam, detail) {
        this.dispatchEvent(new CustomEvent(naam, { bubbles: true, detail }));
      }

      // Afspraak tussen secties (nachtbouw 12/13-10-2026): de accessoires in de gekozen deal staan op
      // <html data-lx-deal-producten="handle,handle"> en gaan mee met het event lx:deal-gekozen op document.
      // lx-cross-sell verbergt die. Zonder dealkiezer (VISION, accessoires): een lege lijst.
      meldDeal() {
        const keuze = this.querySelector('input[name="properties[_deal]"]:checked');
        const producten = ((keuze && keuze.dataset.producten) || '').split(',').filter(Boolean);
        document.documentElement.dataset.lxDealProducten = producten.join(',');
        document.dispatchEvent(new CustomEvent('lx:deal-gekozen', { detail: { producten } }));
      }

      opWissel = (event) => {
        const invoer = event.target;
        if (!invoer || invoer.name !== 'properties[_deal]' || !invoer.checked) return;
        // 08b: alleen de extra's van deze deal; aangevinkte extra's van een andere deal vallen weg.
        this.querySelectorAll('[data-lx-upsell]').forEach((groep) => {
          const aan = groep.dataset.lxUpsell === invoer.value;
          groep.hidden = !aan;
          if (!aan) groep.querySelectorAll('input[data-lx-upsell-variant]').forEach((vak) => (vak.checked = false));
        });
        this.meld('lx:deal', { deal: invoer.value });
        this.meldDeal();
      };

      opTerug = (event) => {
        if (event.persisted) {
          this.zetBezig(false);
          this.meldDeal();
        }
      };

      zetBezig(bezig) {
        this.bezig = bezig;
        const knop = this.knop;
        if (knop) {
          knop.disabled = bezig || this.uitverkocht;
          if (bezig) {
            knop.setAttribute('aria-busy', 'true');
          } else {
            knop.removeAttribute('aria-busy');
          }
        }
        this.meld('lx:koop:bezig', { bezig, bron: this.bron || 'hoofd' });
      }

      // De melding verschijnt waar de bezoeker tikte (bron hoofd, balk of lade): twee role="alert"-regels
      // tegelijk zou een schermlezer twee keer laten voorlezen.
      toonFout(tekst, bron) {
        const melding = tekst || this.dataset.fout || '';
        const regel = this.foutregel;
        if (regel && (bron || 'hoofd') === 'hoofd') {
          regel.textContent = melding;
          regel.hidden = false;
        }
        this.meld('lx:koop:fout', { melding, bron: bron || 'hoofd' });
      }

      // Deal 2 en 3 met een Shopify-bundel: die ene bundel. Anders de ONE plus de extra's van de gekozen deal.
      // Elke regel met _deal.
      items() {
        const keuze = this.querySelector('input[name="properties[_deal]"]:checked');
        const deal = keuze ? keuze.value : '';
        const bundel = keuze ? keuze.dataset.bundel : '';
        // 08b: aangevinkte extra's uit de zichtbare schuifrij, als losse regels erbij.
        const upsells = Array.from(
          this.querySelectorAll('[data-lx-upsell]:not([hidden]) input[data-lx-upsell-variant]:checked')
        ).map((vak) => ({ id: Number(vak.dataset.lxUpsellVariant), quantity: 1, properties: { _upsell: deal || '1' } }));
        // Bij voorraad 0 gaat de levertijd zichtbaar mee op de regel van het product (wagen, checkout, bevestiging).
        const eigen = (basis) => (this.levering ? { ...basis, Levering: this.levering } : basis);
        if (bundel) return [{ id: Number(bundel), quantity: 1, properties: eigen(deal ? { _deal: deal } : {}) }, ...upsells];
        const extras = ((keuze && keuze.dataset.extras) || '').split(',').filter(Boolean);
        return [
          ...[this.dataset.variant, ...extras].map((id, i) => ({
            id: Number(id),
            quantity: 1,
            properties: i === 0 ? eigen(deal ? { _deal: deal } : {}) : deal ? { _deal: deal } : {},
          })),
          ...upsells,
        ];
      }

      opVersturen = async (event) => {
        if (event.target !== this.formulier) return;
        event.preventDefault();
        // De balk en de lade zetten volgendeBron vlak voor requestSubmit(); de hoofdknop niet.
        const bron = this.volgendeBron || 'hoofd';
        this.volgendeBron = null;
        if (this.bezig || this.uitverkocht) return;
        this.bron = bron;
        // Deal 2 of 3 zonder Shopify-bundel (instelling «alleen met bundel»): niet bestellen tegen de volle
        // prijs van losse regels, want de dealkaart belooft de dealprijs.
        const gekozen = this.querySelector('input[name="properties[_deal]"]:checked');
        if (gekozen && gekozen.dataset.geenBundel !== undefined) {
          this.toonFout(gekozen.dataset.geenBundel, bron);
          return;
        }
        const regel = this.foutregel;
        if (regel) regel.hidden = true;
        this.zetBezig(true);
        const wagen = this.dataset.wagen || '/cart';
        // De winkelwagenlade (sectie lx-wagen in de footergroep) komt met het antwoord mee terug
        // (bundled section rendering) en gaat open; zonder lade blijft het de pagina /cart.
        const lade = document.querySelector('lx-wagen[data-modus="lade"]');
        const sectie = lade && typeof lade.toonMet === 'function' ? lade.dataset.sectie : '';
        const lichaam = { items: this.items() };
        if (sectie) lichaam.sections = sectie;
        try {
          const antwoord = await fetch((this.dataset.toevoegen || '/cart/add') + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(lichaam),
          });
          const json = await antwoord.json().catch(() => ({}));
          if (!antwoord.ok || json.status) {
            // Alleen de (vertaalde) uitleg van Shopify tonen; anders de instelbare fouttekst.
            const melding = typeof json.description === 'string' ? json.description : '';
            const shopifyFout = new Error(melding);
            shopifyFout.vanShopify = true;
            throw shopifyFout;
          }
          if (sectie && json.sections && json.sections[sectie]) {
            this.zetBezig(false);
            lade.toonMet(json.sections[sectie], bron === 'hoofd' ? this.knop : null);
            // Zonder detail haalt de kop de teller zelf op; de koopbalk meet hierop «toegevoegd».
            window.dispatchEvent(new CustomEvent('lx:cart:updated'));
            return;
          }
          let cart = null;
          try {
            const r = await fetch(wagen + '.js', { headers: { Accept: 'application/json' } });
            cart = await r.json();
          } catch (e) {
            cart = null;
          }
          window.dispatchEvent(new CustomEvent('lx:cart:updated', { detail: cart }));
          window.location.assign(wagen);
        } catch (fout) {
          // Een netwerkfout geeft een Engelse browsertekst ("Failed to fetch"); die tonen we niet.
          this.zetBezig(false);
          this.toonFout(fout && fout.vanShopify ? fout.message : '', bron);
        }
      };
    }
    customElements.define('lx-koop-formulier', LxKoopFormulier);
  }

  /*
    09b Sticky koopbalk. Eén gedeelde regie voor alle balken op de pagina: één scroll-luisteraar (passief,
    hooguit één meting per frame), één IntersectionObserver op de formulieren en de footer, en een
    MutationObserver op het open-attribuut van dialogen (menu-lade, beeldzoom). De meting leest alleen
    (getBoundingClientRect); schrijven gebeurt pas als de stand van een balk echt verandert.
  */
  if (!customElements.get('lx-koop-balk')) {
    (function () {
      const zonderBeweging = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const inEditor = () => Boolean(window.Shopify && window.Shopify.designMode);
      // Invoer zonder toetsenbord. Al het andere (tekstvelden, select, contenteditable) laat de balk wijken:
      // vraagbalk 10d, Klaviyo; op iOS staat een vaste balk anders midden in beeld boven het toetsenbord.
      const GEEN_TOETSENBORD = ['button', 'checkbox', 'color', 'file', 'hidden', 'image', 'radio', 'range', 'reset', 'submit'];

      const balken = new Set();
      let luistert = false;
      let frame = 0;
      let waarnemer = null;
      let dialoogWachter = null;
      let padding = 0;

      const plan = () => {
        if (!frame) frame = requestAnimationFrame(bepaal);
      };

      const kop = () => document.querySelector('.lx-header-sectie, .header-section');
      const footer = () => document.querySelector('#MainContent ~ footer, .lx-footer');

      // Onderrand van de vaste kop (56 px als hij plakt; 0 als er geen vaste kop is).
      function kopOnder() {
        const k = kop();
        return k ? Math.max(0, k.getBoundingClientRect().bottom) : 0;
      }

      function invoerActief() {
        const el = document.activeElement;
        if (!el || el === document.body || el.closest('.lx-koop__balk, .lx-koop__lade')) return false;
        if (el.isContentEditable) return true;
        if (el.tagName === 'TEXTAREA' || el.tagName === 'SELECT') return true;
        return el.tagName === 'INPUT' && !GEEN_TOETSENBORD.includes(String(el.type || 'text').toLowerCase());
      }

      function andereDialoog() {
        return Array.from(document.querySelectorAll('dialog[open]')).some((d) => !d.matches('.lx-koop__lade'));
      }

      // De cookiebanner van Shopify staat onderaan; de balk komt pas na de keuze.
      function cookiebanner() {
        const banner = document.getElementById('shopify-pc__banner');
        if (!banner) return false;
        const r = banner.getBoundingClientRect();
        if (r.height <= 0 || r.bottom <= 0 || r.top >= window.innerHeight) return false;
        const stijl = getComputedStyle(banner);
        return stijl.visibility !== 'hidden' && stijl.opacity !== '0';
      }

      function zetPadding() {
        let hoogte = 0;
        balken.forEach((b) => {
          if (b.zichtbaar) hoogte = Math.max(hoogte, b.hoogte || 0);
        });
        hoogte = Math.ceil(hoogte);
        if (hoogte === padding) return;
        padding = hoogte;
        // WCAG 2.4.11 (C43): wat de focus krijgt, scrolt de browser boven de balk.
        if (hoogte > 0) {
          document.documentElement.style.setProperty('scroll-padding-bottom', `${hoogte}px`);
        } else {
          document.documentElement.style.removeProperty('scroll-padding-bottom');
        }
      }

      function bepaal() {
        frame = 0;
        if (!balken.size) return;
        // Zolang een lade open is, blijft alles staan: bij het sluiten gaat de focus terug naar «Andere deal».
        for (const b of balken) if (b.ladeOpen()) return;

        const onder = kopOnder();
        const hoogte = window.innerHeight;
        const voet = footer();
        const voetInBeeld = voet ? voet.getBoundingClientRect().top < hoogte : false;
        // Nooit twee koopknoppen tegelijk: staat er ergens een koopblok in beeld, dan geen balk.
        const formInBeeld = Array.from(document.querySelectorAll('lx-koop-formulier')).some((f) => {
          const r = f.getBoundingClientRect();
          return r.height > 0 && r.bottom > onder && r.top < hoogte;
        });
        const blokkade = voetInBeeld || formInBeeld || invoerActief() || andereDialoog() || cookiebanner();

        // De balk van het laatst gepasseerde formulier: onderkant boven de kop, het dichtst erbij.
        let kandidaat = null;
        let beste = -Infinity;
        balken.forEach((b) => {
          const r = b.formEl.getBoundingClientRect();
          if (r.height > 0 && r.bottom <= onder && r.bottom > beste) {
            kandidaat = b;
            beste = r.bottom;
          }
        });

        balken.forEach((b) => {
          // Staat de focus in de balk zelf, dan wijkt hij alleen voor het koopblok (focus niet wegnemen).
          // Alleen bij zichtbare (toetsenbord)focus: na een tik op «Andere deal» en het sluiten van de lade staat de
          // focus programmatisch op die knop, en dan moet de balk op een touchscherm gewoon voor de footer wijken.
          const actief = document.activeElement;
          const focusErin = b.balk.contains(actief) && actief.matches(':focus-visible');
          b.zet(b === kandidaat && (!blokkade || (focusErin && !formInBeeld)));
        });
        zetPadding();
      }

      function maakWaarnemer() {
        if (waarnemer) waarnemer.disconnect();
        waarnemer = null;
        if (!('IntersectionObserver' in window)) return;
        const k = kop();
        const marge = k ? Math.round(k.getBoundingClientRect().height) : 0;
        waarnemer = new IntersectionObserver(plan, { rootMargin: `-${marge}px 0px 0px 0px` });
        balken.forEach((b) => waarnemer.observe(b.formEl));
        const voet = footer();
        if (voet) waarnemer.observe(voet);
      }

      function start() {
        if (luistert) return;
        luistert = true;
        // Ook een sprong over het koopblok heen (ankerlink, terugknop, scroll-herstel) telt: die geeft wel een
        // scroll-event, maar geen wissel in de IntersectionObserver.
        window.addEventListener('scroll', plan, { passive: true });
        window.addEventListener('resize', plan, { passive: true });
        if (window.visualViewport) window.visualViewport.addEventListener('resize', plan, { passive: true });
        window.addEventListener('pageshow', plan);
        document.addEventListener('focusin', plan);
        document.addEventListener('focusout', plan);
        document.addEventListener('visitorConsentCollected', plan);
        if ('MutationObserver' in window) {
          dialoogWachter = new MutationObserver(plan);
          dialoogWachter.observe(document.body, { subtree: true, attributes: true, attributeFilter: ['open'] });
        }
        maakWaarnemer();
      }

      function stop() {
        luistert = false;
        window.removeEventListener('scroll', plan);
        window.removeEventListener('resize', plan);
        if (window.visualViewport) window.visualViewport.removeEventListener('resize', plan);
        window.removeEventListener('pageshow', plan);
        document.removeEventListener('focusin', plan);
        document.removeEventListener('focusout', plan);
        document.removeEventListener('visitorConsentCollected', plan);
        if (dialoogWachter) dialoogWachter.disconnect();
        dialoogWachter = null;
        if (waarnemer) waarnemer.disconnect();
        waarnemer = null;
        if (frame) cancelAnimationFrame(frame);
        frame = 0;
        zetPadding();
      }

      class LxKoopBalk extends HTMLElement {
        connectedCallback() {
          const sectie = this.closest('.lx-koop');
          this.formEl = sectie ? sectie.querySelector('lx-koop-formulier') : null;
          this.balk = this.querySelector('[data-lx-balk]');
          this.lade = this.querySelector('[data-lx-balk-lade]');
          this.andere = this.querySelector('[data-lx-andere]');
          this.knop = this.querySelector('[data-lx-balk-knop]');
          this.ladeKnop = this.querySelector('[data-lx-lade-knop]');
          this.fout = this.querySelector('[data-lx-balk-fout]');
          this.zichtbaar = false;
          this.hoogte = 0;
          if (!this.formEl || !this.balk) return;

          this.ac = new AbortController();
          const signal = this.ac.signal;
          const opDeal = () => this.toonDeal(true);
          this.formEl.addEventListener('change', opDeal, { signal });
          this.formEl.addEventListener('lx:deal', opDeal, { signal });
          this.formEl.addEventListener('lx:koop:bezig', (event) => this.opBezig(event), { signal });
          this.formEl.addEventListener('lx:koop:fout', (event) => this.opFout(event), { signal });
          this.balk.addEventListener('click', (event) => this.opBalkKlik(event), { signal });
          if (this.lade) {
            this.lade.addEventListener('click', (event) => this.opLadeKlik(event), { signal });
            this.lade.addEventListener('change', (event) => this.opLadeKeuze(event), { signal });
            this.lade.addEventListener(
              'cancel',
              (event) => {
                event.preventDefault();
                this.sluitLade();
              },
              { signal }
            );
            this.lade.addEventListener('close', () => this.opLadeDicht(), { signal });
          }
          window.addEventListener('popstate', () => this.opGeschiedenis(), { signal });
          window.addEventListener('pageshow', (event) => this.opPageshow(event), { signal });
          window.addEventListener('lx:cart:updated', () => this.opToegevoegd(), { signal });
          if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => this.toonDeal(false), { once: true, signal });
          }
          // De dealfoto's staan lazy in de HTML en zouden pas laden als de balk verschijnt of de deal wisselt: dan
          // staat er even een leeg vak (gemeten 07-10-2026). Na het laden van de pagina haalt hij ze alvast op
          // (drie kleine webp's), buiten het kritieke pad van de pagina.
          const haalFotos = () => {
            this.balk.querySelectorAll('img[loading="lazy"]').forEach((img) => {
              img.loading = 'eager';
            });
          };
          if (document.readyState === 'complete') {
            haalFotos();
          } else {
            window.addEventListener('load', haalFotos, { once: true, signal });
          }
          if ('ResizeObserver' in window) {
            this.maat = new ResizeObserver(() => {
              if (!this.zichtbaar) return;
              this.hoogte = this.balk.getBoundingClientRect().height;
              zetPadding();
            });
            this.maat.observe(this.balk);
          }

          balken.add(this);
          start();
          if (waarnemer) waarnemer.observe(this.formEl);
          this.toonDeal(false);
          plan();
        }

        disconnectedCallback() {
          if (this.ac) this.ac.abort();
          this.ac = null;
          if (this.maat) this.maat.disconnect();
          this.maat = null;
          clearTimeout(this.balkKlok);
          clearTimeout(this.ladeKlok);
          clearTimeout(this.terugKlok);
          if (waarnemer && this.formEl) waarnemer.unobserve(this.formEl);
          if (this.lade && this.lade.open) this.lade.close();
          this.ontgrendel();
          this.zichtbaar = false;
          if (!balken.delete(this)) return;
          zetPadding();
          if (!balken.size) stop();
        }

        /* Deal volgen: altijd de radio die in het formulier gekozen is, ook na terugknop of scroll-herstel */

        toonDeal(wissel) {
          const keuze = this.formEl.querySelector('input[name="properties[_deal]"]:checked');
          if (!keuze) return;
          const data = keuze.dataset;
          this.balk.querySelectorAll('[data-lx-veld]').forEach((el) => {
            const tekst = data[el.dataset.lxVeld] || '';
            if (el.textContent !== tekst) el.textContent = tekst;
          });
          this.balk.querySelectorAll('[data-lx-als]').forEach((el) => {
            el.hidden = !data[el.dataset.lxAls];
          });
          this.balk.querySelectorAll('[data-lx-balk-beeld]').forEach((el) => {
            el.hidden = el.dataset.lxBalkBeeld !== keuze.value;
          });
          this.deal = keuze.value;
          if (wissel) this.verbergFout();
        }

        /* Tonen en verbergen (de regie hierboven beslist) */

        zet(zien) {
          if (zien === this.zichtbaar) return;
          this.zichtbaar = zien;
          const balk = this.balk;
          clearTimeout(this.balkKlok);
          if (zien) {
            balk.hidden = false;
            balk.toggleAttribute('inert', false);
            if (!zonderBeweging()) balk.getBoundingClientRect();
            balk.classList.add('is-zichtbaar');
            this.hoogte = balk.getBoundingClientRect().height;
            if (!this.getoond) {
              this.getoond = true;
              this.meet('getoond', { deal: this.deal });
            }
            return;
          }
          // Staat de focus nog in de balk (toetsenbord, teruggescrold naar het koopblok), dan gaat hij naar
          // hetzelfde onderdeel in het koopblok, zodat hij niet op <body> belandt als de balk inert wordt.
          if (balk.contains(document.activeElement)) {
            const andere = document.activeElement.closest('[data-lx-andere]');
            const doel = andere
              ? this.formEl.querySelector('input[name="properties[_deal]"]:checked')
              : this.formEl.knop || this.formEl.querySelector('[data-lx-koop-knop]');
            if (doel && !doel.disabled) doel.focus({ preventScroll: true });
          }
          // Uitschuiven, daarna hidden en inert: niet alleen onzichtbaar, anders blijft hij focusbaar.
          balk.classList.remove('is-zichtbaar');
          balk.toggleAttribute('inert', true);
          const weg = () => {
            if (!this.zichtbaar) balk.hidden = true;
          };
          if (zonderBeweging()) {
            weg();
          } else {
            this.balkKlok = setTimeout(weg, 200);
          }
        }

        /* Kopen: precies wat de hoofdknop doet, via de submit-handler van het formulier */

        opBalkKlik(event) {
          if (event.target.closest('[data-lx-balk-knop]')) {
            this.koop('balk');
          } else if (event.target.closest('[data-lx-andere]')) {
            this.openLade();
          }
        }

        koop(bron) {
          const form = this.formEl.formulier || this.formEl.querySelector('form');
          if (!form || this.formEl.bezig) return;
          this.verbergFout();
          // Lukt het niet, dan krijgt deze knop de focus terug (de knoppen zijn uit zolang het bezig is).
          this.focusTerug = bron === 'lade' ? this.andere : this.knop;
          this.meet('knop', { deal: this.deal, bron });
          this.formEl.volgendeBron = bron;
          if (typeof form.requestSubmit === 'function') {
            form.requestSubmit();
          } else {
            form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
          }
        }

        opBezig(event) {
          const detail = event.detail || {};
          const bezig = Boolean(detail.bezig);
          [this.knop, this.andere, this.ladeKnop].forEach((knop) => {
            if (knop) knop.disabled = bezig;
          });
          if (this.knop) {
            if (bezig) {
              this.knop.setAttribute('aria-busy', 'true');
            } else {
              this.knop.removeAttribute('aria-busy');
            }
          }
          if (bezig) {
            this.verbergFout();
            this.wachtOpWagen = detail.bron === 'balk' || detail.bron === 'lade';
            return;
          }
          this.wachtOpWagen = false;
          const doel = this.focusTerug;
          this.focusTerug = null;
          const actief = document.activeElement;
          if (doel && this.zichtbaar && (!actief || actief === document.body)) doel.focus({ preventScroll: true });
        }

        opFout(event) {
          const detail = event.detail || {};
          if (detail.bron !== 'balk' && detail.bron !== 'lade') return;
          // Is de balk intussen weg (teruggescrold naar het koopblok), dan hoort de melding bij de hoofdknop.
          if (!this.zichtbaar || !this.fout) {
            this.formEl.toonFout(detail.melding, 'hoofd');
            return;
          }
          this.fout.textContent = detail.melding || '';
          this.fout.hidden = !detail.melding;
        }

        verbergFout() {
          if (!this.fout || this.fout.hidden) return;
          this.fout.hidden = true;
          this.fout.textContent = '';
        }

        opToegevoegd() {
          if (!this.wachtOpWagen) return;
          this.wachtOpWagen = false;
          this.meet('toegevoegd', { deal: this.deal });
        }

        opPageshow(event) {
          // Terug uit de winkelwagen of scroll-herstel: de browser kan een andere radio teruggezet hebben.
          if (event.persisted && this.ladeOpen()) {
            this.inGeschiedenis = false;
            this.sluitLade();
          }
          this.toonDeal(false);
          plan();
        }

        /* Lade «Andere deal»: dialog met showModal; sluiten met de X, Escape, de scrim of de terugknop */

        ladeOpen() {
          return Boolean(this.lade && this.lade.open);
        }

        openLade() {
          const lade = this.lade;
          if (!lade || lade.open || typeof lade.showModal !== 'function') return;
          // Nooit een lade bovenop een andere dialoog.
          if (document.querySelector('dialog[open]')) return;
          clearTimeout(this.ladeKlok);
          if (this.opLadeEinde) lade.removeEventListener('transitionend', this.opLadeEinde);
          lade.querySelectorAll('[data-lx-ladekeuze]').forEach((invoer) => {
            invoer.checked = invoer.value === this.deal;
          });
          lade.showModal();
          this.vergrendel();
          if (this.andere) this.andere.setAttribute('aria-expanded', 'true');
          // Een stap in de geschiedenis, zodat de terugknop de lade sluit en niet de pagina verlaat.
          if (!inEditor()) {
            try {
              history.pushState({ lxKoopLade: lade.id }, '');
              this.inGeschiedenis = true;
            } catch (e) {
              this.inGeschiedenis = false;
            }
          }
          if (!zonderBeweging()) lade.getBoundingClientRect();
          lade.classList.add('is-open');
          const gekozen = lade.querySelector('[data-lx-ladekeuze]:checked') || lade.querySelector('[data-lx-ladekeuze]');
          if (gekozen) gekozen.focus({ preventScroll: true });
          this.meet('andere_deal', { deal: this.deal });
        }

        sluitLade(daarna) {
          const lade = this.lade;
          if (!lade || !lade.open) {
            if (daarna) daarna();
            return;
          }
          lade.classList.remove('is-open');
          if (this.andere) this.andere.setAttribute('aria-expanded', 'false');
          const klaar = () => {
            clearTimeout(this.ladeKlok);
            if (this.opLadeEinde) lade.removeEventListener('transitionend', this.opLadeEinde);
            this.opLadeEinde = null;
            if (lade.open) lade.close();
          };
          if (zonderBeweging()) {
            klaar();
          } else {
            this.opLadeEinde = (event) => {
              if (event.target === lade && event.propertyName === 'transform') klaar();
            };
            lade.addEventListener('transitionend', this.opLadeEinde);
            this.ladeKlok = setTimeout(klaar, 400);
          }
          // De stap van het openen weer weghalen, en pas daarna verder (toevoegen): zo valt de terugstap nooit
          // samen met de navigatie naar de winkelwagen.
          if (this.inGeschiedenis) {
            this.inGeschiedenis = false;
            this.naTerug = daarna || null;
            clearTimeout(this.terugKlok);
            this.terugKlok = setTimeout(() => this.naGeschiedenis(), 500);
            history.back();
          } else if (daarna) {
            daarna();
          }
        }

        naGeschiedenis() {
          clearTimeout(this.terugKlok);
          const daarna = this.naTerug;
          this.naTerug = null;
          if (daarna) daarna();
        }

        opGeschiedenis() {
          if (this.inGeschiedenis) {
            // Terugknop of veeggebaar terwijl de lade open is: alleen sluiten; de stap is al weg.
            this.inGeschiedenis = false;
            this.sluitLade();
            return;
          }
          if (this.naTerug) this.naGeschiedenis();
        }

        opLadeDicht() {
          if (this.lade) this.lade.classList.remove('is-open');
          if (this.andere) this.andere.setAttribute('aria-expanded', 'false');
          this.ontgrendel();
          if (this.inGeschiedenis) {
            // Gesloten buiten sluitLade om (bijv. de browser na een tweede Escape): de stap toch weghalen.
            this.inGeschiedenis = false;
            history.back();
          }
          if (this.andere && !this.andere.disabled) this.andere.focus({ preventScroll: true });
          plan();
        }

        opLadeKlik(event) {
          // Een tik op de scrim (::backdrop) komt binnen op de dialog zelf; de inhoud vult de dialog helemaal.
          if (event.target === this.lade || event.target.closest('[data-lx-lade-sluit]')) {
            this.sluitLade();
          } else if (event.target.closest('[data-lx-lade-knop]')) {
            this.sluitLade(() => this.koop('lade'));
          }
        }

        // Een keuze in de lade zet meteen de radio in de kiezer, met een change-event: kiezer, balk en wagen lopen gelijk.
        opLadeKeuze(event) {
          const invoer = event.target;
          if (!invoer || !invoer.matches('[data-lx-ladekeuze]') || !invoer.checked) return;
          const doel = Array.from(this.formEl.querySelectorAll('input[name="properties[_deal]"]')).find(
            (radio) => radio.value === invoer.value
          );
          if (!doel || doel.checked) return;
          doel.checked = true;
          doel.dispatchEvent(new Event('change', { bubbles: true }));
          this.meet('dealwissel', { deal: invoer.value });
        }

        vergrendel() {
          if (this.vergrendeld) return;
          const html = document.documentElement;
          this.vorigeOverflow = html.style.overflow;
          html.style.overflow = 'hidden';
          this.vergrendeld = true;
        }

        ontgrendel() {
          if (!this.vergrendeld) return;
          document.documentElement.style.overflow = this.vorigeOverflow || '';
          this.vergrendeld = false;
        }

        /* Meten: Shopify-klantevents (custom pixel) en Clarity, alleen als ze er zijn */

        meet(naam, data) {
          if (inEditor()) return;
          const sleutel = `lx_koopbalk_${naam}`;
          try {
            const analytics = window.Shopify && window.Shopify.analytics;
            if (analytics && typeof analytics.publish === 'function') analytics.publish(sleutel, data || {});
          } catch (e) {
            /* meten mag de balk nooit breken */
          }
          try {
            if (typeof window.clarity === 'function') window.clarity('event', sleutel);
          } catch (e) {
            /* idem */
          }
        }
      }

      customElements.define('lx-koop-balk', LxKoopBalk);
    })();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lx-overons-reviews"] && !Shopify.designMode) return;
  try {
    
  /* Startpositie van de doorlopende rijen (zoals lx-trustpilot): de eerste kaart van rij 1 staat bij het laden
     op de rand van de inhoud, rij 2 een halve kaart verder (data-start). Rustig: 25 px per seconde. Lopen en
     verslepen zit in lx-carrousel.js (.lx-loop); deze sectie geeft alleen de startpositie door (data-fase). */
  (function () {
    function zet(sectie) {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var kolom = sectie.querySelector('[data-lx-overons-reviews-kolom]');
      if (!kolom) return;
      var stijl = getComputedStyle(kolom);
      var rand = kolom.getBoundingClientRect().left + parseFloat(stijl.paddingLeft || 0);
      sectie.querySelectorAll('[data-lx-overons-loop]').forEach(function (loop) {
        if (!loop.offsetParent) return;
        var baan = loop.querySelector('.lx-loop__baan');
        if (!baan) return;
        var kaarten = baan.children;
        var helft = kaarten.length / 2;
        if (!helft || !kaarten[helft]) return;
        var d = kaarten[helft].offsetLeft - kaarten[0].offsetLeft;
        if (d <= 0) return;
        var m = rand - loop.getBoundingClientRect().left + (parseFloat(loop.dataset.start) || 0);
        var f = loop.dataset.richting === 'rechts' ? (((m % d) + d) % d) / d : ((((d - m) % d) + d) % d) / d;
        loop.dataset.fase = f.toFixed(4);
        loop.dispatchEvent(new CustomEvent('lx-loop:fase'));
      });
    }
    function alles() {
      document.querySelectorAll('.lx-overons-reviews').forEach(function (sectie) {
        if (sectie.dataset.lxOveronsReviewsKlaar) return;
        sectie.dataset.lxOveronsReviewsKlaar = '1';
        zet(sectie);
        var breedte = window.innerWidth;
        window.addEventListener('resize', function () {
          if (window.innerWidth === breedte) return;
          breedte = window.innerWidth;
          zet(sectie);
        });
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', alles);
    else alles();
    document.addEventListener('shopify:section:load', alles);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lx-product"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('lx-product-galerij')) return;

    const rustig = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    class LxProductGalerij extends HTMLElement {
      connectedCallback() {
        this.baan = this.querySelector('[data-lx-baan]');
        this.rij = this.querySelector('[data-lx-thumbs]');
        this.zoom = this.querySelector('[data-lx-zoom]');
        this.dias = Array.from(this.querySelectorAll('[data-lx-dia]'));
        this.thumbs = Array.from(this.querySelectorAll('[data-lx-thumb]'));
        this.actief = 0;
        this.doel = null;
        this.raf = 0;
        if (!this.baan || this.dias.length === 0) return;

        this.stop = new AbortController();
        const signal = this.stop.signal;

        this.baan.addEventListener('scroll', () => this.plan(), { passive: true, signal });
        this.baan.addEventListener('scrollend', () => this.klaar(), { signal });
        this.baan.addEventListener('pointerdown', () => { this.doel = null; }, { signal });
        this.baan.addEventListener('keydown', (e) => this.toets(e), { signal });

        this.thumbs.forEach((knop, i) => {
          knop.addEventListener('click', () => this.ga(i), { signal });
        });

        this.querySelectorAll('[data-lx-vergroot]').forEach((knop) => {
          knop.addEventListener('click', () => this.open(Number(knop.dataset.lxVergroot), knop), { signal });
        });

        if (this.zoom) {
          const sluit = this.zoom.querySelector('[data-lx-sluit]');
          if (sluit) sluit.addEventListener('click', () => this.zoom.close(), { signal });
          this.zoom.addEventListener('close', () => {
            document.documentElement.style.removeProperty('overflow');
            if (this.terug) this.terug.focus({ preventScroll: true });
          }, { signal });
        }

        // Blok «Video»: tik op de dia speelt de video af in het videovenster, met geluid (15-10-2026).
        this.videovenster = this.querySelector('[data-lx-videovenster]');
        this.querySelectorAll('[data-lx-video]').forEach((knop) => {
          knop.addEventListener('click', () => this.speel(knop.dataset.lxVideo, knop), { signal });
        });
        if (this.videovenster) {
          const sluit = this.videovenster.querySelector('[data-lx-sluit]');
          if (sluit) sluit.addEventListener('click', () => this.videovenster.close(), { signal });
          // Tik op het donkere vlak naast de video sluit ook.
          this.videovenster.addEventListener('click', (e) => {
            if (e.target === this.videovenster) this.videovenster.close();
          }, { signal });
          this.videovenster.addEventListener('close', () => {
            this.videovenster.querySelectorAll('video').forEach((video) => video.pause());
            document.documentElement.style.removeProperty('overflow');
            if (this.terug) this.terug.focus({ preventScroll: true });
          }, { signal });
        }

        // Theme editor: een blok «Beeld» selecteren laat die dia zien.
        document.addEventListener('shopify:block:select', (e) => {
          const i = this.dias.findIndex((dia) => dia === e.target || dia.contains(e.target));
          if (i > -1) this.ga(i);
        }, { signal });
      }

      disconnectedCallback() {
        if (this.stop) this.stop.abort();
        if (this.raf) cancelAnimationFrame(this.raf);
        clearTimeout(this.klok);
        if (this.zoom && this.zoom.open) document.documentElement.style.removeProperty('overflow');
        if (this.videovenster && this.videovenster.open) document.documentElement.style.removeProperty('overflow');
      }

      breedte() {
        return this.baan.clientWidth || 1;
      }

      plan() {
        if (this.raf) return;
        this.raf = requestAnimationFrame(() => {
          this.raf = 0;
          this.lees();
        });
      }

      klaar() {
        this.doel = null;
        this.lees();
      }

      lees() {
        const i = Math.round(this.baan.scrollLeft / this.breedte());
        if (this.doel !== null) {
          if (i !== this.doel) return;
          this.doel = null;
        }
        this.zet(i);
      }

      zet(i) {
        const n = Math.max(0, Math.min(i, this.dias.length - 1));
        if (n === this.actief) return;
        this.actief = n;
        // Pillen en kortingspil alleen bij packshots: een sfeerfoto (vullend) heeft bovenin zijn eigen kop (Dion
        // 13-10-2026). De eerste dia houdt ze altijd, zoals bij het laden.
        this.classList.toggle('is-sfeer', n > 0 && this.dias[n].classList.contains('lx-product__dia--vullend'));
        this.thumbs.forEach((knop, j) => {
          const aan = j === n;
          knop.classList.toggle('is-actief', aan);
          if (aan) knop.setAttribute('aria-current', 'true');
          else knop.removeAttribute('aria-current');
        });
        this.dias.forEach((dia, j) => {
          this.focusdoel(dia).tabIndex = j === n ? 0 : -1;
        });
        this.toonThumb(n);
      }

      // Het focusdoel van een dia: de vergroot- of videoknop, of de dia zelf als die geen knop heeft (placeholder).
      focusdoel(dia) {
        return dia.querySelector('[data-lx-vergroot], [data-lx-video]') || dia;
      }

      ga(i, focus = false) {
        const n = Math.max(0, Math.min(i, this.dias.length - 1));
        const links = n * this.breedte();
        clearTimeout(this.klok);
        if (Math.abs(this.baan.scrollLeft - links) < 1) {
          this.doel = null;
        } else {
          this.doel = n;
          this.klok = setTimeout(() => this.klaar(), 1000);
          this.baan.scrollTo({ left: links, behavior: rustig() ? 'auto' : 'smooth' });
        }
        this.zet(n);
        if (focus) this.focusdoel(this.dias[n]).focus({ preventScroll: true });
      }

      toonThumb(i) {
        const knop = this.thumbs[i];
        if (!knop || !this.rij) return;
        const marge = parseFloat(getComputedStyle(this.rij).paddingLeft) || 0;
        const links = knop.offsetLeft - marge;
        const rechts = knop.offsetLeft + knop.offsetWidth + marge - this.rij.clientWidth;
        let doel = null;
        if (this.rij.scrollLeft > links) doel = links;
        else if (this.rij.scrollLeft < rechts) doel = rechts;
        if (doel !== null) this.rij.scrollTo({ left: doel, behavior: rustig() ? 'auto' : 'smooth' });
      }

      toets(e) {
        if (e.key === 'ArrowRight') {
          e.preventDefault();
          this.ga(this.actief + 1, true);
        } else if (e.key === 'ArrowLeft') {
          e.preventDefault();
          this.ga(this.actief - 1, true);
        } else if (e.key === 'Home') {
          e.preventDefault();
          this.ga(0, true);
        } else if (e.key === 'End') {
          e.preventDefault();
          this.ga(this.dias.length - 1, true);
        }
      }

      open(i, knop) {
        if (!this.zoom || typeof this.zoom.showModal !== 'function') return;
        this.terug = knop;
        this.zoom.showModal();
        document.documentElement.style.overflow = 'hidden';
        const doel = this.zoom.querySelector('[data-lx-zoombeeld="' + i + '"]');
        this.zoom.scrollTop = doel ? doel.offsetTop : 0;
      }

      speel(i, knop) {
        const venster = this.videovenster;
        if (!venster || typeof venster.showModal !== 'function') return;
        const video = venster.querySelector('[data-lx-videobron="' + i + '"]');
        if (!video) return;
        venster.querySelectorAll('video').forEach((v) => { v.hidden = v !== video; });
        if (!video.poster && video.dataset.poster) video.poster = video.dataset.poster;
        this.terug = knop;
        venster.showModal();
        document.documentElement.style.overflow = 'hidden';
        // De tik is de toestemming voor geluid. Weigert de browser toch, dan staat de video klaar met de bediening.
        const start = video.play();
        if (start && typeof start.catch === 'function') start.catch(() => {});
      }
    }

    customElements.define('lx-product-galerij', LxProductGalerij);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lx-service-modellen"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('lx-service-rij')) return;
    const rustig = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* Stippen volgen de rij en zijn knoppen; zoals lx-zakelijk-modellen. Werkt ook na herladen in de editor. */
    class LxServiceRij extends HTMLElement {
      connectedCallback() {
        if (this._klaar) return;
        this.rij = this.querySelector('[data-lx-rij]');
        if (!this.rij) return;
        this._klaar = true;
        this.kaarten = Array.from(this.rij.querySelectorAll('[data-lx-kaart]'));
        this.stippen = Array.from(this.querySelectorAll('[data-lx-stip]'));
        this.actief = -1;
        this.gepland = false;
        this.opScroll = () => {
          if (this.gepland) return;
          this.gepland = true;
          requestAnimationFrame(() => {
            this.gepland = false;
            this.werkStippenBij();
          });
        };
        this.opKlik = (event) => {
          const stip = event.target instanceof Element ? event.target.closest('[data-lx-stip]') : null;
          if (stip && this.contains(stip)) this.gaNaar(Number(stip.dataset.lxStip));
        };
        this.opFocus = (event) => {
          const doel = event.target instanceof Element ? event.target : null;
          if (!doel || !doel.matches(':focus-visible')) return;
          const kaart = doel.closest('[data-lx-kaart]');
          const index = kaart ? this.kaarten.indexOf(kaart) : -1;
          if (index > -1) this.gaNaar(index, true);
        };
        this.opBlokKeuze = (event) => {
          const kaart = event.target instanceof Element ? event.target.closest('[data-lx-kaart]') : null;
          const index = kaart ? this.kaarten.indexOf(kaart) : -1;
          if (index > -1) this.gaNaar(index, true);
        };
        this.rij.addEventListener('scroll', this.opScroll, { passive: true });
        this.addEventListener('click', this.opKlik);
        this.addEventListener('focusin', this.opFocus);
        document.addEventListener('shopify:block:select', this.opBlokKeuze);
        this.werkStippenBij();
      }

      disconnectedCallback() {
        if (!this._klaar) return;
        this._klaar = false;
        this.rij.removeEventListener('scroll', this.opScroll);
        this.removeEventListener('click', this.opKlik);
        this.removeEventListener('focusin', this.opFocus);
        document.removeEventListener('shopify:block:select', this.opBlokKeuze);
      }

      beginVan(kaart) {
        return kaart.offsetLeft - this.kaarten[0].offsetLeft;
      }

      gaNaar(index, direct) {
        const kaart = this.kaarten[index];
        if (!kaart) return;
        this.rij.scrollTo({ left: this.beginVan(kaart), behavior: direct || rustig() ? 'auto' : 'smooth' });
      }

      werkStippenBij() {
        if (!this.kaarten.length || !this.stippen.length) return;
        const links = this.rij.scrollLeft;
        const max = this.rij.scrollWidth - this.rij.clientWidth;
        let index = 0;
        if (max > 0 && links >= max - 2) {
          index = this.kaarten.length - 1;
        } else {
          let kleinste = Infinity;
          this.kaarten.forEach((kaart, i) => {
            const afstand = Math.abs(this.beginVan(kaart) - links);
            if (afstand < kleinste) {
              kleinste = afstand;
              index = i;
            }
          });
        }
        if (index === this.actief) return;
        this.actief = index;
        this.stippen.forEach((stip, i) => {
          if (i === index) stip.setAttribute('aria-current', 'true');
          else stip.removeAttribute('aria-current');
        });
      }
    }
    customElements.define('lx-service-rij', LxServiceRij);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lx-service-oplossingen"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('lx-service-filter')) return;
    class LxServiceFilter extends HTMLElement {
      connectedCallback() {
        if (this._klaar) return;
        this._klaar = true;
        this.balk = this.querySelector('[data-lx-filter]');
        this.keuzes = Array.from(this.querySelectorAll('[data-lx-keuze]'));
        this.vragen = Array.from(this.querySelectorAll('[data-lx-model]'));
        if (this.balk) this.balk.hidden = false;
        this.opKlik = (event) => {
          const knop = event.target instanceof Element ? event.target.closest('[data-lx-keuze]') : null;
          if (knop && this.contains(knop)) this.kies(knop.dataset.lxKeuze);
        };
        /* Eén tegelijk open, ook in browsers zonder <details name>. */
        this.opToggle = (event) => {
          const v = event.target;
          if (!(v instanceof HTMLDetailsElement) || !v.open) return;
          this.vragen.forEach((ander) => {
            if (ander !== v) ander.open = false;
          });
        };
        this.addEventListener('click', this.opKlik);
        this.addEventListener('toggle', this.opToggle, true);
      }
      disconnectedCallback() {
        if (!this._klaar) return;
        this._klaar = false;
        this.removeEventListener('click', this.opKlik);
        this.removeEventListener('toggle', this.opToggle, true);
      }
      kies(model) {
        this.keuzes.forEach((k) => k.setAttribute('aria-pressed', String(k.dataset.lxKeuze === model)));
        const eigen = this.vragen.filter((v) => v.dataset.lxModel === model);
        const tonen = model !== 'alle' && eigen.length ? eigen : this.vragen.filter((v) => v.dataset.lxModel === 'alle');
        this.vragen.forEach((v) => {
          const zichtbaar = tonen.includes(v);
          v.hidden = !zichtbaar;
          v.open = zichtbaar && v === tonen[0];
        });
      }
    }
    customElements.define('lx-service-filter', LxServiceFilter);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lx-trustpilot"] && !Shopify.designMode) return;
  try {
    
  /* Startpositie van de doorlopende rijen: de eerste kaart van rij 1 staat bij het laden op de rand van
     de inhoud (zoals Figma), rij 2 een halve kaart verder (data-start). Snelheid overal gelijk, rustig:
     25 px per seconde. Lopen en verslepen zit in lx-carrousel.js (.lx-loop); deze sectie geeft alleen de startpositie door (data-fase). */
  (function () {
    function zet(sectie) {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var kolom = sectie.querySelector('[data-lx-trustpilot-kolom]');
      if (!kolom) return;
      var stijl = getComputedStyle(kolom);
      var rand = kolom.getBoundingClientRect().left + parseFloat(stijl.paddingLeft || 0);
      sectie.querySelectorAll('[data-lx-trustpilot-loop]').forEach(function (loop) {
        if (!loop.offsetParent) return;
        var baan = loop.querySelector('.lx-loop__baan');
        if (!baan) return;
        var kaarten = baan.children;
        var helft = kaarten.length / 2;
        if (!helft || !kaarten[helft]) return;
        var d = kaarten[helft].offsetLeft - kaarten[0].offsetLeft;
        if (d <= 0) return;
        var m = rand - loop.getBoundingClientRect().left + (parseFloat(loop.dataset.start) || 0);
        var f = loop.dataset.richting === 'rechts' ? (((m % d) + d) % d) / d : ((((d - m) % d) + d) % d) / d;
        loop.dataset.fase = f.toFixed(4);
        loop.dispatchEvent(new CustomEvent('lx-loop:fase'));
      });
    }
    function alles() {
      document.querySelectorAll('.lx-trustpilot').forEach(function (sectie) {
        if (sectie.dataset.lxTrustpilotKlaar) return;
        sectie.dataset.lxTrustpilotKlaar = '1';
        zet(sectie);
        var breedte = window.innerWidth;
        window.addEventListener('resize', function () {
          if (window.innerWidth === breedte) return;
          breedte = window.innerWidth;
          zet(sectie);
        });
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', alles);
    else alles();
    document.addEventListener('shopify:section:load', alles);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lx-ugc"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const rustig = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!customElements.get('lx-ugc-video')) {
      class LxUgcVideo extends HTMLElement {
        connectedCallback() {
          if (this._klaar) return;
          this.video = this.querySelector('video');
          this.knop = this.querySelector('.lx-ugc__speel');
          if (!this.video || !this.knop) return;
          this._klaar = true;

          this.video.muted = true;
          this.video.playsInline = true;
          this.video.setAttribute('playsinline', '');

          this._opKlik = this.speel.bind(this);
          this._opPlay = this.opPlay.bind(this);
          this._opEinde = this.stop.bind(this);

          this.knop.addEventListener('click', this._opKlik);
          this.video.addEventListener('play', this._opPlay);
          this.video.addEventListener('ended', this._opEinde);
        }

        disconnectedCallback() {
          if (!this._klaar) return;
          this._klaar = false;
          this.knop.removeEventListener('click', this._opKlik);
          this.video.removeEventListener('play', this._opPlay);
          this.video.removeEventListener('ended', this._opEinde);
        }

        speel() {
          if (!this.video.poster && this.video.dataset.poster) this.video.poster = this.video.dataset.poster;
          this.classList.add('is-spelend');
          this.video.controls = true;
          const bezig = this.video.play();
          if (bezig && typeof bezig.catch === 'function') {
            bezig.catch(() => this.stop());
          }
          this.video.focus({ preventScroll: true });
        }

        opPlay() {
          /* Eén video tegelijk binnen dezelfde sectie (ook de kopieën van de carrousel). */
          const sectie = this.closest('.lx-ugc');
          if (!sectie) return;
          sectie.querySelectorAll('lx-ugc-video').forEach((ander) => {
            if (ander !== this && ander.video && !ander.video.paused) ander.video.pause();
          });
        }

        stop() {
          const hadFocus = this.contains(document.activeElement);
          this.video.controls = false;
          this.classList.remove('is-spelend');
          if (hadFocus && !this.closest('[data-lx-kopie]')) this.knop.focus({ preventScroll: true });
        }
      }

      customElements.define('lx-ugc-video', LxUgcVideo);
    }

    if (customElements.get('lx-ugc-carrousel')) return;

    /*
      Doorlopende rij op native scroll (vegen, trackpad, toetsenbord blijven werken). Past de echte rij niet in
      beeld, dan komen er kopieën voor en achter: [kopie][echt][kopie]. Na het scrollen staat de rij altijd weer
      op dezelfde kaart in het echte deel. Niet terugspringen zolang er een video speelt.
    */
    class LxUgcCarrousel extends HTMLElement {
      connectedCallback() {
        if (this._klaar) return;
        this.rij = this.querySelector('.lx-ugc__rij');
        if (!this.rij) return;
        this._klaar = true;
        this.echt = Array.from(this.rij.children);
        this.voor = [];
        this.na = [];
        this.lus = false;

        this.vorige = this.querySelector('[data-lx-vorige]');
        this.volgende = this.querySelector('[data-lx-volgende]');
        this._opVorige = () => this.stap(-1);
        this._opVolgende = () => this.stap(1);
        this._opScroll = this.opScroll.bind(this);
        this._opRust = this.normaliseer.bind(this);
        this._opMedia = this.opMedia.bind(this);
        if (this.vorige) this.vorige.addEventListener('click', this._opVorige);
        /* Na slepen met de muis (lx-carrousel.js): terug naar de echte set. */
        this.rij.addEventListener('lx:sleep-klaar', this._opRust);
        if (this.volgende) this.volgende.addEventListener('click', this._opVolgende);
        this.rij.addEventListener('scroll', this._opScroll, { passive: true });
        this.heeftScrollend = 'onscrollend' in window;
        if (this.heeftScrollend) this.rij.addEventListener('scrollend', this._opRust);
        this.rij.addEventListener('pause', this._opMedia, true);
        this.rij.addEventListener('ended', this._opMedia, true);

        /* Posters pas laden als de sectie in de buurt komt (de sectie staat onder de vouw). */
        if ('IntersectionObserver' in window) {
          this.voorlader = new IntersectionObserver(
            (items) => {
              if (!items.some((i) => i.isIntersecting)) return;
              this.laadPosters();
              this.voorlader.disconnect();
              this.voorlader = null;
            },
            { rootMargin: '600px 0px' }
          );
          this.voorlader.observe(this);
          /* Video uit beeld geschoven: pauzeren. */
          this.kijker = new IntersectionObserver(
            (items) => {
              items.forEach((i) => {
                if (i.isIntersecting) return;
                const v = i.target;
                if (!v.paused) v.pause();
              });
            },
            { root: this.rij, threshold: 0.25 }
          );
          this.echt.forEach((k) => this.kijkNaar(k));
        } else {
          this.laadPosters();
        }

        if ('ResizeObserver' in window) {
          this.waarnemer = new ResizeObserver(() => this.meet());
          this.waarnemer.observe(this.rij);
        }
        this.meet();
      }

      disconnectedCallback() {
        if (!this._klaar) return;
        this._klaar = false;
        if (this.vorige) this.vorige.removeEventListener('click', this._opVorige);
        if (this.volgende) this.volgende.removeEventListener('click', this._opVolgende);
        this.rij.removeEventListener('scroll', this._opScroll);
        this.rij.removeEventListener('scrollend', this._opRust);
        this.rij.removeEventListener('lx:sleep-klaar', this._opRust);
        this.rij.removeEventListener('pause', this._opMedia, true);
        this.rij.removeEventListener('ended', this._opMedia, true);
        if (this.voorlader) this.voorlader.disconnect();
        if (this.kijker) this.kijker.disconnect();
        if (this.waarnemer) this.waarnemer.disconnect();
        clearTimeout(this._rustTimer);
      }

      kijkNaar(kaart) {
        if (!this.kijker) return;
        const v = kaart.querySelector('video');
        if (v) this.kijker.observe(v);
      }

      laadPosters() {
        this._postersGeladen = true;
        this.rij.querySelectorAll('video[data-poster]').forEach((v) => {
          if (!v.poster) v.poster = v.dataset.poster;
        });
      }

      /* Past de echte rij in beeld? Gemeten aan de echte kaarten, los van kopieën en centreren. Met
         getBoundingClientRect: op desktop is een kaart een kwart van de kolom en dus vaak geen heel getal, en
         offsetWidth rondt af (4 kaarten die precies passen, mogen niet als «past niet» tellen). */
      past() {
        const eerste = this.echt[0];
        const laatste = this.echt[this.echt.length - 1];
        if (!eerste || !laatste) return true;
        const breedte = laatste.getBoundingClientRect().right - eerste.getBoundingClientRect().left;
        return breedte <= this.rij.getBoundingClientRect().width + 2;
      }

      meet() {
        if (!this.rij.clientWidth) return;
        const moet = this.echt.length > 1 && !this.past();
        if (moet && !this.lus) this.zetLus();
        else if (!moet && this.lus) this.haalLus();
        else if (this.lus) this.springNaar(this.index());
      }

      kopie(kaart) {
        const k = kaart.cloneNode(true);
        k.setAttribute('aria-hidden', 'true');
        k.setAttribute('data-lx-kopie', '');
        [...k.attributes].forEach((a) => {
          if (a.name.startsWith('data-shopify')) k.removeAttribute(a.name);
        });
        k.querySelectorAll('button, a, video, [tabindex]').forEach((el) => el.setAttribute('tabindex', '-1'));
        k.querySelectorAll('.is-spelend').forEach((el) => el.classList.remove('is-spelend'));
        k.querySelectorAll('video').forEach((v) => v.removeAttribute('controls'));
        return k;
      }

      zetLus() {
        const index = this.index();
        this.voor = this.echt.map((k) => this.kopie(k));
        this.na = this.echt.map((k) => this.kopie(k));
        this.rij.prepend(...this.voor);
        this.rij.append(...this.na);
        this.voor.concat(this.na).forEach((k) => this.kijkNaar(k));
        if (this._postersGeladen) this.laadPosters();
        this.lus = true;
        this.setAttribute('data-lus', '');
        this.springNaar(index);
      }

      haalLus() {
        this.voor.concat(this.na).forEach((k) => {
          const v = k.querySelector('video');
          if (v && this.kijker) this.kijker.unobserve(v);
          k.remove();
        });
        this.voor = [];
        this.na = [];
        this.lus = false;
        this.removeAttribute('data-lus');
        this.rij.scrollLeft = 0;
      }

      /* Afstand tussen twee kaarten (kaart + gap). */
      stapBreedte() {
        if (this.echt.length < 2) return this.echt[0] ? this.echt[0].offsetWidth : 0;
        return this.echt[1].offsetLeft - this.echt[0].offsetLeft;
      }

      /* Breedte van één volledige set kaarten (alleen in de lus). */
      setBreedte() {
        return this.lus ? this.echt[0].offsetLeft - this.voor[0].offsetLeft : 0;
      }

      /* Index van de echte kaart die links in beeld staat. */
      index() {
        const stap = this.stapBreedte();
        if (!this.lus || !stap) return 0;
        const n = this.echt.length;
        const i = Math.round((this.rij.scrollLeft - this.echt[0].offsetLeft) / stap);
        return ((i % n) + n) % n;
      }

      springNaar(index) {
        const kaart = this.echt[index];
        this.rij.scrollLeft = this.lus && kaart ? kaart.offsetLeft : 0;
      }

      speeltEr() {
        return [...this.rij.querySelectorAll('video')].some((v) => !v.paused && !v.ended);
      }

      /* Na het scrollen: vanuit een kopie ongemerkt naar dezelfde kaart in het echte deel. */
      normaliseer() {
        this._doelIndex = null;
        /* Tijdens slepen of uitglijden niet springen; 'lx:sleep-klaar' roept dit daarna aan. */
        if (this.rij.classList.contains('is-slepen')) return;
        this._bezig = false;
        if (!this.lus || this.speeltEr()) return;
        const w = this.setBreedte();
        if (!w) return;
        const s = this.rij.scrollLeft;
        const begin = this.echt[0].offsetLeft;
        if (s < begin - 1) this.rij.scrollLeft = s + w;
        else if (s >= begin + w - 1) this.rij.scrollLeft = s - w;
      }

      opScroll() {
        this._bezig = true;
        if (this.heeftScrollend) return;
        clearTimeout(this._rustTimer);
        this._rustTimer = setTimeout(this._opRust, 150);
      }

      opMedia() {
        if (!this._bezig) this.normaliseer();
      }

      /* Eén kaart verder of terug, naar de linkerrand van die kaart zelf (geen opgetelde stappen: een kaart is op
         desktop een kwart van de kolom en meestal geen heel getal). Snel achter elkaar klikken telt elke klik: zolang
         de rij nog schuift, rekent de volgende stap vanaf het vorige doel. */
      stap(richting) {
        const stap = this.stapBreedte();
        if (!stap) return;
        if (!this._bezig) this.normaliseer();
        const kaarten = Array.from(this.rij.children);
        const begin = kaarten[0] ? kaarten[0].offsetLeft : 0;
        const huidig = this._bezig && this._doelIndex != null
          ? this._doelIndex
          : Math.round((this.rij.scrollLeft - begin) / stap);
        const index = Math.max(0, Math.min(kaarten.length - 1, huidig + richting));
        this._doelIndex = index;
        const kaart = kaarten[index];
        const max = this.rij.scrollWidth - this.rij.clientWidth;
        const doel = Math.max(0, Math.min(kaart ? kaart.offsetLeft - begin : 0, max));
        this.rij.scrollTo({ left: doel, behavior: rustig() ? 'auto' : 'smooth' });
      }
    }

    customElements.define('lx-ugc-carrousel', LxUgcCarrousel);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lx-verhaal"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (!customElements.get('lx-verhaal-momenten')) {
      class LxVerhaalMomenten extends HTMLElement {
        connectedCallback() {
          if (this.lxKlaar) return;
          this.lxKlaar = true;
          this.addEventListener('click', (event) => {
            const tab = event.target.closest('[role="tab"]');
            if (tab && this.contains(tab)) this.kies(tab, false);
          });
          this.addEventListener('keydown', (event) => this.toets(event));
          this.addEventListener('shopify:block:select', (event) => {
            const tab = event.target.closest('[role="tab"]');
            if (tab && this.contains(tab)) this.kies(tab, false);
          });
        }

        get tabs() {
          return Array.from(this.querySelectorAll('[role="tab"]'));
        }

        toets(event) {
          const tabs = this.tabs;
          const huidig = tabs.indexOf(event.target.closest('[role="tab"]'));
          if (huidig < 0) return;
          const aantal = tabs.length;
          let volgende;
          switch (event.key) {
            case 'ArrowRight':
            case 'ArrowDown':
              volgende = (huidig + 1) % aantal;
              break;
            case 'ArrowLeft':
            case 'ArrowUp':
              volgende = (huidig - 1 + aantal) % aantal;
              break;
            case 'Home':
              volgende = 0;
              break;
            case 'End':
              volgende = aantal - 1;
              break;
            default:
              return;
          }
          event.preventDefault();
          this.kies(tabs[volgende], true);
        }

        kies(gekozen, focus) {
          this.tabs.forEach((tab) => {
            const actief = tab === gekozen;
            tab.setAttribute('aria-selected', actief ? 'true' : 'false');
            tab.tabIndex = actief ? 0 : -1;
            const paneel = document.getElementById(tab.getAttribute('aria-controls'));
            if (paneel) paneel.classList.toggle('is-actief', actief);
          });
          if (focus) gekozen.focus();
        }
      }
      customElements.define('lx-verhaal-momenten', LxVerhaalMomenten);
    }

    if (!customElements.get('lx-verhaal-info')) {
      class LxVerhaalInfo extends HTMLElement {
        connectedCallback() {
          const knop = this.querySelector('button[aria-controls]');
          if (!knop || knop.lxKlaar) return;
          knop.lxKlaar = true;
          const zet = (open) => {
            const doel = document.getElementById(knop.getAttribute('aria-controls'));
            if (!doel) return;
            knop.setAttribute('aria-expanded', open ? 'true' : 'false');
            doel.hidden = !open;
          };
          knop.addEventListener('click', () => zet(knop.getAttribute('aria-expanded') !== 'true'));
          knop.addEventListener('keydown', (event) => {
            if (event.key === 'Escape' && knop.getAttribute('aria-expanded') === 'true') {
              event.preventDefault();
              zet(false);
            }
          });
        }
      }
      customElements.define('lx-verhaal-info', LxVerhaalInfo);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lx-voor-na"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('lx-voor-na-schuif')) return;

    class LxVoorNaSchuif extends HTMLElement {
      connectedCallback() {
        if (this._klaar) return;
        this.bereik = this.querySelector('.lx-voor-na__bereik');
        if (!this.bereik) return;
        this._klaar = true;
        this._slepen = false;
        this._bewogen = false;

        this._opDown = this.opDown.bind(this);
        this._opMove = this.opMove.bind(this);
        this._opUp = this.opUp.bind(this);
        this._opCancel = this.opCancel.bind(this);
        this._opInput = this.opInput.bind(this);

        this.addEventListener('pointerdown', this._opDown);
        this.addEventListener('pointermove', this._opMove);
        this.addEventListener('pointerup', this._opUp);
        this.addEventListener('pointercancel', this._opCancel);
        this.addEventListener('lostpointercapture', this._opCancel);
        this.bereik.addEventListener('input', this._opInput);

        this.zet(parseFloat(this.bereik.value), false);
      }

      disconnectedCallback() {
        if (!this._klaar) return;
        this._klaar = false;
        this.removeEventListener('pointerdown', this._opDown);
        this.removeEventListener('pointermove', this._opMove);
        this.removeEventListener('pointerup', this._opUp);
        this.removeEventListener('pointercancel', this._opCancel);
        this.removeEventListener('lostpointercapture', this._opCancel);
        this.bereik.removeEventListener('input', this._opInput);
      }

      positieUit(event) {
        const vak = this.getBoundingClientRect();
        if (!vak.width) return null;
        const p = ((event.clientX - vak.left) / vak.width) * 100;
        return Math.min(100, Math.max(0, p));
      }

      zet(p, bereikBijwerken) {
        if (p === null || isNaN(p)) return;
        this.style.setProperty('--lx-voor-na-pos', p + '%');
        if (bereikBijwerken !== false) this.bereik.value = String(Math.round(p));
      }

      opDown(event) {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        if (event.target === this.bereik) return;
        this._slepen = true;
        this._bewogen = false;
        this._startX = event.clientX;
        this._startY = event.clientY;
        try {
          this.setPointerCapture(event.pointerId);
        } catch (e) {}
        if (event.pointerType === 'mouse') {
          event.preventDefault();
          this.zet(this.positieUit(event));
        }
      }

      opMove(event) {
        if (!this._slepen) return;
        if (!this._bewogen) {
          /*
            Pas slepen als de vinger vooral opzij gaat. Een schuine veeg die vooral omlaag gaat is
            scrollen (touch-action: pan-y); zonder deze toets schoof de scheiding een paar pixels mee
            voordat de browser de aanwijzer annuleerde.
          */
          const dx = Math.abs(event.clientX - this._startX);
          const dy = Math.abs(event.clientY - this._startY);
          if (dx > 2 && dx > dy) this._bewogen = true;
        }
        if (this._bewogen || event.pointerType === 'mouse') this.zet(this.positieUit(event));
      }

      opUp(event) {
        if (!this._slepen) return;
        this._slepen = false;
        /* Een tik zonder slepen (vinger of pen) zet de scheiding op die plek. */
        if (!this._bewogen && event.pointerType !== 'mouse') this.zet(this.positieUit(event));
        try {
          this.releasePointerCapture(event.pointerId);
        } catch (e) {}
      }

      opCancel() {
        this._slepen = false;
      }

      opInput() {
        this.zet(parseFloat(this.bereik.value), false);
      }
    }

    customElements.define('lx-voor-na-schuif', LxVoorNaSchuif);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lx-vraag"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('lx-vraag-balk')) return;

    class LxVraagBalk extends HTMLElement {
      constructor() {
        super();
        this.bijKlik = this.bijKlik.bind(this);
        this.bijVersturen = this.bijVersturen.bind(this);
      }

      connectedCallback() {
        this.formulier = this.querySelector('[data-lx-vraag-formulier]');
        this.invoer = this.querySelector('[data-lx-vraag-invoer]');
        this.addEventListener('click', this.bijKlik);
        if (this.formulier) this.formulier.addEventListener('submit', this.bijVersturen);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.bijKlik);
        if (this.formulier) this.formulier.removeEventListener('submit', this.bijVersturen);
      }

      /* De chat met Sam, als die aan staat en geladen is; anders null en geldt de mailto-terugval. */
      sam() {
        if (!this.hasAttribute('data-sam')) return null;
        const api = window.SamChat;
        return api && typeof api.vraag === 'function' ? api : null;
      }

      /* Een voorbeeldvraag gaat naar Sam, of zet zonder Sam de vraag in het veld. */
      bijKlik(event) {
        const pil = event.target instanceof Element ? event.target.closest('[data-lx-vraag-pil]') : null;
        if (!pil) return;
        const sam = this.sam();
        if (sam) {
          sam.vraag(pil.textContent.trim());
          return;
        }
        if (!this.invoer) return;
        this.invoer.value = pil.textContent.trim();
        this.invoer.focus();
        const einde = this.invoer.value.length;
        try {
          this.invoer.setSelectionRange(einde, einde);
        } catch (fout) {
          /* niet elk invoertype ondersteunt een cursorpositie */
        }
      }

      /* Versturen gaat naar Sam, of opent zonder Sam een mail met het onderwerp en de vraag. Leeg: niets doen. */
      bijVersturen(event) {
        event.preventDefault();
        const vraag = this.invoer ? this.invoer.value.trim() : '';
        if (!vraag) return;
        const sam = this.sam();
        if (sam) {
          sam.vraag(vraag);
          this.invoer.value = '';
          return;
        }
        const email = (this.dataset.email || '').trim();
        if (!email) return;
        const onderwerp = this.dataset.onderwerp || '';
        window.location.href =
          'mailto:' + email + '?subject=' + encodeURIComponent(onderwerp) + '&body=' + encodeURIComponent(vraag);
      }
    }

    customElements.define('lx-vraag-balk', LxVraagBalk);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lx-wagen"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('lx-wagen')) return;

    const zonderBeweging = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    class LxWagen extends HTMLElement {
      connectedCallback() {
        this.lade = this.querySelector('[data-lx-wagen-lade]');
        this.ac = new AbortController();
        const signal = this.ac.signal;
        this.addEventListener('click', (event) => this.opKlik(event), { signal });
        // Akkoord algemene voorwaarden: keuze onthouden over het verversen van de inhoud heen, en bij een leeg vak
        // onze eigen melding tonen in plaats van de browserballon (invalid vuurt vóór submit).
        this.avAkkoord = false;
        this.addEventListener('change', (event) => {
          if (!event.target.matches('[data-lx-wagen-av]')) return;
          this.avAkkoord = event.target.checked;
          if (this.avAkkoord) this.querySelectorAll('[data-lx-wagen-av-fout]').forEach((f) => (f.hidden = true));
        }, { signal });
        // Nieuwsbrief: het wagenkenmerk volgt het vinkje (leeg = geen kenmerk op de bestelling).
        this.addEventListener('change', (event) => {
          if (!event.target.matches('[data-lx-wagen-nieuwsbrief]')) return;
          fetch((window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ attributes: { Nieuwsbrief: event.target.checked ? 'ja' : '' } }),
          }).catch(() => {});
        }, { signal });
        this.addEventListener('invalid', (event) => {
          if (!event.target.matches('[data-lx-wagen-av]')) return;
          event.preventDefault();
          const fout = event.target.closest('form').querySelector('[data-lx-wagen-av-fout]');
          if (fout) fout.hidden = false;
          event.target.focus({ preventScroll: false });
        }, { capture: true, signal });
        if (this.lade) {
          this.lade.addEventListener('cancel', (event) => {
            event.preventDefault();
            this.sluit();
          }, { signal });
          this.lade.addEventListener('close', () => this.opGesloten(), { signal });
          // Het wagenicoon in de kop opent de lade; zonder JavaScript blijft het een link naar /cart.
          document.addEventListener('click', (event) => this.opIcoon(event), { signal });
          window.addEventListener('pageshow', (event) => {
            if (event.persisted) {
              if (this.lade.open) this.sluit(true);
              this.ververs();
            }
          }, { signal });
          this.markeerIcoon();
        }
        // Andere onderdelen van het thema (oude Horizon-secties) melden een gewijzigde wagen met cart:update.
        document.addEventListener('cart:update', () => this.ververs(), { signal });
        if (!this.lade) this.volgKop();
        // Over de grens van 1024 heen (venster smaller of breder): «Ook handig» opnieuw opbouwen, want rondlopen
        // en pijlen hangen af van de breedte (zetRijen).
        window.matchMedia('(min-width: 1024px)').addEventListener('change', () => {
          if (this.querySelector('[data-lx-rij][data-lx-rond]')) this.ververs();
        }, { signal });
        this.zetRijen();
      }

      disconnectedCallback() {
        this.ac.abort();
        clearTimeout(this.sluitKlok);
        if (this.kopWaarnemer) this.kopWaarnemer.disconnect();
        this.ontgrendel();
      }

      // /cart op desktop: de samenvatting plakt onder de vaste kop van de site; zijn hoogte als --lx-wagen-kop.
      volgKop() {
        const kop = document.querySelector('.lx-header-sectie');
        if (!kop) return;
        const zet = () => this.style.setProperty('--lx-wagen-kop', `${kop.offsetHeight}px`);
        zet();
        if (typeof ResizeObserver === 'function') {
          this.kopWaarnemer = new ResizeObserver(zet);
          this.kopWaarnemer.observe(kop);
        }
      }

      get inhoud() {
        return this.querySelector('[data-lx-wagen-inhoud]');
      }

      markeerIcoon() {
        document.querySelectorAll('[data-lx-wagen]').forEach((icoon) => {
          icoon.setAttribute('aria-haspopup', 'dialog');
          icoon.setAttribute('aria-controls', this.lade.id);
        });
      }

      opIcoon(event) {
        const icoon = event.target.closest('[data-lx-wagen]');
        if (!icoon || event.defaultPrevented) return;
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button > 0) return;
        event.preventDefault();
        this.terugFocus = icoon;
        this.open();
      }

      /* Lade openen en sluiten, zoals de menu-lade in lx-header */

      open() {
        const lade = this.lade;
        if (!lade) return;
        if (lade.open) {
          clearTimeout(this.sluitKlok);
          if (this.opEinde) lade.removeEventListener('transitionend', this.opEinde);
          lade.classList.add('is-open');
          return;
        }
        if (!this.terugFocus) {
          const actief = document.activeElement;
          this.terugFocus = actief && actief !== document.body ? actief : document.querySelector('[data-lx-wagen]');
        }
        if (typeof lade.showModal === 'function') {
          lade.showModal();
        } else {
          lade.setAttribute('open', '');
        }
        this.vergrendel();
        if (!zonderBeweging()) lade.getBoundingClientRect();
        lade.classList.add('is-open');
        const sluit = lade.querySelector('[data-lx-wagen-sluit]');
        if (sluit) sluit.focus({ preventScroll: true });
        this.zetRijen();
      }

      sluit(direct) {
        const lade = this.lade;
        if (!lade || !lade.open) return;
        lade.classList.remove('is-open');
        const klaar = () => {
          clearTimeout(this.sluitKlok);
          if (this.opEinde) lade.removeEventListener('transitionend', this.opEinde);
          this.opEinde = null;
          if (!lade.open) return;
          if (typeof lade.close === 'function') {
            lade.close();
          } else {
            lade.removeAttribute('open');
            this.opGesloten();
          }
        };
        if (direct === true || zonderBeweging()) {
          klaar();
          return;
        }
        this.opEinde = (event) => {
          if (event.target === lade && event.propertyName === 'transform') klaar();
        };
        lade.addEventListener('transitionend', this.opEinde);
        this.sluitKlok = setTimeout(klaar, 400);
      }

      opGesloten() {
        if (this.lade) this.lade.classList.remove('is-open');
        this.ontgrendel();
        const doel = this.terugFocus && this.terugFocus.isConnected ? this.terugFocus : null;
        this.terugFocus = null;
        if (doel && typeof doel.focus === 'function') doel.focus({ preventScroll: true });
      }

      vergrendel() {
        if (this.vergrendeld) return;
        const html = document.documentElement;
        this.vorigeOverflow = html.style.overflow;
        html.style.overflow = 'hidden';
        this.vergrendeld = true;
      }

      ontgrendel() {
        if (!this.vergrendeld) return;
        document.documentElement.style.overflow = this.vorigeOverflow || '';
        this.vergrendeld = false;
      }

      /* Inhoud: vervangen met de HTML van deze sectie (uit een wagenverzoek of de Section Rendering API) */

      // Voor lx-koop: de sectie-HTML uit het /cart/add.js-antwoord tonen en de lade openen. terug = waar de focus
      // na het sluiten heen gaat (de koopknop verloor hem toen hij tijdens het toevoegen uitgeschakeld was).
      toonMet(html, terug) {
        if (terug && terug.isConnected) this.terugFocus = terug;
        this.vervang(html);
        this.open();
      }

      vervang(html) {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const nieuw = doc.querySelector('[data-lx-wagen-inhoud]');
        const oud = this.inhoud;
        if (!nieuw || !oud) return;
        const focus = document.activeElement && document.activeElement.closest('[data-lx-focus]');
        const focusSleutel = focus && oud.contains(focus) ? focus.getAttribute('data-lx-focus') : null;
        const midden = oud.querySelector('[data-lx-wagen-midden]');
        const scroll = midden ? midden.scrollTop : 0;
        oud.replaceChildren(...nieuw.childNodes);
        oud.querySelectorAll('[data-lx-wagen-av]').forEach((vak) => (vak.checked = this.avAkkoord));
        const nieuwMidden = oud.querySelector('[data-lx-wagen-midden]');
        if (nieuwMidden) nieuwMidden.scrollTop = scroll;
        this.zetRijen();
        if (focusSleutel) {
          const terug = oud.querySelector(`[data-lx-focus="${CSS.escape(focusSleutel)}"]`);
          if (terug) {
            terug.focus({ preventScroll: true });
            return;
          }
        }
        if (this.lade && this.lade.open && (!document.activeElement || !this.lade.contains(document.activeElement))) {
          const sluit = this.lade.querySelector('[data-lx-wagen-sluit]');
          if (sluit) sluit.focus({ preventScroll: true });
        }
      }

      async ververs() {
        const id = this.dataset.sectie;
        if (!id) return;
        try {
          const antwoord = await fetch(`${window.location.pathname}?section_id=${encodeURIComponent(id)}`, {
            credentials: 'same-origin',
          });
          if (antwoord.ok) this.vervang(await antwoord.text());
        } catch (e) {
          /* De oude inhoud blijft staan. */
        }
      }

      /* Knoppen in de inhoud */

      opKlik(event) {
        if (this.lade && event.target === this.lade) {
          this.sluit();
          return;
        }
        if (event.target.closest('[data-lx-wagen-sluit]')) {
          this.sluit();
          return;
        }
        const aantal = event.target.closest('[data-lx-aantal]');
        if (aantal) {
          this.wijzig(aantal.dataset.sleutel, Number(aantal.dataset.lxAantal));
          return;
        }
        const upgrade = event.target.closest('[data-lx-upgrade]');
        if (upgrade) {
          this.upgrade(upgrade.dataset);
          return;
        }
        const pijl = event.target.closest('[data-lx-wagen-pijl]');
        if (pijl) {
          this.blader(pijl);
          return;
        }
        const toevoegen = event.target.closest('[data-lx-toevoegen]');
        if (toevoegen) this.voegToe(Number(toevoegen.dataset.lxToevoegen));
      }

      async verzoek(pad, lichaam) {
        const antwoord = await fetch(`${window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/'}${pad}`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify(Object.assign({ sections: this.dataset.sectie }, lichaam)),
        });
        const json = await antwoord.json().catch(() => ({}));
        if (!antwoord.ok || json.status) {
          const fout = new Error(typeof json.description === 'string' ? json.description : '');
          fout.vanShopify = true;
          throw fout;
        }
        return json;
      }

      async bezig(werk) {
        if (this.isBezig) return;
        this.isBezig = true;
        const inhoud = this.inhoud;
        if (inhoud) inhoud.setAttribute('aria-busy', 'true');
        const regel = this.querySelector('[data-lx-wagen-fout]');
        if (regel) regel.hidden = true;
        try {
          const json = await werk();
          const html = json && json.sections && json.sections[this.dataset.sectie];
          if (html) {
            this.vervang(html);
          } else {
            await this.ververs();
          }
          // Teller in de kop en de meting van de koopbalk; zonder detail haalt de kop /cart.js zelf op.
          const wagen = json && typeof json.item_count === 'number' ? json : null;
          window.dispatchEvent(new CustomEvent('lx:cart:updated', { detail: wagen }));
        } catch (fout) {
          const melding = fout && fout.vanShopify && fout.message ? fout.message : this.dataset.fout;
          const nieuweRegel = this.querySelector('[data-lx-wagen-fout]');
          if (nieuweRegel && melding) {
            nieuweRegel.textContent = melding;
            nieuweRegel.hidden = false;
          }
        } finally {
          this.isBezig = false;
          const nu = this.inhoud;
          if (nu) nu.removeAttribute('aria-busy');
        }
      }

      wijzig(sleutel, aantal) {
        if (!sleutel || !(aantal >= 0)) return;
        this.bezig(() => this.verzoek('cart/change.js', { id: sleutel, quantity: aantal }));
      }

      // Upgrade: eerst de bundel erbij, dan de oude regel eruit. Lukt het toevoegen niet, dan blijft alles staan.
      upgrade(gegevens) {
        const naar = Number(gegevens.naar);
        const aantal = Math.max(1, Number(gegevens.aantal) || 1);
        if (!naar || !gegevens.sleutel) return;
        this.bezig(async () => {
          await this.verzoek('cart/add.js', {
            items: [{ id: naar, quantity: aantal, properties: { _deal: String(gegevens.deal || '') } }],
            sections: undefined,
          });
          return this.verzoek('cart/change.js', { id: gegevens.sleutel, quantity: 0 });
        });
      }

      voegToe(variant) {
        if (!variant) return;
        this.bezig(() => this.verzoek('cart/add.js', { items: [{ id: variant, quantity: 1 }] }));
      }

      // Pijlen bij «Ook handig» (desktop): één kaart verder. De rij loopt rond, dus er is altijd een volgende.
      blader(knop) {
        const blok = knop.closest('.lx-wagen__handig');
        const rij = blok && blok.querySelector('[data-lx-rij]');
        const kaart = rij && rij.querySelector('.lx-wagen__kaart');
        if (!kaart) return;
        const gap = parseFloat(getComputedStyle(kaart.parentElement).columnGap) || 0;
        const stap = (kaart.getBoundingClientRect().width + gap) * Number(knop.dataset.lxWagenPijl || 1);
        rij.scrollBy({ left: stap, behavior: zonderBeweging() ? 'auto' : 'smooth' });
      }

      /* «Ook handig»: schuifrij die rondloopt vanaf 3 kaarten (besluit Dion 05-10-2026) */

      // De kaarten staan drie keer in de rij: kopieën, echte kaarten, kopieën. De rij begint bij de eerste echte
      // kaart. Staat na het vegen een kopie vooraan, dan springt de rij ongemerkt een hele set terug of vooruit,
      // zodat er altijd een volgende kaart is. De kopieën zijn inert en aria-hidden: schermlezers en Tab zien
      // alleen de echte kaarten. Alleen als de rij maten heeft (lade open of pagina /cart).
      // Desktop (vanaf 1024): passen alle kaarten in beeld (bijv. /cart, 688 breed), dan geen kopieën en geen pijlen;
      // anders lopen ze rond zoals op mobiel en verschijnen de pijlen naast de kop (Figma 802:23143, 802:27406).
      zetRijen() {
        if (this.lade && !this.lade.open) return;
        const breed = window.matchMedia('(min-width: 1024px)').matches;
        this.querySelectorAll('[data-lx-rij][data-lx-rond]:not([data-lx-klaar])').forEach((rij) => {
          const lijst = rij.querySelector('ul');
          if (!lijst || !rij.clientWidth) return;
          const kaarten = Array.from(lijst.children);
          if (kaarten.length < 3) return;
          if (breed && lijst.offsetWidth <= rij.clientWidth + 1) return;
          rij.dataset.lxKlaar = '1';
          const blok = rij.closest('.lx-wagen__handig');
          const pijlen = blok && blok.querySelector('[data-lx-wagen-pijlen]');
          if (pijlen && breed) pijlen.hidden = false;
          const kloon = (kaart) => {
            const k = kaart.cloneNode(true);
            k.setAttribute('aria-hidden', 'true');
            k.setAttribute('inert', '');
            k.querySelectorAll('[id]').forEach((el) => el.removeAttribute('id'));
            k.querySelectorAll('[data-lx-focus]').forEach((el) => el.removeAttribute('data-lx-focus'));
            return k;
          };
          lijst.prepend(...kaarten.map(kloon));
          lijst.append(...kaarten.map(kloon));
          const zet = (x) => {
            rij.style.scrollSnapType = 'none';
            rij.scrollLeft = x;
            rij.style.scrollSnapType = '';
          };
          const start = () => kaarten[0].offsetLeft;
          const set = () => lijst.children[kaarten.length * 2].offsetLeft - kaarten[0].offsetLeft;
          zet(start());
          let klok = null;
          const terug = () => {
            const x = rij.scrollLeft;
            const s = start();
            const b = set();
            if (!b) return;
            if (x < s) zet(x + b);
            else if (x >= s + b) zet(x - b);
          };
          rij.addEventListener(
            'scroll',
            () => {
              clearTimeout(klok);
              klok = setTimeout(terug, 140);
            },
            { passive: true }
          );
        });
      }
    }

    customElements.define('lx-wagen', LxWagen);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lx-zakelijk-faq"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('lx-zakelijk-faq-lijst')) return;

    const DUUR = 300;
    const rustig = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /*
      Lijst met <details name="…">. De browser houdt zelf één vraag open; dit script voegt alleen de
      schuifanimatie toe. Tijdens het dichtschuiven heeft een vraag tijdelijk geen name (anders sluit de
      browser hem meteen als een andere opengaat) en het attribuut data-sluit (dan staat het plusje al terug).
    */
    class LxZakelijkFaqLijst extends HTMLElement {
      constructor() {
        super();
        this.bijBlokSelectie = this.bijBlokSelectie.bind(this);
      }

      connectedCallback() {
        this.addEventListener('click', this);
        document.addEventListener('shopify:block:select', this.bijBlokSelectie);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this);
        document.removeEventListener('shopify:block:select', this.bijBlokSelectie);
      }

      handleEvent(event) {
        const kop = event.target instanceof Element ? event.target.closest('summary') : null;
        const vraag = kop ? kop.parentElement : null;
        if (!(vraag instanceof HTMLDetailsElement) || !this.contains(vraag)) return;
        event.preventDefault();
        this.zet(vraag, !this.isOpen(vraag));
      }

      /* In de theme editor: een gekozen vraag klapt open, zodat je ziet wat je bewerkt. */
      bijBlokSelectie(event) {
        const vraag = event.target instanceof Element ? event.target.closest('details') : null;
        if (vraag && this.contains(vraag)) this.zet(vraag, true, true);
      }

      isOpen(vraag) {
        return vraag.open && !vraag.hasAttribute('data-sluit');
      }

      zet(vraag, open, direct = false) {
        if (!open) {
          this.sluit(vraag, direct);
          return;
        }
        for (const ander of this.querySelectorAll('details[open]')) {
          if (ander !== vraag) this.sluit(ander, direct);
        }
        this.open(vraag, direct);
      }

      open(vraag, direct) {
        const paneel = vraag.querySelector('[data-lx-zakelijk-faq-paneel]');
        const van = vraag.open && paneel ? paneel.offsetHeight : 0;
        this.stop(vraag);
        vraag.open = true;
        if (direct || !paneel || rustig() || typeof paneel.animate !== 'function') return;
        const naar = paneel.offsetHeight;
        if (naar === van) return;
        this.animeer(vraag, paneel, van, naar, null);
      }

      sluit(vraag, direct) {
        if (!vraag.open) return;
        if (!direct && vraag.hasAttribute('data-sluit')) return;
        const paneel = vraag.querySelector('[data-lx-zakelijk-faq-paneel]');
        const van = paneel ? paneel.offsetHeight : 0;
        this.stop(vraag);
        if (direct || !paneel || rustig() || typeof paneel.animate !== 'function') {
          vraag.open = false;
          return;
        }
        const naam = vraag.getAttribute('name');
        if (naam !== null) {
          vraag.dataset.lxNaam = naam;
          vraag.removeAttribute('name');
        }
        vraag.setAttribute('data-sluit', '');
        this.animeer(vraag, paneel, van, 0, () => this.rondSluitenAf(vraag));
      }

      animeer(vraag, paneel, van, naar, klaar) {
        const animatie = paneel.animate([{ height: `${van}px` }, { height: `${naar}px` }], {
          duration: DUUR,
          easing: 'ease',
        });
        vraag.lxAnimatie = animatie;
        animatie.onfinish = () => {
          vraag.lxAnimatie = null;
          if (klaar) klaar();
        };
      }

      rondSluitenAf(vraag) {
        vraag.removeAttribute('data-sluit');
        vraag.open = false;
        this.zetNaamTerug(vraag);
      }

      zetNaamTerug(vraag) {
        if (vraag.dataset.lxNaam === undefined) return;
        vraag.setAttribute('name', vraag.dataset.lxNaam);
        delete vraag.dataset.lxNaam;
      }

      /* Een lopende animatie afbreken (bijv. twee keer snel tikken); de vraag blijft staan zoals hij is. */
      stop(vraag) {
        const animatie = vraag.lxAnimatie;
        if (animatie) {
          animatie.onfinish = null;
          animatie.cancel();
          vraag.lxAnimatie = null;
        }
        if (vraag.hasAttribute('data-sluit')) {
          vraag.removeAttribute('data-sluit');
          this.zetNaamTerug(vraag);
        }
      }
    }

    customElements.define('lx-zakelijk-faq-lijst', LxZakelijkFaqLijst);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lx-zakelijk-modellen"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('lx-zakelijk-modellen-rij')) return;
    const rustig = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* Stippen volgen de rij en zijn knoppen; zoals lx-categorie-modellen. Werkt ook na een herlaadbeurt in de editor. */
    class LxZakelijkModellenRij extends HTMLElement {
      connectedCallback() {
        if (this._klaar) return;
        this.rij = this.querySelector('[data-lx-rij]');
        if (!this.rij) return;
        this._klaar = true;
        this.kaarten = Array.from(this.rij.querySelectorAll('[data-lx-kaart]'));
        this.stippen = Array.from(this.querySelectorAll('[data-lx-stip]'));
        this.actief = -1;
        this.gepland = false;
        this.opScroll = () => {
          if (this.gepland) return;
          this.gepland = true;
          requestAnimationFrame(() => {
            this.gepland = false;
            this.werkStippenBij();
          });
        };
        this.opKlik = (event) => {
          const stip = event.target instanceof Element ? event.target.closest('[data-lx-stip]') : null;
          if (stip && this.contains(stip)) this.gaNaar(Number(stip.dataset.lxStip));
        };
        /* Met Tab naar een knop in een kaart die half buiten beeld staat: die kaart naar voren. */
        this.opFocus = (event) => {
          const doel = event.target instanceof Element ? event.target : null;
          if (!doel || !doel.matches(':focus-visible')) return;
          const kaart = doel.closest('[data-lx-kaart]');
          const index = kaart ? this.kaarten.indexOf(kaart) : -1;
          if (index > -1) this.gaNaar(index, true);
        };
        this.opBlokKeuze = (event) => {
          const kaart = event.target instanceof Element ? event.target.closest('[data-lx-kaart]') : null;
          const index = kaart ? this.kaarten.indexOf(kaart) : -1;
          if (index > -1) this.gaNaar(index, true);
        };
        this.rij.addEventListener('scroll', this.opScroll, { passive: true });
        this.addEventListener('click', this.opKlik);
        this.addEventListener('focusin', this.opFocus);
        document.addEventListener('shopify:block:select', this.opBlokKeuze);
        this.werkStippenBij();
      }

      disconnectedCallback() {
        if (!this._klaar) return;
        this._klaar = false;
        this.rij.removeEventListener('scroll', this.opScroll);
        this.removeEventListener('click', this.opKlik);
        this.removeEventListener('focusin', this.opFocus);
        document.removeEventListener('shopify:block:select', this.opBlokKeuze);
      }

      beginVan(kaart) {
        return kaart.offsetLeft - this.kaarten[0].offsetLeft;
      }

      gaNaar(index, direct) {
        const kaart = this.kaarten[index];
        if (!kaart) return;
        this.rij.scrollTo({ left: this.beginVan(kaart), behavior: direct || rustig() ? 'auto' : 'smooth' });
      }

      werkStippenBij() {
        if (!this.kaarten.length || !this.stippen.length) return;
        const links = this.rij.scrollLeft;
        const max = this.rij.scrollWidth - this.rij.clientWidth;
        let index = 0;
        if (max > 0 && links >= max - 2) {
          index = this.kaarten.length - 1;
        } else {
          let kleinste = Infinity;
          this.kaarten.forEach((kaart, i) => {
            const afstand = Math.abs(this.beginVan(kaart) - links);
            if (afstand < kleinste) {
              kleinste = afstand;
              index = i;
            }
          });
        }
        if (index === this.actief) return;
        this.actief = index;
        this.stippen.forEach((stip, i) => {
          if (i === index) stip.setAttribute('aria-current', 'true');
          else stip.removeAttribute('aria-current');
        });
      }
    }
    customElements.define('lx-zakelijk-modellen-rij', LxZakelijkModellenRij);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lx-zakelijk-offerte"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.lxZakelijkOfferte) return;
    window.lxZakelijkOfferte = true;

    const rustig = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const gelijk = (a, b) => String(a || '').trim().toLowerCase() === String(b || '').trim().toLowerCase();

    /* Het formulier op deze pagina (de eerste, als de sectie twee keer op de pagina staat). */
    const formulier = () => document.querySelector('[data-lx-zakelijk-offerte]');

    const naarFormulier = (kaart, focusDoel, glad) => {
      kaart.scrollIntoView({ behavior: glad && !rustig() ? 'smooth' : 'auto', block: 'start' });
      if (focusDoel) focusDoel.focus({ preventScroll: true });
    };

    const kies = (kaart, groep, waarde) => {
      for (const keuze of kaart.querySelectorAll(`input[type="radio"][data-lx-offerte-groep="${groep}"]`)) {
        if (gelijk(keuze.value, waarde)) {
          keuze.checked = true;
          keuze.dispatchEvent(new Event('change', { bubbles: true }));
          return keuze;
        }
      }
      return null;
    };

    /* Klik op een offerteknop elders op de pagina: model of personalisatie aanvinken en naar het formulier. */
    document.addEventListener('click', (event) => {
      if (event.defaultPrevented || event.button !== 0) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const knop =
        event.target instanceof Element
          ? event.target.closest('[data-lx-offerte-model], [data-lx-offerte-personalisatie]')
          : null;
      if (!knop) return;
      const kaart = formulier();
      if (!kaart || kaart.contains(knop)) return;
      let doel = null;
      if (knop.hasAttribute('data-lx-offerte-model')) {
        doel = kies(kaart, 'model', knop.getAttribute('data-lx-offerte-model')) || doel;
      }
      if (knop.hasAttribute('data-lx-offerte-personalisatie')) {
        doel = kies(kaart, 'personalisatie', knop.getAttribute('data-lx-offerte-personalisatie')) || doel;
      }
      event.preventDefault();
      naarFormulier(kaart, doel, true);
    });

    /* Datumveld: leeg of niet (voor de kleur en de hint), en de kalender openen met één tik. */
    const vandaag = () => {
      const d = new Date();
      const tw = (n) => String(n).padStart(2, '0');
      return `${d.getFullYear()}-${tw(d.getMonth() + 1)}-${tw(d.getDate())}`;
    };
    const zetLeeg = (veld) => veld.toggleAttribute('data-leeg', !veld.value);
    const kanKiezer = typeof HTMLInputElement !== 'undefined' && 'showPicker' in HTMLInputElement.prototype;

    const bereidVoor = (wortel) => {
      for (const veld of wortel.querySelectorAll('[data-lx-zakelijk-datum]')) {
        if (!veld.min) veld.min = vandaag();
        if (kanKiezer) veld.classList.add('lx-zakelijk-offerte__datum-invoer--kiezer');
        const hint = veld.nextElementSibling;
        if (hint && hint.classList.contains('lx-zakelijk-offerte__datum-hint')) {
          veld.classList.add('lx-zakelijk-offerte__datum-invoer--hint');
        }
        zetLeeg(veld);
      }
    };

    for (const soort of ['input', 'change']) {
      document.addEventListener(soort, (event) => {
        if (event.target instanceof HTMLInputElement && event.target.hasAttribute('data-lx-zakelijk-datum')) {
          zetLeeg(event.target);
        }
      });
    }
    document.addEventListener('click', (event) => {
      const veld = event.target;
      if (!kanKiezer || !(veld instanceof HTMLInputElement) || !veld.hasAttribute('data-lx-zakelijk-datum')) return;
      try {
        veld.showPicker();
      } catch (fout) {
        /* Niet toegestaan in deze context (bijv. in een iframe): dan werkt het veld gewoon zonder. */
      }
    });

    /* Na verzenden: de bevestiging (of de foutmelding) in beeld, onder de vaste header, met de focus erop. */
    const naLaden = () => {
      bereidVoor(document);
      const melding = document.querySelector('[data-lx-zakelijk-offerte-bedankt], [data-lx-zakelijk-offerte-fouten]');
      const kaart = melding ? melding.closest('[data-lx-zakelijk-offerte]') : null;
      if (kaart) naarFormulier(kaart, melding, false);
    };

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', naLaden);
    else naLaden();

    document.addEventListener('shopify:section:load', (event) => {
      if (event.target instanceof Element) bereidVoor(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
